(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1870],{

/***/ 13425:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/portfolio/[[...address]]",
      function () {
        return __webpack_require__(78375);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 61818:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _rainbow_me_rainbowkit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87671);
/* harmony import */ var _reservoir0x_reservoir_kit_ui__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9836);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var wagmi__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69077);
/* harmony import */ var _context_ToastContextProvider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98045);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82731);







const CancelBid = (param)=>{
    let { bidId , openState , trigger , mutate  } = param;
    const { addToast  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_context_ToastContextProvider__WEBPACK_IMPORTED_MODULE_2__/* .ToastContext */ .u);
    const { openConnectModal  } = (0,_rainbow_me_rainbowkit__WEBPACK_IMPORTED_MODULE_4__/* .useConnectModal */ .We)();
    const marketplaceChain = (0,hooks__WEBPACK_IMPORTED_MODULE_3__/* .useMarketplaceChain */ .gw)();
    const { switchNetworkAsync  } = (0,wagmi__WEBPACK_IMPORTED_MODULE_5__/* .useSwitchNetwork */ .g0)({
        chainId: marketplaceChain.id
    });
    const { data: signer  } = (0,wagmi__WEBPACK_IMPORTED_MODULE_5__/* .useWalletClient */ .py)();
    const { chain: activeChain  } = (0,wagmi__WEBPACK_IMPORTED_MODULE_5__/* .useNetwork */ .LN)();
    const isInTheWrongNetwork = Boolean(signer && marketplaceChain.id !== (activeChain === null || activeChain === void 0 ? void 0 : activeChain.id));
    if (isInTheWrongNetwork) {
        return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.cloneElement)(trigger, {
            onClick: async ()=>{
                if (switchNetworkAsync && activeChain) {
                    const chain = await switchNetworkAsync(marketplaceChain.id);
                    if (chain.id !== marketplaceChain.id) {
                        return false;
                    }
                }
                if (!signer) {
                    openConnectModal === null || openConnectModal === void 0 ? void 0 : openConnectModal();
                }
            }
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_reservoir0x_reservoir_kit_ui__WEBPACK_IMPORTED_MODULE_6__/* .CancelBidModal */ .BJ, {
        bidId: bidId,
        trigger: trigger,
        openState: openState,
        onCancelComplete: (data)=>{
            addToast === null || addToast === void 0 ? void 0 : addToast({
                title: "User canceled bid",
                description: "You have canceled the bid."
            });
        },
        onCancelError: (error, data)=>{
            console.log("Bid Cancel Error", error, data);
            addToast === null || addToast === void 0 ? void 0 : addToast({
                title: "Could not cancel bid",
                description: "The transaction was not completed."
            });
        },
        onClose: (data, currentStep)=>{
            if (mutate && currentStep == _reservoir0x_reservoir_kit_ui__WEBPACK_IMPORTED_MODULE_6__/* .CancelBidStep.Complete */ .JE.Complete) mutate();
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CancelBid);


/***/ }),

/***/ 41456:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _rainbow_me_rainbowkit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87671);
/* harmony import */ var _reservoir0x_reservoir_kit_ui__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9836);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var wagmi__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69077);
/* harmony import */ var _context_ToastContextProvider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98045);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82731);







const CancelListing = (param)=>{
    let { listingId , openState , trigger , mutate  } = param;
    const { addToast  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_context_ToastContextProvider__WEBPACK_IMPORTED_MODULE_2__/* .ToastContext */ .u);
    const { openConnectModal  } = (0,_rainbow_me_rainbowkit__WEBPACK_IMPORTED_MODULE_4__/* .useConnectModal */ .We)();
    const marketplaceChain = (0,hooks__WEBPACK_IMPORTED_MODULE_3__/* .useMarketplaceChain */ .gw)();
    const { switchNetworkAsync  } = (0,wagmi__WEBPACK_IMPORTED_MODULE_5__/* .useSwitchNetwork */ .g0)({
        chainId: marketplaceChain.id
    });
    const { data: signer  } = (0,wagmi__WEBPACK_IMPORTED_MODULE_5__/* .useWalletClient */ .py)();
    const { chain: activeChain  } = (0,wagmi__WEBPACK_IMPORTED_MODULE_5__/* .useNetwork */ .LN)();
    const isInTheWrongNetwork = Boolean(signer && activeChain && activeChain.id !== marketplaceChain.id);
    if (isInTheWrongNetwork) {
        return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.cloneElement)(trigger, {
            onClick: async ()=>{
                if (switchNetworkAsync && activeChain) {
                    const chain = await switchNetworkAsync(marketplaceChain.id);
                    if (chain.id !== marketplaceChain.id) {
                        return false;
                    }
                }
                if (!signer) {
                    openConnectModal === null || openConnectModal === void 0 ? void 0 : openConnectModal();
                }
            }
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_reservoir0x_reservoir_kit_ui__WEBPACK_IMPORTED_MODULE_6__/* .CancelListingModal */ .GO, {
        listingId: listingId,
        openState: openState,
        trigger: trigger,
        onCancelComplete: (data)=>{
            addToast === null || addToast === void 0 ? void 0 : addToast({
                title: "User canceled listing",
                description: "You have canceled the listing."
            });
        },
        onCancelError: (error, data)=>{
            console.log("Listing Cancel Error", error, data);
            addToast === null || addToast === void 0 ? void 0 : addToast({
                title: "Could not cancel listing",
                description: "The transaction was not completed."
            });
        },
        onClose: (data, currentStep)=>{
            if (mutate && currentStep == _reservoir0x_reservoir_kit_ui__WEBPACK_IMPORTED_MODULE_6__/* .CancelListingStep.Complete */ .MD.Complete) mutate();
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CancelListing);


/***/ }),

/***/ 61955:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _radix_ui_react_tooltip__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(40299);
/* harmony import */ var _primitives__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50689);
/* harmony import */ var utils_chains__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79062);
/* harmony import */ var context_ChainContextProvider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43810);
/* harmony import */ var components_primitives_Tooltip__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(79320);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82731);
/* harmony import */ var next_themes__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(82010);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _radix_ui_react_dropdown_menu__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(84113);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(99603);
/* harmony import */ var _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(59417);
/* harmony import */ var components_primitives_Dropdown__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(12623);















const ChainToggle = ()=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_8__.useRouter)();
    const { chain , switchCurrentChain  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(context_ChainContextProvider__WEBPACK_IMPORTED_MODULE_4__/* .ChainContext */ .p);
    const isMounted = (0,hooks__WEBPACK_IMPORTED_MODULE_6__/* .useMounted */ .s4)();
    const { theme  } = (0,next_themes__WEBPACK_IMPORTED_MODULE_7__/* .useTheme */ .F)();
    const switchChains = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((chainOption)=>{
        if (router.query.chain) {
            Object.keys(router.query).forEach((param)=>delete router.query[param]);
            router.replace({
                pathname: router.pathname,
                query: router.query
            }, undefined, {
                shallow: true
            });
        }
        switchCurrentChain(chainOption.id);
    }, [
        router.query,
        switchCurrentChain
    ]);
    if (!isMounted || utils_chains__WEBPACK_IMPORTED_MODULE_3__/* ["default"].length */ .ZP.length === 1) {
        return null;
    }
    if (utils_chains__WEBPACK_IMPORTED_MODULE_3__/* ["default"].length */ .ZP.length > 3) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_radix_ui_react_dropdown_menu__WEBPACK_IMPORTED_MODULE_11__/* .Root */ .fC, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_dropdown_menu__WEBPACK_IMPORTED_MODULE_11__/* .Trigger */ .xz, {
                    asChild: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zx, {
                        color: "gray3",
                        css: {
                            px: "14px",
                            justifyContent: "space-between",
                            width: "auto",
                            minWidth: "max-content",
                            "@md": {
                                minWidth: "max-content",
                                px: "$4"
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: theme === "dark" ? chain.darkIconUrl : chain.lightIconUrl,
                                style: {
                                    height: 20
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                                style: "body1",
                                children: chain.name
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
                                css: {
                                    color: "$gray10",
                                    transition: "transform",
                                    "[data-state=open] &": {
                                        transform: "rotate(180deg)"
                                    }
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_9__/* .FontAwesomeIcon */ .G, {
                                    icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_12__/* .faChevronDown */ .ptq,
                                    width: 16
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives_Dropdown__WEBPACK_IMPORTED_MODULE_10__/* .DropdownMenuContent */ .AW, {
                    css: {
                        mt: "$2",
                        zIndex: 1000,
                        width: "auto",
                        minWidth: "max-content",
                        "@md": {
                            minWidth: "max-content"
                        }
                    },
                    children: utils_chains__WEBPACK_IMPORTED_MODULE_3__/* ["default"].map */ .ZP.map((supportedChain)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives_Dropdown__WEBPACK_IMPORTED_MODULE_10__/* .DropdownMenuItem */ .Xi, {
                            css: {
                                py: "$3",
                                px: "$1",
                                display: "flex",
                                gap: "$2"
                            },
                            onClick: ()=>{
                                const newUrl = router.asPath.replace(chain.routePrefix, supportedChain.routePrefix);
                                switchCurrentChain(supportedChain.id);
                                router.replace(newUrl, undefined, {
                                    scroll: false
                                });
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
                                    css: {
                                        width: 30
                                    },
                                    justify: "center",
                                    align: "center",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: theme === "dark" ? supportedChain.darkIconUrl : supportedChain.lightIconUrl,
                                        style: {
                                            height: 20
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                                    style: "body1",
                                    children: supportedChain.name
                                })
                            ]
                        }, supportedChain.id))
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .ToggleGroup */ .tX, {
        type: "single",
        value: chain.name,
        children: utils_chains__WEBPACK_IMPORTED_MODULE_3__/* ["default"].map */ .ZP.map((chainOption)=>{
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_radix_ui_react_tooltip__WEBPACK_IMPORTED_MODULE_13__/* .Root */ .fC, {
                delayDuration: 0,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_tooltip__WEBPACK_IMPORTED_MODULE_13__/* .Trigger */ .xz, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .ToggleGroupItem */ .GX, {
                            asChild: true,
                            value: chainOption.name,
                            disabled: chainOption.name === chain.name,
                            onClick: ()=>{
                                const newUrl = router.asPath.replace(chain.routePrefix, chainOption.routePrefix);
                                switchCurrentChain(chainOption.id);
                                router.replace(newUrl, undefined, {
                                    scroll: false
                                });
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
                                css: {
                                    width: 56,
                                    display: "flex",
                                    justifyContent: "center"
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: theme === "dark" ? chainOption.darkIconUrl : chainOption.lightIconUrl,
                                    style: {
                                        height: 20
                                    }
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_radix_ui_react_tooltip__WEBPACK_IMPORTED_MODULE_13__/* .Content */ .VY, {
                        sideOffset: -4,
                        side: "top",
                        align: "center",
                        style: {
                            zIndex: 100,
                            filter: "drop-shadow(0px 3px 8px rgba(0, 0, 0, 0.3))"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives_Tooltip__WEBPACK_IMPORTED_MODULE_5__/* .TooltipArrow */ .C, {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
                                css: {
                                    zIndex: 9999,
                                    $$shadowColor: "$colors$panelShadow",
                                    boxShadow: "0px 1px 5px rgba(0,0,0,0.2)",
                                    borderRadius: 8,
                                    overflow: "hidden"
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
                                    css: {
                                        background: "$neutralBgSubtle",
                                        p: "$2"
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                                        style: "body3",
                                        as: "p",
                                        children: chainOption === null || chainOption === void 0 ? void 0 : chainOption.name
                                    })
                                })
                            })
                        ]
                    })
                ]
            }, chainOption.name);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ChainToggle);


/***/ }),

/***/ 31561:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q": function() { return /* binding */ PercentChange; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./utils/round.ts
const round = function(num) {
    let percision = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 4;
    return Math.floor(num * Math.pow(10, percision)) / Math.pow(10, percision);
};
/* harmony default export */ var utils_round = (round);

// EXTERNAL MODULE: ./components/primitives/index.ts + 14 modules
var primitives = __webpack_require__(50689);
;// CONCATENATED MODULE: ./components/primitives/PercentChange.tsx



const PercentChange = (param)=>{
    let { value , decimals =2 , ...props } = param;
    if (value === undefined || value === null || value === 0) return null;
    const percentage = (value - 1) * 100;
    const isPositive = percentage > 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Text */.xv, {
        style: props.style || "subtitle3",
        css: {
            color: isPositive ? "$green11" : "$red11",
            ml: "$1"
        },
        ...props,
        children: [
            utils_round(percentage, decimals),
            "%"
        ]
    });
};


/***/ }),

/***/ 78375:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _address_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/primitives/index.ts + 14 modules
var primitives = __webpack_require__(50689);
// EXTERNAL MODULE: ./components/Layout.tsx
var Layout = __webpack_require__(51943);
// EXTERNAL MODULE: ./node_modules/react-responsive/dist/react-responsive.js
var react_responsive = __webpack_require__(1852);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/wagmi/dist/index.js + 25 modules
var dist = __webpack_require__(69077);
// EXTERNAL MODULE: ./components/primitives/Tab.tsx
var Tab = __webpack_require__(53370);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-tabs/dist/index.module.js
var index_module = __webpack_require__(36888);
// EXTERNAL MODULE: ./node_modules/@reservoir0x/reservoir-kit-ui/dist/index.module.js + 197 modules
var dist_index_module = __webpack_require__(9836);
// EXTERNAL MODULE: ./hooks/index.ts + 7 modules
var hooks = __webpack_require__(82731);
// EXTERNAL MODULE: ./components/buttons/index.ts + 3 modules
var buttons = __webpack_require__(52158);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/usehooks-ts/dist/esm/index.js + 36 modules
var esm = __webpack_require__(5678);
// EXTERNAL MODULE: ./components/common/LoadingSpinner.tsx
var LoadingSpinner = __webpack_require__(74431);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js + 1 modules
var index_es = __webpack_require__(99603);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/index.mjs
var free_solid_svg_icons = __webpack_require__(59417);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/navbar/index.tsx + 9 modules
var navbar = __webpack_require__(42927);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-dialog/dist/index.module.js
var react_dialog_dist_index_module = __webpack_require__(51528);
// EXTERNAL MODULE: ./components/primitives/Dialog.tsx
var Dialog = __webpack_require__(39114);
// EXTERNAL MODULE: ./context/ToastContextProvider.tsx + 4 modules
var ToastContextProvider = __webpack_require__(98045);
;// CONCATENATED MODULE: ./components/buttons/Transfer.tsx










const ERC721NFTAbi = [
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "from",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "to",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "id",
                "type": "uint256"
            }
        ],
        "name": "safeTransferFrom",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    }
];
const ERC1155NFTAbi = [
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "from",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "to",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "id",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "amount",
                "type": "uint256"
            },
            {
                "internalType": "bytes",
                "name": "data",
                "type": "bytes"
            }
        ],
        "name": "safeTransferFrom",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    }
];
const Transfer = (param)=>{
    let { token , mutate  } = param;
    var _token_token, _token_token1, _token_token2, _token_token3, _token_token4, _token_token5, _token_token6, _token_token7, _token_token_collection, _token_token8, _token_token9;
    const { addToast  } = (0,react.useContext)(ToastContextProvider/* ToastContext */.u);
    const { address  } = (0,dist/* useAccount */.mA)();
    const [transferAddress, setTransferAddress] = (0,react.useState)("");
    const [quantity, setQuantity] = (0,react.useState)(1);
    const mediaType = (0,dist_index_module/* extractMediaType */.uh)(token === null || token === void 0 ? void 0 : token.token);
    const showPreview = mediaType === "other" || mediaType === "html" || mediaType === null;
    const { writeAsync , data , isLoading , error: error  } = (0,dist/* useContractWrite */.GG)({
        address: (token === null || token === void 0 ? void 0 : (_token_token = token.token) === null || _token_token === void 0 ? void 0 : _token_token.contract) || "0x0",
        abi: (token === null || token === void 0 ? void 0 : (_token_token1 = token.token) === null || _token_token1 === void 0 ? void 0 : _token_token1.kind) === "erc721" ? ERC721NFTAbi : ERC1155NFTAbi,
        functionName: "safeTransferFrom",
        args: (token === null || token === void 0 ? void 0 : (_token_token2 = token.token) === null || _token_token2 === void 0 ? void 0 : _token_token2.kind) === "erc721" ? [
            address,
            transferAddress,
            token === null || token === void 0 ? void 0 : (_token_token3 = token.token) === null || _token_token3 === void 0 ? void 0 : _token_token3.tokenId
        ] : [
            address,
            transferAddress,
            token === null || token === void 0 ? void 0 : (_token_token4 = token.token) === null || _token_token4 === void 0 ? void 0 : _token_token4.tokenId,
            quantity,
            ""
        ]
    });
    const { isLoading: isLoadingTransaction , isSuccess =true  } = (0,dist/* useWaitForTransaction */.BX)({
        hash: data === null || data === void 0 ? void 0 : data.hash
    });
    const handleSetQuantity = (e)=>{
        let qty = parseInt(e.target.value, 10);
        setQuantity(qty < 1 ? 1 : qty);
    };
    const handleTransfer = async ()=>{
        writeAsync === null || writeAsync === void 0 ? void 0 : writeAsync().then(()=>{
            mutate === null || mutate === void 0 ? void 0 : mutate();
        }).catch(()=>{
        // Empty
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_dialog_dist_index_module/* Root */.fC, {
        modal: false,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_dialog_dist_index_module/* DialogTrigger */.hg, {
                asChild: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                    css: {
                        justifyContent: "center",
                        width: "44px",
                        height: "44px"
                    },
                    type: "button",
                    size: "small",
                    color: "gray3",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                        icon: free_solid_svg_icons/* faPaperPlane */.XCy,
                        width: 16,
                        height: 16
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_dialog_dist_index_module/* DialogPortal */.PK, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* Content */.VY, {
                    onInteractOutside: (e)=>{
                        e.preventDefault();
                    },
                    css: {
                        top: "20%",
                        padding: 20,
                        zIndex: 9999,
                        maxWidth: 500,
                        minWidth: 350
                    },
                    children: isSuccess ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        align: "center",
                        justify: "center",
                        direction: "column",
                        css: {
                            textAlign: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                icon: free_solid_svg_icons/* faCheckCircle */.f8k,
                                size: "2xl",
                                color: "#b8ff33",
                                style: {
                                    marginBottom: 20
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                css: {
                                    wordBreak: "break-word",
                                    mb: "$5"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                    style: "h6",
                                    children: "Your NFT has successfully transferred to ".concat(transferAddress)
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_dialog_dist_index_module/* Close */.x8, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                                    color: "secondary",
                                    children: "OK"
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_dialog_dist_index_module/* Close */.x8, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                                    css: {
                                        position: "fixed",
                                        top: 10,
                                        right: 10,
                                        justifyContent: "center",
                                        width: "44px",
                                        height: "44px",
                                        alignItems: "center",
                                        borderRadius: "$lg",
                                        backgroundColor: "$gray3",
                                        color: "$gray12",
                                        "&:hover": {
                                            backgroundColor: "$gray4"
                                        }
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: free_solid_svg_icons/* faXmark */.g82,
                                        width: 16,
                                        height: 16
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                align: "center",
                                direction: "column",
                                css: {
                                    overflow: "hidden"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                        css: {
                                            mb: "$4"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                            style: "h4",
                                            children: "Transfer your NFT"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_module/* TokenMedia */.Y1, {
                                        token: token === null || token === void 0 ? void 0 : token.token,
                                        style: {
                                            width: 150,
                                            height: 150,
                                            transition: "transform .3s ease-in-out",
                                            maxHeight: 720,
                                            borderRadius: "$base",
                                            aspectRatio: "1/1",
                                            marginBottom: 20,
                                            border: "2px solid #5D770D"
                                        },
                                        onRefreshToken: ()=>{
                                            mutate === null || mutate === void 0 ? void 0 : mutate();
                                            addToast === null || addToast === void 0 ? void 0 : addToast({
                                                title: "Refresh token",
                                                description: "Request to refresh this token was accepted."
                                            });
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Box */.xu, {
                                        css: {
                                            mb: 20
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Box */.xu, {
                                                css: {
                                                    textAlign: "center"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                        children: (token === null || token === void 0 ? void 0 : (_token_token5 = token.token) === null || _token_token5 === void 0 ? void 0 : _token_token5.kind) === "erc1155" ? "".concat(quantity, "x ") : ""
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                        children: '"'.concat((token === null || token === void 0 ? void 0 : (_token_token6 = token.token) === null || _token_token6 === void 0 ? void 0 : _token_token6.name) ? token.token.name : "".concat(token === null || token === void 0 ? void 0 : (_token_token7 = token.token) === null || _token_token7 === void 0 ? void 0 : (_token_token_collection = _token_token7.collection) === null || _token_token_collection === void 0 ? void 0 : _token_token_collection.name, " #").concat(token === null || token === void 0 ? void 0 : (_token_token8 = token.token) === null || _token_token8 === void 0 ? void 0 : _token_token8.tokenId), '"')
                                                    }),
                                                    " will be transferred to ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                        children: "".concat(transferAddress == "" ? "..." : transferAddress)
                                                    })
                                                ]
                                            }),
                                            transferAddress !== "" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Box */.xu, {
                                                css: {
                                                    color: "orange",
                                                    mt: "$4",
                                                    textAlign: "center"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                        icon: free_solid_svg_icons/* faWarning */.e7M,
                                                        style: {
                                                            marginRight: 5
                                                        }
                                                    }),
                                                    "Items sent to the wrong address cannot be recovered"
                                                ]
                                            }),
                                            error && transferAddress !== "" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Box */.xu, {
                                                css: {
                                                    color: "red",
                                                    mt: "$4",
                                                    textAlign: "center"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                        icon: free_solid_svg_icons/* faClose */.YIN,
                                                        style: {
                                                            marginRight: 5
                                                        }
                                                    }),
                                                    error.message
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                        justify: "between",
                                        css: {
                                            mb: 20,
                                            px: 10,
                                            width: "100%"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Input */.II, {
                                                disabled: isLoading || isLoadingTransaction,
                                                value: transferAddress,
                                                onChange: (e)=>setTransferAddress(e.target.value),
                                                placeholder: "e.g. 0x21ab235523cdd...",
                                                containerCss: {
                                                    width: "100%"
                                                }
                                            }),
                                            (token === null || token === void 0 ? void 0 : (_token_token9 = token.token) === null || _token_token9 === void 0 ? void 0 : _token_token9.kind) === "erc1155" && /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Input */.II, {
                                                disabled: isLoading || isLoadingTransaction,
                                                value: quantity,
                                                onChange: handleSetQuantity,
                                                placeholder: "Qty",
                                                type: "number",
                                                containerCss: {
                                                    width: 100,
                                                    ml: "$2"
                                                }
                                            })
                                        ]
                                    }),
                                    isLoadingTransaction ? /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                        as: "h4",
                                        children: "Transferring..."
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                                        disabled: isLoading || isLoadingTransaction || !!error,
                                        onClick: handleTransfer,
                                        children: isLoading ? "Confirm" : "Transfer"
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var buttons_Transfer = (Transfer);

// EXTERNAL MODULE: ./components/primitives/Checkbox.tsx + 3 modules
var Checkbox = __webpack_require__(92522);
// EXTERNAL MODULE: ./context/ChainContextProvider.tsx
var ChainContextProvider = __webpack_require__(43810);
// EXTERNAL MODULE: ./components/primitives/Dropdown.tsx
var Dropdown = __webpack_require__(12623);
// EXTERNAL MODULE: ./components/buttons/CancelListing.tsx
var CancelListing = __webpack_require__(41456);
// EXTERNAL MODULE: ./utils/fetcher.ts
var fetcher = __webpack_require__(84205);
// EXTERNAL MODULE: ./utils/till.ts
var till = __webpack_require__(94830);
// EXTERNAL MODULE: ./utils/numbers.ts + 1 modules
var numbers = __webpack_require__(23701);
// EXTERNAL MODULE: ./components/common/OpenSeaVerified.tsx
var OpenSeaVerified = __webpack_require__(44930);
// EXTERNAL MODULE: ./components/buttons/BuyNow.tsx
var BuyNow = __webpack_require__(66918);
// EXTERNAL MODULE: ./components/buttons/List.tsx
var List = __webpack_require__(85534);
// EXTERNAL MODULE: ./utils/optimizeImage.ts
var optimizeImage = __webpack_require__(77497);
;// CONCATENATED MODULE: ./components/portfolio/PortfolioTokenCard.tsx





















/* harmony default export */ var PortfolioTokenCard = ((param)=>{
    let { token , address , isOwner , rarityEnabled =true , orderQuantity , tokenCount , selectedItems , setSelectedItems , mutate , onMediaPlayed  } = param;
    var _token_token, _token_token_collection, _token_ownership, _token_ownership_floorAsk, _token_ownership_floorAsk_rawData, _token_token1, _token_token_collection1, _token_token_collection_id, _token_token2, _token_token3, _token_token4, _token_token5, _token_token6, _token_token7, _token_token8, _token_token9, _token_token10, _token_token11, _token_token12, _token_ownership1, _token_ownership_floorAsk1, _token_ownership2, _token_ownership_floorAsk2, _token_ownership_floorAsk_price, _token_ownership_floorAsk_price_amount, _token_ownership3, _token_ownership_floorAsk3, _token_ownership_floorAsk_price1, _token_ownership_floorAsk_price_currency, _token_ownership4, _token_ownership_floorAsk4, _token_ownership_floorAsk_source, _token_ownership5, _token_ownership_floorAsk5, _token_ownership_floorAsk_source1, _token_token13, _token_token_lastSale, _token_token_lastSale_price, _token_token_lastSale_price_amount, _token_token_lastSale_price_amount1, _token_token_lastSale_price_currency, _token_token_lastSale_price_currency1, _token_ownership6, _token_ownership_floorAsk6, _token_ownership_floorAsk_price2, _token_token14, _token_token15, _token_token_collection2, _token_token16, _token_token_topBid, _token_token_topBid_price, _token_token_topBid_price_amount, _token_token17, _token_ownership7, _token_ownership_floorAsk7, _token_token18, _token_token19, _token_token_collection3, _token_ownership8, _token_ownership_floorAsk8, _token_token20, _token_token21, _token_token_collection4, _token_ownership9, _token_ownership_floorAsk9;
    const { addToast  } = (0,react.useContext)(ToastContextProvider/* ToastContext */.u);
    const [isRefreshing, setIsRefreshing] = (0,react.useState)(false);
    let dynamicToken = token;
    const isSmallDevice = (0,react_responsive.useMediaQuery)({
        maxWidth: 900
    });
    const mediaType = (0,dist_index_module/* extractMediaType */.uh)(dynamicToken === null || dynamicToken === void 0 ? void 0 : dynamicToken.token);
    const showPreview = mediaType === "other" || mediaType === "html" || mediaType === null;
    const { routePrefix , proxyApi  } = (0,hooks/* useMarketplaceChain */.gw)();
    const collectionImage = (0,react.useMemo)(()=>{
        var _token_token, _token_token_collection;
        return (0,optimizeImage/* default */.Z)(token === null || token === void 0 ? void 0 : (_token_token = token.token) === null || _token_token === void 0 ? void 0 : (_token_token_collection = _token_token.collection) === null || _token_token_collection === void 0 ? void 0 : _token_token_collection.imageUrl, 500);
    }, [
        token === null || token === void 0 ? void 0 : (_token_token = token.token) === null || _token_token === void 0 ? void 0 : (_token_token_collection = _token_token.collection) === null || _token_token_collection === void 0 ? void 0 : _token_token_collection.imageUrl
    ]);
    const isOracleOrder = token === null || token === void 0 ? void 0 : (_token_ownership = token.ownership) === null || _token_ownership === void 0 ? void 0 : (_token_ownership_floorAsk = _token_ownership.floorAsk) === null || _token_ownership_floorAsk === void 0 ? void 0 : (_token_ownership_floorAsk_rawData = _token_ownership_floorAsk.rawData) === null || _token_ownership_floorAsk_rawData === void 0 ? void 0 : _token_ownership_floorAsk_rawData.isNativeOffChainCancellable;
    const contract = ((_token_token1 = token.token) === null || _token_token1 === void 0 ? void 0 : (_token_token_collection1 = _token_token1.collection) === null || _token_token_collection1 === void 0 ? void 0 : _token_token_collection1.id) ? (_token_token_collection_id = (_token_token2 = token.token) === null || _token_token2 === void 0 ? void 0 : _token_token2.collection.id) === null || _token_token_collection_id === void 0 ? void 0 : _token_token_collection_id.split(":")[0] : undefined;
    const addSelectedItem = (item)=>{
        setSelectedItems([
            ...selectedItems,
            item
        ]);
    };
    const removeSelectedItem = (item)=>{
        setSelectedItems(selectedItems.filter((selectedItem)=>{
            var _selectedItem_token, _item_token, _selectedItem_token1, _item_token1;
            return (selectedItem === null || selectedItem === void 0 ? void 0 : (_selectedItem_token = selectedItem.token) === null || _selectedItem_token === void 0 ? void 0 : _selectedItem_token.tokenId) !== (item === null || item === void 0 ? void 0 : (_item_token = item.token) === null || _item_token === void 0 ? void 0 : _item_token.tokenId) || (selectedItem === null || selectedItem === void 0 ? void 0 : (_selectedItem_token1 = selectedItem.token) === null || _selectedItem_token1 === void 0 ? void 0 : _selectedItem_token1.contract) !== (item === null || item === void 0 ? void 0 : (_item_token1 = item.token) === null || _item_token1 === void 0 ? void 0 : _item_token1.contract);
        }));
    };
    const isSelectedItem = (0,react.useMemo)(()=>{
        return selectedItems.some((selectedItem)=>{
            var _selectedItem_token, _token_token, _selectedItem_token1, _token_token1;
            return (selectedItem === null || selectedItem === void 0 ? void 0 : (_selectedItem_token = selectedItem.token) === null || _selectedItem_token === void 0 ? void 0 : _selectedItem_token.tokenId) === (token === null || token === void 0 ? void 0 : (_token_token = token.token) === null || _token_token === void 0 ? void 0 : _token_token.tokenId) && (selectedItem === null || selectedItem === void 0 ? void 0 : (_selectedItem_token1 = selectedItem.token) === null || _selectedItem_token1 === void 0 ? void 0 : _selectedItem_token1.contract) === (token === null || token === void 0 ? void 0 : (_token_token1 = token.token) === null || _token_token1 === void 0 ? void 0 : _token_token1.contract);
        });
    }, [
        selectedItems
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Box */.xu, {
        css: {
            borderRadius: 8,
            overflow: "hidden",
            background: "$neutralBgSubtle",
            $$shadowColor: "$colors$panelShadow",
            boxShadow: "0 8px 12px 0px $$shadowColor",
            position: "relative",
            "&:hover > a > div > img": {
                transform: "scale(1.1)"
            },
            "@sm": {
                "&:hover .token-button-container": {
                    bottom: 0
                }
            }
        },
        children: [
            tokenCount && /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                justify: "center",
                align: "center",
                css: {
                    borderRadius: 8,
                    px: "$2",
                    py: "$1",
                    mr: "$2",
                    position: "absolute",
                    left: "$2",
                    top: "$2",
                    zIndex: 1,
                    maxWidth: "50%",
                    backgroundColor: "rgba(	38, 41, 43, 0.3)"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Text */.xv, {
                    css: {
                        color: "$whiteA12"
                    },
                    ellipsify: true,
                    children: [
                        "x",
                        (0,numbers/* formatNumber */.uf)(tokenCount, 0, true)
                    ]
                })
            }),
            isOwner && !isSmallDevice ? /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                css: {
                    borderRadius: "99999px",
                    width: 48,
                    height: 48,
                    backgroundColor: isSelectedItem ? "$primary9" : "#15171833",
                    "&:hover": {
                        backgroundColor: isSelectedItem ? "$primary9" : "#15171859"
                    },
                    opacity: isSelectedItem ? 1 : 1,
                    position: "absolute",
                    right: "$2",
                    zIndex: 1,
                    top: "$2",
                    color: "white",
                    p: 0,
                    justifyContent: "center"
                },
                onClick: (e)=>{
                    e.preventDefault();
                    if (!isSelectedItem) {
                        addSelectedItem(token);
                    } else {
                        removeSelectedItem(token);
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                    icon: isSelectedItem ? free_solid_svg_icons/* faCheck */.LEp : free_solid_svg_icons/* faPlus */.r8p,
                    width: 20,
                    height: 20
                })
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                passHref: true,
                href: "/".concat(routePrefix, "/asset/").concat(token === null || token === void 0 ? void 0 : (_token_token3 = token.token) === null || _token_token3 === void 0 ? void 0 : _token_token3.contract, ":").concat(token === null || token === void 0 ? void 0 : (_token_token4 = token.token) === null || _token_token4 === void 0 ? void 0 : _token_token4.tokenId),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                    css: {
                        background: "$gray3",
                        overflow: "hidden"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_module/* TokenMedia */.Y1, {
                        token: dynamicToken === null || dynamicToken === void 0 ? void 0 : dynamicToken.token,
                        style: {
                            width: "100%",
                            transition: "transform .3s ease-in-out",
                            maxHeight: 720,
                            height: "100%",
                            borderRadius: 0,
                            aspectRatio: "1/1"
                        },
                        staticOnly: showPreview,
                        audioOptions: {
                            onPlay: (e)=>{
                                onMediaPlayed === null || onMediaPlayed === void 0 ? void 0 : onMediaPlayed(e);
                            }
                        },
                        videoOptions: {
                            onPlay: (e)=>{
                                onMediaPlayed === null || onMediaPlayed === void 0 ? void 0 : onMediaPlayed(e);
                            }
                        },
                        onRefreshToken: ()=>{
                            mutate === null || mutate === void 0 ? void 0 : mutate();
                            addToast === null || addToast === void 0 ? void 0 : addToast({
                                title: "Refresh token",
                                description: "Request to refresh this token was accepted."
                            });
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/".concat(routePrefix, "/asset/").concat(token === null || token === void 0 ? void 0 : (_token_token5 = token.token) === null || _token_token5 === void 0 ? void 0 : _token_token5.contract, ":").concat(token === null || token === void 0 ? void 0 : (_token_token6 = token.token) === null || _token_token6 === void 0 ? void 0 : _token_token6.tokenId),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                    css: {
                        p: "$4",
                        minHeight: 132,
                        cursor: "pointer"
                    },
                    direction: "column",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                            css: {
                                mb: "$4"
                            },
                            align: "center",
                            justify: "between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                    align: "center",
                                    css: {
                                        gap: "$2",
                                        minWidth: 0
                                    },
                                    children: [
                                        collectionImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            style: {
                                                borderRadius: "4px",
                                                objectFit: "cover",
                                                aspectRatio: "1/1"
                                            },
                                            loader: (param)=>{
                                                let { src  } = param;
                                                return src;
                                            },
                                            src: collectionImage,
                                            alt: "".concat(token === null || token === void 0 ? void 0 : (_token_token7 = token.token) === null || _token_token7 === void 0 ? void 0 : _token_token7.name),
                                            width: 24,
                                            height: 24
                                        }) : null,
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Text */.xv, {
                                            style: "subtitle1",
                                            as: "p",
                                            ellipsify: true,
                                            css: {
                                                pr: "$1",
                                                flex: 1
                                            },
                                            children: [
                                                (token === null || token === void 0 ? void 0 : (_token_token8 = token.token) === null || _token_token8 === void 0 ? void 0 : _token_token8.name) || "#" + (token === null || token === void 0 ? void 0 : (_token_token9 = token.token) === null || _token_token9 === void 0 ? void 0 : _token_token9.tokenId),
                                                " "
                                            ]
                                        })
                                    ]
                                }),
                                rarityEnabled && (token === null || token === void 0 ? void 0 : (_token_token10 = token.token) === null || _token_token10 === void 0 ? void 0 : _token_token10.kind) !== "erc1155" && (token === null || token === void 0 ? void 0 : (_token_token11 = token.token) === null || _token_token11 === void 0 ? void 0 : _token_token11.rarityRank) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                    css: {
                                        px: "$1",
                                        py: 2,
                                        background: "$gray5",
                                        borderRadius: 8,
                                        minWidth: "max-content"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                        align: "center",
                                        css: {
                                            gap: 5
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                style: {
                                                    width: 13,
                                                    height: 13
                                                },
                                                src: "/icons/rarity-icon.svg"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                style: "subtitle3",
                                                as: "p",
                                                children: (0,numbers/* formatNumber */.uf)(token === null || token === void 0 ? void 0 : (_token_token12 = token.token) === null || _token_token12 === void 0 ? void 0 : _token_token12.rarityRank)
                                            })
                                        ]
                                    })
                                }) : null
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                            align: "center",
                            css: {
                                gap: "$2"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                    css: {
                                        flex: 1,
                                        minWidth: 0,
                                        width: "100%",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis"
                                    },
                                    children: (token === null || token === void 0 ? void 0 : (_token_ownership1 = token.ownership) === null || _token_ownership1 === void 0 ? void 0 : (_token_ownership_floorAsk1 = _token_ownership1.floorAsk) === null || _token_ownership_floorAsk1 === void 0 ? void 0 : _token_ownership_floorAsk1.price) && /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                                        logoHeight: 18,
                                        amount: token === null || token === void 0 ? void 0 : (_token_ownership2 = token.ownership) === null || _token_ownership2 === void 0 ? void 0 : (_token_ownership_floorAsk2 = _token_ownership2.floorAsk) === null || _token_ownership_floorAsk2 === void 0 ? void 0 : (_token_ownership_floorAsk_price = _token_ownership_floorAsk2.price) === null || _token_ownership_floorAsk_price === void 0 ? void 0 : (_token_ownership_floorAsk_price_amount = _token_ownership_floorAsk_price.amount) === null || _token_ownership_floorAsk_price_amount === void 0 ? void 0 : _token_ownership_floorAsk_price_amount.decimal,
                                        address: token === null || token === void 0 ? void 0 : (_token_ownership3 = token.ownership) === null || _token_ownership3 === void 0 ? void 0 : (_token_ownership_floorAsk3 = _token_ownership3.floorAsk) === null || _token_ownership_floorAsk3 === void 0 ? void 0 : (_token_ownership_floorAsk_price1 = _token_ownership_floorAsk3.price) === null || _token_ownership_floorAsk_price1 === void 0 ? void 0 : (_token_ownership_floorAsk_price_currency = _token_ownership_floorAsk_price1.currency) === null || _token_ownership_floorAsk_price_currency === void 0 ? void 0 : _token_ownership_floorAsk_price_currency.contract,
                                        textStyle: "h6",
                                        css: {
                                            textOverflow: "ellipsis",
                                            minWidth: 0,
                                            with: "100%",
                                            overflow: "hidden"
                                        },
                                        maximumFractionDigits: 4
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: (token === null || token === void 0 ? void 0 : (_token_ownership4 = token.ownership) === null || _token_ownership4 === void 0 ? void 0 : (_token_ownership_floorAsk4 = _token_ownership4.floorAsk) === null || _token_ownership_floorAsk4 === void 0 ? void 0 : (_token_ownership_floorAsk_source = _token_ownership_floorAsk4.source) === null || _token_ownership_floorAsk_source === void 0 ? void 0 : _token_ownership_floorAsk_source.name) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        style: {
                                            width: 20,
                                            height: 20,
                                            borderRadius: "50%"
                                        },
                                        src: "".concat(proxyApi, "/redirect/sources/").concat(token === null || token === void 0 ? void 0 : (_token_ownership5 = token.ownership) === null || _token_ownership5 === void 0 ? void 0 : (_token_ownership_floorAsk5 = _token_ownership5.floorAsk) === null || _token_ownership_floorAsk5 === void 0 ? void 0 : (_token_ownership_floorAsk_source1 = _token_ownership_floorAsk5.source) === null || _token_ownership_floorAsk_source1 === void 0 ? void 0 : _token_ownership_floorAsk_source1.domain, "/logo/v2")
                                    })
                                })
                            ]
                        }),
                        (token === null || token === void 0 ? void 0 : (_token_token13 = token.token) === null || _token_token13 === void 0 ? void 0 : (_token_token_lastSale = _token_token13.lastSale) === null || _token_token_lastSale === void 0 ? void 0 : (_token_token_lastSale_price = _token_token_lastSale.price) === null || _token_token_lastSale_price === void 0 ? void 0 : (_token_token_lastSale_price_amount = _token_token_lastSale_price.amount) === null || _token_token_lastSale_price_amount === void 0 ? void 0 : _token_token_lastSale_price_amount.decimal) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                            css: {
                                gap: "$2",
                                marginTop: "auto"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                    css: {
                                        color: "$gray11"
                                    },
                                    style: "subtitle3",
                                    children: "Last Sale"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                                    logoHeight: 12,
                                    amount: (_token_token_lastSale_price_amount1 = token.token.lastSale.price.amount) === null || _token_token_lastSale_price_amount1 === void 0 ? void 0 : _token_token_lastSale_price_amount1.decimal,
                                    address: (_token_token_lastSale_price_currency = token.token.lastSale.price.currency) === null || _token_token_lastSale_price_currency === void 0 ? void 0 : _token_token_lastSale_price_currency.contract,
                                    decimals: (_token_token_lastSale_price_currency1 = token.token.lastSale.price.currency) === null || _token_token_lastSale_price_currency1 === void 0 ? void 0 : _token_token_lastSale_price_currency1.decimals,
                                    textStyle: "subtitle3",
                                    maximumFractionDigits: 4
                                })
                            ]
                        }) : null
                    ]
                })
            }),
            !isOwner && (token === null || token === void 0 ? void 0 : (_token_ownership6 = token.ownership) === null || _token_ownership6 === void 0 ? void 0 : (_token_ownership_floorAsk6 = _token_ownership6.floorAsk) === null || _token_ownership_floorAsk6 === void 0 ? void 0 : (_token_ownership_floorAsk_price2 = _token_ownership_floorAsk6.price) === null || _token_ownership_floorAsk_price2 === void 0 ? void 0 : _token_ownership_floorAsk_price2.amount) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                className: "token-button-container",
                css: {
                    width: "100%",
                    transition: "bottom 0.25s ease-in-out",
                    position: "absolute",
                    bottom: -44,
                    left: 0,
                    right: 0,
                    gap: 1
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BuyNow/* default */.Z, {
                    tokenId: (_token_token14 = token.token) === null || _token_token14 === void 0 ? void 0 : _token_token14.tokenId,
                    collectionId: (_token_token15 = token.token) === null || _token_token15 === void 0 ? void 0 : (_token_token_collection2 = _token_token15.collection) === null || _token_token_collection2 === void 0 ? void 0 : _token_token_collection2.id,
                    mutate: mutate,
                    buttonCss: {
                        justifyContent: "center",
                        flex: 1
                    },
                    buttonProps: {
                        corners: "square"
                    },
                    buttonChildren: "Buy Now"
                })
            }) : null,
            isOwner ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                className: "token-button-container",
                css: {
                    width: "100%",
                    transition: "bottom 0.25s ease-in-out",
                    position: "absolute",
                    bottom: -44,
                    left: 0,
                    right: 0,
                    gap: 1
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
                        token: token,
                        buttonCss: {
                            justifyContent: "center",
                            flex: 1
                        },
                        buttonProps: {
                            corners: "square"
                        },
                        buttonChildren: "List",
                        mutate: mutate
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dropdown/* Dropdown */.Lt, {
                        modal: false,
                        trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                            corners: "square",
                            size: "xs",
                            css: {
                                width: 44,
                                justifyContent: "center"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                icon: free_solid_svg_icons/* faEllipsis */.S6C
                            })
                        }),
                        contentProps: {
                            asChild: true,
                            forceMount: true,
                            align: "start",
                            alignOffset: -18
                        },
                        children: [
                            (token === null || token === void 0 ? void 0 : (_token_token16 = token.token) === null || _token_token16 === void 0 ? void 0 : (_token_token_topBid = _token_token16.topBid) === null || _token_token_topBid === void 0 ? void 0 : (_token_token_topBid_price = _token_token_topBid.price) === null || _token_token_topBid_price === void 0 ? void 0 : (_token_token_topBid_price_amount = _token_token_topBid_price.amount) === null || _token_token_topBid_price_amount === void 0 ? void 0 : _token_token_topBid_price_amount.decimal) && isOwner && /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons/* AcceptBid */.ZS, {
                                tokenId: token.token.tokenId,
                                collectionId: token === null || token === void 0 ? void 0 : (_token_token17 = token.token) === null || _token_token17 === void 0 ? void 0 : _token_token17.contract,
                                mutate: mutate,
                                buttonCss: {
                                    gap: "$2",
                                    px: "$2",
                                    py: "$3",
                                    borderRadius: 8,
                                    outline: "none",
                                    cursor: "pointer",
                                    "&:hover": {
                                        backgroundColor: "$gray5"
                                    },
                                    "&:focus": {
                                        backgroundColor: "$gray5"
                                    }
                                },
                                buttonChildren: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                            css: {
                                                color: "$gray10"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                icon: free_solid_svg_icons/* faHand */.ioV
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                            children: "Accept Best Offer"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* DropdownMenuItem */.Xi, {
                                css: {
                                    py: "$3",
                                    width: "100%"
                                },
                                onClick: (e)=>{
                                    var _token_token;
                                    if (isRefreshing) {
                                        e.preventDefault();
                                        return;
                                    }
                                    setIsRefreshing(true);
                                    (0,fetcher/* default */.ZP)("".concat(window.location.origin, "/").concat(proxyApi, "/tokens/refresh/v1"), undefined, {
                                        method: "POST",
                                        headers: {
                                            "Content-Type": "application/json"
                                        },
                                        body: JSON.stringify({
                                            token: "".concat(contract, ":").concat((_token_token = token.token) === null || _token_token === void 0 ? void 0 : _token_token.tokenId)
                                        })
                                    }).then((param)=>{
                                        let { data , response  } = param;
                                        if (response.status === 200) {
                                            addToast === null || addToast === void 0 ? void 0 : addToast({
                                                title: "Refresh token",
                                                description: "Request to refresh this token was accepted."
                                            });
                                        } else {
                                            throw data;
                                        }
                                        setIsRefreshing(false);
                                    }).catch((e)=>{
                                        var _DATE_REGEX_exec;
                                        const ratelimit = (_DATE_REGEX_exec = till/* DATE_REGEX.exec */.n.exec(e === null || e === void 0 ? void 0 : e.message)) === null || _DATE_REGEX_exec === void 0 ? void 0 : _DATE_REGEX_exec[0];
                                        addToast === null || addToast === void 0 ? void 0 : addToast({
                                            title: "Refresh token failed",
                                            description: ratelimit ? "This token was recently refreshed. The next available refresh is ".concat((0,till/* timeTill */.x)(ratelimit), ".") : "This token was recently refreshed. Please try again later."
                                        });
                                        setIsRefreshing(false);
                                        throw e;
                                    });
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                    align: "center",
                                    css: {
                                        gap: "$2"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                            css: {
                                                color: "$gray10",
                                                animation: isRefreshing ? "".concat(LoadingSpinner/* spin */.O, " 1s cubic-bezier(0.76, 0.35, 0.2, 0.7) infinite") : "none"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                icon: free_solid_svg_icons/* faRefresh */.QDM,
                                                width: 16,
                                                height: 16
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                            children: "Refresh Token"
                                        })
                                    ]
                                })
                            }),
                            isOracleOrder && (token === null || token === void 0 ? void 0 : (_token_ownership7 = token.ownership) === null || _token_ownership7 === void 0 ? void 0 : (_token_ownership_floorAsk7 = _token_ownership7.floorAsk) === null || _token_ownership_floorAsk7 === void 0 ? void 0 : _token_ownership_floorAsk7.id) && (token === null || token === void 0 ? void 0 : (_token_token18 = token.token) === null || _token_token18 === void 0 ? void 0 : _token_token18.tokenId) && (token === null || token === void 0 ? void 0 : (_token_token19 = token.token) === null || _token_token19 === void 0 ? void 0 : (_token_token_collection3 = _token_token19.collection) === null || _token_token_collection3 === void 0 ? void 0 : _token_token_collection3.id) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_module/* EditListingModal */.oU, {
                                trigger: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                    align: "center",
                                    css: {
                                        gap: "$2",
                                        px: "$2",
                                        py: "$3",
                                        borderRadius: 8,
                                        outline: "none",
                                        cursor: "pointer",
                                        "&:hover": {
                                            backgroundColor: "$gray5"
                                        },
                                        "&:focus": {
                                            backgroundColor: "$gray5"
                                        }
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                            css: {
                                                color: "$gray10"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                icon: free_solid_svg_icons/* faEdit */.Xcf
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                            children: "Edit Listing"
                                        })
                                    ]
                                }),
                                listingId: token === null || token === void 0 ? void 0 : (_token_ownership8 = token.ownership) === null || _token_ownership8 === void 0 ? void 0 : (_token_ownership_floorAsk8 = _token_ownership8.floorAsk) === null || _token_ownership_floorAsk8 === void 0 ? void 0 : _token_ownership_floorAsk8.id,
                                tokenId: token === null || token === void 0 ? void 0 : (_token_token20 = token.token) === null || _token_token20 === void 0 ? void 0 : _token_token20.tokenId,
                                collectionId: token === null || token === void 0 ? void 0 : (_token_token21 = token.token) === null || _token_token21 === void 0 ? void 0 : (_token_token_collection4 = _token_token21.collection) === null || _token_token_collection4 === void 0 ? void 0 : _token_token_collection4.id,
                                onClose: (data, currentStep)=>{
                                    if (mutate && currentStep == dist_index_module/* EditListingStep.Complete */.qy.Complete) mutate();
                                }
                            }) : null,
                            (token === null || token === void 0 ? void 0 : (_token_ownership9 = token.ownership) === null || _token_ownership9 === void 0 ? void 0 : (_token_ownership_floorAsk9 = _token_ownership9.floorAsk) === null || _token_ownership_floorAsk9 === void 0 ? void 0 : _token_ownership_floorAsk9.id) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CancelListing/* default */.Z, {
                                listingId: token.ownership.floorAsk.id,
                                mutate: mutate,
                                trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                                    css: {
                                        px: "$2",
                                        py: "$3",
                                        borderRadius: 8,
                                        outline: "none",
                                        cursor: "pointer",
                                        "&:hover": {
                                            backgroundColor: "$gray5"
                                        },
                                        "&:focus": {
                                            backgroundColor: "$gray5"
                                        }
                                    },
                                    children: !isOracleOrder ? /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Tooltip */.u, {
                                        content: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                            style: "body2",
                                            as: "p",
                                            children: "Canceling this order requires gas."
                                        }),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                            align: "center",
                                            css: {
                                                gap: "$2"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                                    css: {
                                                        color: "$gray10"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                        icon: free_solid_svg_icons/* faGasPump */.q16
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                    color: "error",
                                                    children: "Cancel Listing"
                                                })
                                            ]
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                        color: "error",
                                        children: "Cancel"
                                    })
                                })
                            }) : null
                        ]
                    })
                ]
            }) : null
        ]
    });
});

;// CONCATENATED MODULE: ./components/portfolio/TokenTable.tsx



























const ownerDesktopTemplateColumns = "1.25fr repeat(3, .75fr) 1.5fr";
const desktopTemplateColumns = "1.25fr repeat(3, .75fr)";
const TokenTable = /*#__PURE__*/ (0,react.forwardRef)((param, ref)=>{
    let { address , isLoading , sortBy , filterCollection , selectedItems , isOwner , itemView , setSelectedItems  } = param;
    const loadMoreRef = (0,react.useRef)(null);
    const loadMoreObserver = (0,esm/* useIntersectionObserver */.S1)(loadMoreRef, {});
    const client = (0,dist_index_module/* useReservoirClient */.RW)();
    const [acceptBidModalOpen, setAcceptBidModalOpen] = (0,react.useState)(false);
    const [playingElement, setPlayingElement] = (0,react.useState)();
    let tokenQuery = {
        limit: 20,
        sortBy: sortBy,
        collection: filterCollection,
        includeTopBid: true,
        includeRawData: true,
        includeAttributes: true
    };
    const { chain  } = (0,react.useContext)(ChainContextProvider/* ChainContext */.p);
    if (chain.collectionSetId) {
        tokenQuery.collectionsSetId = chain.collectionSetId;
    } else if (chain.community) {
        tokenQuery.community = chain.community;
    }
    const { data: tokens , fetchNextPage , mutate , isFetchingPage , isValidating  } = (0,dist_index_module/* useUserTokens */.Vy)(address, tokenQuery, {
        revalidateIfStale: true
    });
    (0,react.useEffect)(()=>{
        const isVisible = !!(loadMoreObserver === null || loadMoreObserver === void 0 ? void 0 : loadMoreObserver.isIntersecting);
        if (isVisible) {
            fetchNextPage();
        }
    }, [
        loadMoreObserver === null || loadMoreObserver === void 0 ? void 0 : loadMoreObserver.isIntersecting
    ]);
    (0,react.useEffect)(()=>{
        const eventListener = (event, chainId)=>{
            switch(event.name){
                case "accept_offer_complete":
                    {
                        if (!acceptBidModalOpen && !selectedItems.length) {
                            mutate();
                            setSelectedItems([]);
                        }
                        break;
                    }
            }
        };
        client === null || client === void 0 ? void 0 : client.addEventListener(eventListener);
        return ()=>{
            client === null || client === void 0 ? void 0 : client.removeEventListener(eventListener);
        };
    }, [
        client
    ]);
    (0,react.useEffect)(()=>{
        if (acceptBidModalOpen) {
            setSelectedItems([]);
        }
    }, [
        acceptBidModalOpen
    ]);
    (0,react.useImperativeHandle)(ref, ()=>({
            mutate
        }));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !isValidating && !isFetchingPage && tokens && tokens.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                direction: "column",
                align: "center",
                css: {
                    py: "$6",
                    gap: "$4",
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                        css: {
                            color: "$gray11"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                            icon: free_solid_svg_icons/* faMagnifyingGlass */.Y$T,
                            size: "2xl"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                        css: {
                            color: "$gray11"
                        },
                        children: "No items found"
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                direction: "column",
                css: {
                    width: "100%"
                },
                children: [
                    isLoading ? null : itemView === "list" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableHeading, {
                                isOwner: isOwner
                            }),
                            tokens.map((token, i)=>{
                                var _token_token;
                                if (!token) return null;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenTableRow, {
                                    token: token,
                                    mutate: mutate,
                                    selectedItems: selectedItems,
                                    setSelectedItems: setSelectedItems,
                                    isOwner: isOwner,
                                    onAcceptBidModalOpened: (open)=>{
                                        setAcceptBidModalOpen(open);
                                    }
                                }, "".concat((_token_token = token.token) === null || _token_token === void 0 ? void 0 : _token_token.tokenId, "-").concat(i));
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Grid */.rj, {
                        css: {
                            gap: "$4",
                            width: "100%",
                            pb: "$6",
                            gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
                            "@md": {
                                gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))"
                            }
                        },
                        children: tokens === null || tokens === void 0 ? void 0 : tokens.map((token, i)=>{
                            var _token_token, _token_ownership;
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(PortfolioTokenCard, {
                                token: token,
                                isOwner: isOwner,
                                address: address,
                                tokenCount: (token === null || token === void 0 ? void 0 : (_token_token = token.token) === null || _token_token === void 0 ? void 0 : _token_token.kind) === "erc1155" ? (_token_ownership = token.ownership) === null || _token_ownership === void 0 ? void 0 : _token_ownership.tokenCount : undefined,
                                mutate: mutate,
                                selectedItems: selectedItems,
                                setSelectedItems: setSelectedItems,
                                rarityEnabled: true,
                                onMediaPlayed: (e)=>{
                                    if (playingElement && playingElement !== e.nativeEvent.target) {
                                        playingElement.pause();
                                    }
                                    const element = e.nativeEvent.target || e.nativeEvent.target;
                                    if (element) {
                                        setPlayingElement(element);
                                    }
                                }
                            }, i);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: loadMoreRef
                    })
                ]
            }),
            isValidating && /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                align: "center",
                justify: "center",
                css: {
                    py: "$6"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpinner/* default */.Z, {})
            })
        ]
    });
});
const TokenTableRow = (param)=>{
    let { token , selectedItems , isOwner , onAcceptBidModalOpened , mutate , setSelectedItems  } = param;
    var _token_token, _token_token1, _token_token2, _token_token_collection, _token_ownership, _token_ownership_floorAsk, _token_token3, _token_token_collection1, _token_token_collection_id, _token_token4, _token_token5, _token_token6, _token_token7, _token_token8, _token_token_collection2, _token_token9, _token_ownership1, _token_ownership2, _token_token10, _token_token_collection3, _token_token11, _token_ownership3, _token_ownership_floorAsk1, _token_ownership_floorAsk_price, _token_ownership_floorAsk_price_amount, _token_ownership4, _token_ownership_floorAsk2, _token_ownership_floorAsk_price1, _token_ownership_floorAsk_price_amount1, _token_ownership5, _token_ownership_floorAsk3, _token_ownership_floorAsk_price2, _token_ownership_floorAsk_price_currency, _token_ownership6, _token_ownership_floorAsk4, _token_ownership_floorAsk_price3, _token_ownership_floorAsk_price_currency1, _token_ownership7, _token_ownership_floorAsk5, _token_ownership_floorAsk_price4, _token_ownership_floorAsk_price_netAmount, _token_ownership8, _token_ownership_floorAsk6, _token_ownership_floorAsk_price5, _token_ownership_floorAsk_price_currency2, _token_ownership9, _token_ownership_floorAsk7, _token_ownership_floorAsk_price6, _token_ownership_floorAsk_price_currency3, _token_ownership10, _token_ownership_floorAsk8, _token_ownership_floorAsk_source, _token_ownership11, _token_ownership_floorAsk9, _token_ownership_floorAsk_price7, _token_ownership_floorAsk_price_amount2, _token_ownership12, _token_ownership_floorAsk10, _token_ownership_floorAsk_price8, _token_ownership_floorAsk_price_currency4, _token_ownership13, _token_ownership_floorAsk11, _token_ownership_floorAsk_price9, _token_ownership_floorAsk_price_currency5, _token_token12, _token_token_collection4, _token_token_collection_floorAskPrice, _token_token_collection_floorAskPrice_amount, _token_token13, _token_token_collection5, _token_token_collection_floorAskPrice1, _token_token_collection_floorAskPrice_currency, _token_token14, _token_token_collection6, _token_token_collection_floorAskPrice2, _token_token_collection_floorAskPrice_currency1, _token_token15, _token_token_topBid, _token_token_topBid_price, _token_token_topBid_price_amount, _token_token16, _token_token_topBid1, _token_token_topBid_price1, _token_token_topBid_price_amount1, _token_token17, _token_token_topBid2, _token_token_topBid_price2, _token_token_topBid_price_currency, _token_token18, _token_token_topBid3, _token_token_topBid_price3, _token_token_topBid_price_currency1, _token_token19, _token_token_topBid4, _token_token_topBid_price4, _token_token_topBid_price_netAmount, _token_token20, _token_token_topBid5, _token_token_topBid_price5, _token_token_topBid_price_currency2, _token_token21, _token_token_topBid6, _token_token_topBid_price6, _token_token_topBid_price_currency3, _ref, _token_token22, _ref_source, _token_token23, _token_token24, _token_token_topBid7, _token_token_topBid_price7, _token_token_topBid_price_amount2, _token_token25, _token_token_topBid8, _token_token_topBid_price8, _token_token_topBid_price_currency4, _token_token26, _token_token_topBid9, _token_token_topBid_price9, _token_token_topBid_price_currency5, _token_token27, _token_token_topBid10, _token_token_topBid_price10, _token_token_topBid_price_amount3, _token_token28, _token_token_topBid11, _token_token_topBid_price11, _token_token_topBid_price_amount4, _token_token29, _token_token_topBid12, _token_token_topBid_price12, _token_token_topBid_price_amount5, _token_token30, _token_ownership14, _token_ownership_floorAsk12, _token_token31, _token_token32, _token_token_collection7, _token_ownership15, _token_ownership_floorAsk13, _token_token33, _token_token34, _token_token_collection8, _token_ownership16, _token_ownership_floorAsk14, _token_token35;
    const { routePrefix , proxyApi  } = (0,hooks/* useMarketplaceChain */.gw)();
    const { addToast  } = (0,react.useContext)(ToastContextProvider/* ToastContext */.u);
    const [isRefreshing, setIsRefreshing] = (0,react.useState)(false);
    const isSmallDevice = (0,react_responsive.useMediaQuery)({
        maxWidth: 900
    });
    const addSelectedItem = (item)=>{
        setSelectedItems([
            ...selectedItems,
            item
        ]);
    };
    const removeSelectedItem = (item)=>{
        setSelectedItems(selectedItems.filter((selectedItem)=>{
            var _selectedItem_token, _item_token, _selectedItem_token1, _item_token1;
            return (selectedItem === null || selectedItem === void 0 ? void 0 : (_selectedItem_token = selectedItem.token) === null || _selectedItem_token === void 0 ? void 0 : _selectedItem_token.tokenId) !== (item === null || item === void 0 ? void 0 : (_item_token = item.token) === null || _item_token === void 0 ? void 0 : _item_token.tokenId) || (selectedItem === null || selectedItem === void 0 ? void 0 : (_selectedItem_token1 = selectedItem.token) === null || _selectedItem_token1 === void 0 ? void 0 : _selectedItem_token1.contract) !== (item === null || item === void 0 ? void 0 : (_item_token1 = item.token) === null || _item_token1 === void 0 ? void 0 : _item_token1.contract);
        }));
    };
    const isSelectedItem = (item)=>{
        return selectedItems.some((selectedItem)=>{
            var _selectedItem_token, _item_token, _selectedItem_token1, _item_token1;
            return (selectedItem === null || selectedItem === void 0 ? void 0 : (_selectedItem_token = selectedItem.token) === null || _selectedItem_token === void 0 ? void 0 : _selectedItem_token.tokenId) === (item === null || item === void 0 ? void 0 : (_item_token = item.token) === null || _item_token === void 0 ? void 0 : _item_token.tokenId) && (selectedItem === null || selectedItem === void 0 ? void 0 : (_selectedItem_token1 = selectedItem.token) === null || _selectedItem_token1 === void 0 ? void 0 : _selectedItem_token1.contract) === (item === null || item === void 0 ? void 0 : (_item_token1 = item.token) === null || _item_token1 === void 0 ? void 0 : _item_token1.contract);
        });
    };
    const [acceptBidModalOpen, setAcceptBidModalOpen] = (0,react.useState)(false);
    const imageSrc = (0,react.useMemo)(()=>{
        var _token_token, _token_token1, _token_token2, _token_token_collection, _token_token3, _token_token_collection1;
        return (token === null || token === void 0 ? void 0 : (_token_token = token.token) === null || _token_token === void 0 ? void 0 : _token_token.tokenId) ? (token === null || token === void 0 ? void 0 : (_token_token1 = token.token) === null || _token_token1 === void 0 ? void 0 : _token_token1.imageSmall) || (0,optimizeImage/* default */.Z)(token === null || token === void 0 ? void 0 : (_token_token2 = token.token) === null || _token_token2 === void 0 ? void 0 : (_token_token_collection = _token_token2.collection) === null || _token_token_collection === void 0 ? void 0 : _token_token_collection.imageUrl, 250) : (0,optimizeImage/* default */.Z)(token === null || token === void 0 ? void 0 : (_token_token3 = token.token) === null || _token_token3 === void 0 ? void 0 : (_token_token_collection1 = _token_token3.collection) === null || _token_token_collection1 === void 0 ? void 0 : _token_token_collection1.imageUrl, 250);
    }, [
        token === null || token === void 0 ? void 0 : (_token_token = token.token) === null || _token_token === void 0 ? void 0 : _token_token.tokenId,
        token === null || token === void 0 ? void 0 : (_token_token1 = token.token) === null || _token_token1 === void 0 ? void 0 : _token_token1.imageSmall,
        token === null || token === void 0 ? void 0 : (_token_token2 = token.token) === null || _token_token2 === void 0 ? void 0 : (_token_token_collection = _token_token2.collection) === null || _token_token_collection === void 0 ? void 0 : _token_token_collection.imageUrl
    ]);
    const isOracleOrder = token === null || token === void 0 ? void 0 : (_token_ownership = token.ownership) === null || _token_ownership === void 0 ? void 0 : (_token_ownership_floorAsk = _token_ownership.floorAsk) === null || _token_ownership_floorAsk === void 0 ? void 0 : _token_ownership_floorAsk.isNativeOffChainCancellable;
    const contract = ((_token_token3 = token.token) === null || _token_token3 === void 0 ? void 0 : (_token_token_collection1 = _token_token3.collection) === null || _token_token_collection1 === void 0 ? void 0 : _token_token_collection1.id) ? (_token_token_collection_id = (_token_token4 = token.token) === null || _token_token4 === void 0 ? void 0 : _token_token4.collection.id) === null || _token_token_collection_id === void 0 ? void 0 : _token_token_collection_id.split(":")[0] : undefined;
    if (isSmallDevice) {
        var _token_token36, _token_token37, _token_token38, _token_token39, _token_token_collection9, _token_token40, _token_token41, _token_token_collection10, _token_token_collection_floorAskPrice3, _token_token_collection_floorAskPrice_amount1, _token_token42, _token_token_collection11, _token_token_collection_floorAskPrice4, _token_token_collection_floorAskPrice_currency2, _token_token43, _token_token_collection12, _token_token_collection_floorAskPrice5, _token_token_collection_floorAskPrice_currency3, _token_token44, _token_token_topBid13, _token_token_topBid_price13, _token_token_topBid_price_amount6, _token_token45, _token_token_topBid14, _token_token_topBid_price14, _token_token_topBid_price_currency6, _token_token46, _token_token_topBid15, _token_token_topBid_price15, _token_token_topBid_price_currency7, _token_token47, _token_token_topBid16, _token_token_topBid_price16, _token_token_topBid_price_amount7, _token_token48, _token_ownership17, _token_ownership_floorAsk15, _token_token49, _token_token50, _token_token_collection13, _token_ownership18, _token_ownership_floorAsk16, _token_token51, _token_token52, _token_token_collection14, _token_ownership19, _token_ownership_floorAsk17, _token_token53;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
            direction: "column",
            align: "start",
            css: {
                gap: "$3",
                borderBottom: "1px solid $gray3",
                py: "$3",
                width: "100%",
                overflow: "hidden",
                flex: 1
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/".concat(routePrefix, "/asset/").concat(token === null || token === void 0 ? void 0 : (_token_token36 = token.token) === null || _token_token36 === void 0 ? void 0 : _token_token36.contract, ":").concat(token === null || token === void 0 ? void 0 : (_token_token37 = token.token) === null || _token_token37 === void 0 ? void 0 : _token_token37.tokenId),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        align: "center",
                        children: [
                            imageSrc && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                style: {
                                    borderRadius: "4px",
                                    objectFit: "cover",
                                    aspectRatio: "1/1"
                                },
                                loader: (param)=>{
                                    let { src  } = param;
                                    return src;
                                },
                                src: imageSrc,
                                alt: "".concat(token === null || token === void 0 ? void 0 : (_token_token38 = token.token) === null || _token_token38 === void 0 ? void 0 : _token_token38.name),
                                width: 36,
                                height: 36
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                direction: "column",
                                css: {
                                    ml: "$2",
                                    overflow: "hidden",
                                    minWidth: 0
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                        style: "subtitle3",
                                        ellipsify: true,
                                        color: "subtle",
                                        children: token === null || token === void 0 ? void 0 : (_token_token39 = token.token) === null || _token_token39 === void 0 ? void 0 : (_token_token_collection9 = _token_token39.collection) === null || _token_token_collection9 === void 0 ? void 0 : _token_token_collection9.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Text */.xv, {
                                        style: "subtitle2",
                                        ellipsify: true,
                                        children: [
                                            "#",
                                            token === null || token === void 0 ? void 0 : (_token_token40 = token.token) === null || _token_token40 === void 0 ? void 0 : _token_token40.tokenId
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                    justify: "between",
                    css: {
                        width: "100%",
                        gap: "$3"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                            direction: "column",
                            align: "start",
                            css: {
                                width: "100%"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                    style: "subtitle3",
                                    color: "subtle",
                                    children: "Floor"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                                    amount: token === null || token === void 0 ? void 0 : (_token_token41 = token.token) === null || _token_token41 === void 0 ? void 0 : (_token_token_collection10 = _token_token41.collection) === null || _token_token_collection10 === void 0 ? void 0 : (_token_token_collection_floorAskPrice3 = _token_token_collection10.floorAskPrice) === null || _token_token_collection_floorAskPrice3 === void 0 ? void 0 : (_token_token_collection_floorAskPrice_amount1 = _token_token_collection_floorAskPrice3.amount) === null || _token_token_collection_floorAskPrice_amount1 === void 0 ? void 0 : _token_token_collection_floorAskPrice_amount1.decimal,
                                    address: token === null || token === void 0 ? void 0 : (_token_token42 = token.token) === null || _token_token42 === void 0 ? void 0 : (_token_token_collection11 = _token_token42.collection) === null || _token_token_collection11 === void 0 ? void 0 : (_token_token_collection_floorAskPrice4 = _token_token_collection11.floorAskPrice) === null || _token_token_collection_floorAskPrice4 === void 0 ? void 0 : (_token_token_collection_floorAskPrice_currency2 = _token_token_collection_floorAskPrice4.currency) === null || _token_token_collection_floorAskPrice_currency2 === void 0 ? void 0 : _token_token_collection_floorAskPrice_currency2.contract,
                                    decimals: token === null || token === void 0 ? void 0 : (_token_token43 = token.token) === null || _token_token43 === void 0 ? void 0 : (_token_token_collection12 = _token_token43.collection) === null || _token_token_collection12 === void 0 ? void 0 : (_token_token_collection_floorAskPrice5 = _token_token_collection12.floorAskPrice) === null || _token_token_collection_floorAskPrice5 === void 0 ? void 0 : (_token_token_collection_floorAskPrice_currency3 = _token_token_collection_floorAskPrice5.currency) === null || _token_token_collection_floorAskPrice_currency3 === void 0 ? void 0 : _token_token_collection_floorAskPrice_currency3.decimals,
                                    textStyle: "subtitle2",
                                    logoHeight: 14
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                            direction: "column",
                            align: "start",
                            css: {
                                width: "100%"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                    style: "subtitle3",
                                    color: "subtle",
                                    children: "Top Offer"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                                    amount: token === null || token === void 0 ? void 0 : (_token_token44 = token.token) === null || _token_token44 === void 0 ? void 0 : (_token_token_topBid13 = _token_token44.topBid) === null || _token_token_topBid13 === void 0 ? void 0 : (_token_token_topBid_price13 = _token_token_topBid13.price) === null || _token_token_topBid_price13 === void 0 ? void 0 : (_token_token_topBid_price_amount6 = _token_token_topBid_price13.amount) === null || _token_token_topBid_price_amount6 === void 0 ? void 0 : _token_token_topBid_price_amount6.decimal,
                                    address: token === null || token === void 0 ? void 0 : (_token_token45 = token.token) === null || _token_token45 === void 0 ? void 0 : (_token_token_topBid14 = _token_token45.topBid) === null || _token_token_topBid14 === void 0 ? void 0 : (_token_token_topBid_price14 = _token_token_topBid14.price) === null || _token_token_topBid_price14 === void 0 ? void 0 : (_token_token_topBid_price_currency6 = _token_token_topBid_price14.currency) === null || _token_token_topBid_price_currency6 === void 0 ? void 0 : _token_token_topBid_price_currency6.contract,
                                    decimals: token === null || token === void 0 ? void 0 : (_token_token46 = token.token) === null || _token_token46 === void 0 ? void 0 : (_token_token_topBid15 = _token_token46.topBid) === null || _token_token_topBid15 === void 0 ? void 0 : (_token_token_topBid_price15 = _token_token_topBid15.price) === null || _token_token_topBid_price15 === void 0 ? void 0 : (_token_token_topBid_price_currency7 = _token_token_topBid_price15.currency) === null || _token_token_topBid_price_currency7 === void 0 ? void 0 : _token_token_topBid_price_currency7.decimals,
                                    textStyle: "subtitle2",
                                    logoHeight: 14
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                    css: {
                        gap: "$2",
                        width: "100%"
                    },
                    children: [
                        (token === null || token === void 0 ? void 0 : (_token_token47 = token.token) === null || _token_token47 === void 0 ? void 0 : (_token_token_topBid16 = _token_token47.topBid) === null || _token_token_topBid16 === void 0 ? void 0 : (_token_token_topBid_price16 = _token_token_topBid16.price) === null || _token_token_topBid_price16 === void 0 ? void 0 : (_token_token_topBid_price_amount7 = _token_token_topBid_price16.amount) === null || _token_token_topBid_price_amount7 === void 0 ? void 0 : _token_token_topBid_price_amount7.decimal) && isOwner ? /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons/* AcceptBid */.ZS, {
                            tokenId: token.token.tokenId,
                            collectionId: token === null || token === void 0 ? void 0 : (_token_token48 = token.token) === null || _token_token48 === void 0 ? void 0 : _token_token48.contract,
                            mutate: mutate,
                            openState: [
                                acceptBidModalOpen,
                                (open)=>{
                                    if (open !== acceptBidModalOpen) {
                                        onAcceptBidModalOpened(open);
                                    }
                                    setAcceptBidModalOpen(open);
                                }
                            ],
                            buttonCss: {
                                width: "100%",
                                maxWidth: "300px",
                                justifyContent: "center",
                                px: "20px",
                                backgroundColor: "$primary9",
                                color: "white",
                                "&:hover": {
                                    backgroundColor: "$primary10"
                                }
                            },
                            buttonChildren: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                align: "center",
                                css: {
                                    gap: "$2"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: free_solid_svg_icons/* faBolt */.BDt
                                    }),
                                    "Sell"
                                ]
                            })
                        }) : null,
                        isOwner ? /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons/* List */.aV, {
                            token: token,
                            mutate: mutate,
                            buttonCss: {
                                width: "100%",
                                maxWidth: "300px",
                                justifyContent: "center",
                                px: "20px",
                                backgroundColor: "$gray3",
                                color: "$gray12",
                                "&:hover": {
                                    backgroundColor: "$gray4"
                                }
                            },
                            buttonChildren: "List"
                        }) : null,
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dropdown/* Dropdown */.Lt, {
                            modal: false,
                            trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                                color: "gray3",
                                size: "xs",
                                css: {
                                    width: 44,
                                    height: 44,
                                    justifyContent: "center",
                                    flexShrink: 0
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    icon: free_solid_svg_icons/* faEllipsis */.S6C
                                })
                            }),
                            contentProps: {
                                asChild: true,
                                forceMount: true
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* DropdownMenuItem */.Xi, {
                                    css: {
                                        py: "$3",
                                        width: "100%"
                                    },
                                    onClick: (e)=>{
                                        var _token_token;
                                        if (isRefreshing) {
                                            e.preventDefault();
                                            return;
                                        }
                                        setIsRefreshing(true);
                                        (0,fetcher/* default */.ZP)("".concat(window.location.origin, "/").concat(proxyApi, "/tokens/refresh/v1"), undefined, {
                                            method: "POST",
                                            headers: {
                                                "Content-Type": "application/json"
                                            },
                                            body: JSON.stringify({
                                                token: "".concat(contract, ":").concat((_token_token = token.token) === null || _token_token === void 0 ? void 0 : _token_token.tokenId)
                                            })
                                        }).then((param)=>{
                                            let { data , response  } = param;
                                            if (response.status === 200) {
                                                addToast === null || addToast === void 0 ? void 0 : addToast({
                                                    title: "Refresh token",
                                                    description: "Request to refresh this token was accepted."
                                                });
                                            } else {
                                                throw data;
                                            }
                                            setIsRefreshing(false);
                                        }).catch((e)=>{
                                            var _DATE_REGEX_exec;
                                            const ratelimit = (_DATE_REGEX_exec = till/* DATE_REGEX.exec */.n.exec(e === null || e === void 0 ? void 0 : e.message)) === null || _DATE_REGEX_exec === void 0 ? void 0 : _DATE_REGEX_exec[0];
                                            addToast === null || addToast === void 0 ? void 0 : addToast({
                                                title: "Refresh token failed",
                                                description: ratelimit ? "This token was recently refreshed. The next available refresh is ".concat((0,till/* timeTill */.x)(ratelimit), ".") : "This token was recently refreshed. Please try again later."
                                            });
                                            setIsRefreshing(false);
                                            throw e;
                                        });
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                        align: "center",
                                        css: {
                                            gap: "$2"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                                css: {
                                                    color: "$gray10",
                                                    animation: isRefreshing ? "".concat(LoadingSpinner/* spin */.O, " 1s cubic-bezier(0.76, 0.35, 0.2, 0.7) infinite") : "none"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                    icon: free_solid_svg_icons/* faRefresh */.QDM,
                                                    width: 16,
                                                    height: 16
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                children: "Refresh"
                                            })
                                        ]
                                    })
                                }),
                                isOracleOrder && (token === null || token === void 0 ? void 0 : (_token_ownership17 = token.ownership) === null || _token_ownership17 === void 0 ? void 0 : (_token_ownership_floorAsk15 = _token_ownership17.floorAsk) === null || _token_ownership_floorAsk15 === void 0 ? void 0 : _token_ownership_floorAsk15.id) && (token === null || token === void 0 ? void 0 : (_token_token49 = token.token) === null || _token_token49 === void 0 ? void 0 : _token_token49.tokenId) && (token === null || token === void 0 ? void 0 : (_token_token50 = token.token) === null || _token_token50 === void 0 ? void 0 : (_token_token_collection13 = _token_token50.collection) === null || _token_token_collection13 === void 0 ? void 0 : _token_token_collection13.id) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_module/* EditListingModal */.oU, {
                                    trigger: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                        align: "center",
                                        css: {
                                            gap: "$2",
                                            px: "$2",
                                            py: "$3",
                                            borderRadius: 8,
                                            outline: "none",
                                            cursor: "pointer",
                                            "&:hover": {
                                                backgroundColor: "$gray5"
                                            },
                                            "&:focus": {
                                                backgroundColor: "$gray5"
                                            }
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                                css: {
                                                    color: "$gray10"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                    icon: free_solid_svg_icons/* faEdit */.Xcf
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                children: "Edit Listing"
                                            })
                                        ]
                                    }),
                                    listingId: token === null || token === void 0 ? void 0 : (_token_ownership18 = token.ownership) === null || _token_ownership18 === void 0 ? void 0 : (_token_ownership_floorAsk16 = _token_ownership18.floorAsk) === null || _token_ownership_floorAsk16 === void 0 ? void 0 : _token_ownership_floorAsk16.id,
                                    tokenId: token === null || token === void 0 ? void 0 : (_token_token51 = token.token) === null || _token_token51 === void 0 ? void 0 : _token_token51.tokenId,
                                    collectionId: token === null || token === void 0 ? void 0 : (_token_token52 = token.token) === null || _token_token52 === void 0 ? void 0 : (_token_token_collection14 = _token_token52.collection) === null || _token_token_collection14 === void 0 ? void 0 : _token_token_collection14.id,
                                    onClose: (data, currentStep)=>{
                                        if (mutate && currentStep == dist_index_module/* EditListingStep.Complete */.qy.Complete) mutate();
                                    }
                                }) : null,
                                (token === null || token === void 0 ? void 0 : (_token_ownership19 = token.ownership) === null || _token_ownership19 === void 0 ? void 0 : (_token_ownership_floorAsk17 = _token_ownership19.floorAsk) === null || _token_ownership_floorAsk17 === void 0 ? void 0 : _token_ownership_floorAsk17.id) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CancelListing/* default */.Z, {
                                    listingId: token.ownership.floorAsk.id,
                                    mutate: mutate,
                                    trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                                        css: {
                                            px: "$2",
                                            py: "$3",
                                            borderRadius: 8,
                                            outline: "none",
                                            cursor: "pointer",
                                            "&:hover": {
                                                backgroundColor: "$gray5"
                                            },
                                            "&:focus": {
                                                backgroundColor: "$gray5"
                                            }
                                        },
                                        children: !isOracleOrder ? /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Tooltip */.u, {
                                            content: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                style: "body2",
                                                as: "p",
                                                children: "Cancelling this order requires gas."
                                            }),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                                align: "center",
                                                css: {
                                                    gap: "$2"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                                        css: {
                                                            color: "$gray10"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                            icon: free_solid_svg_icons/* faGasPump */.q16
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                        color: "error",
                                                        children: "Cancel"
                                                    })
                                                ]
                                            })
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                            color: "error",
                                            children: "Cancel"
                                        })
                                    })
                                }) : null
                            ]
                        })
                    ]
                })
            ]
        }, token === null || token === void 0 ? void 0 : (_token_token53 = token.token) === null || _token_token53 === void 0 ? void 0 : _token_token53.tokenId);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* TableRow */.SC, {
        css: {
            gridTemplateColumns: isOwner ? ownerDesktopTemplateColumns : desktopTemplateColumns
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                css: {
                    minWidth: 0,
                    overflow: "hidden"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                    align: "center",
                    css: {
                        gap: "$3"
                    },
                    children: [
                        isOwner ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                            checked: isSelectedItem(token),
                            onCheckedChange: (checked)=>{
                                if (checked) {
                                    addSelectedItem(token);
                                } else {
                                    removeSelectedItem(token);
                                }
                            }
                        }) : null,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/".concat(routePrefix, "/asset/").concat(token === null || token === void 0 ? void 0 : (_token_token5 = token.token) === null || _token_token5 === void 0 ? void 0 : _token_token5.contract, ":").concat(token === null || token === void 0 ? void 0 : (_token_token6 = token.token) === null || _token_token6 === void 0 ? void 0 : _token_token6.tokenId),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                align: "center",
                                children: [
                                    imageSrc && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        style: {
                                            borderRadius: "4px",
                                            objectFit: "cover",
                                            aspectRatio: "1/1"
                                        },
                                        loader: (param)=>{
                                            let { src  } = param;
                                            return src;
                                        },
                                        src: imageSrc,
                                        alt: "".concat(token === null || token === void 0 ? void 0 : (_token_token7 = token.token) === null || _token_token7 === void 0 ? void 0 : _token_token7.name),
                                        width: 48,
                                        height: 48
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                        direction: "column",
                                        css: {
                                            ml: "$2",
                                            overflow: "hidden"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                                justify: "between",
                                                align: "center",
                                                css: {
                                                    gap: "$2"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                        style: "subtitle3",
                                                        ellipsify: true,
                                                        color: "subtle",
                                                        children: token === null || token === void 0 ? void 0 : (_token_token8 = token.token) === null || _token_token8 === void 0 ? void 0 : (_token_token_collection2 = _token_token8.collection) === null || _token_token_collection2 === void 0 ? void 0 : _token_token_collection2.name
                                                    }),
                                                    (token === null || token === void 0 ? void 0 : (_token_token9 = token.token) === null || _token_token9 === void 0 ? void 0 : _token_token9.kind) === "erc1155" && (token === null || token === void 0 ? void 0 : (_token_ownership1 = token.ownership) === null || _token_ownership1 === void 0 ? void 0 : _token_ownership1.tokenCount) && /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                                                        justify: "center",
                                                        align: "center",
                                                        css: {
                                                            borderRadius: 9999,
                                                            backgroundColor: "$gray4",
                                                            maxWidth: "50%"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Text */.xv, {
                                                            ellipsify: true,
                                                            style: "subtitle3",
                                                            css: {
                                                                px: "$2",
                                                                fontSize: 10
                                                            },
                                                            children: [
                                                                "x",
                                                                (0,numbers/* formatNumber */.uf)(token === null || token === void 0 ? void 0 : (_token_ownership2 = token.ownership) === null || _token_ownership2 === void 0 ? void 0 : _token_ownership2.tokenCount, 0, true)
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenSeaVerified/* OpenSeaVerified */.v, {
                                                        openseaVerificationStatus: token === null || token === void 0 ? void 0 : (_token_token10 = token.token) === null || _token_token10 === void 0 ? void 0 : (_token_token_collection3 = _token_token10.collection) === null || _token_token_collection3 === void 0 ? void 0 : _token_token_collection3.openseaVerificationStatus
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Text */.xv, {
                                                style: "subtitle2",
                                                ellipsify: true,
                                                children: [
                                                    "#",
                                                    token === null || token === void 0 ? void 0 : (_token_token11 = token.token) === null || _token_token11 === void 0 ? void 0 : _token_token11.tokenId
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Tooltip */.u, {
                    side: "left",
                    sideOffset: "2",
                    open: (token === null || token === void 0 ? void 0 : (_token_ownership3 = token.ownership) === null || _token_ownership3 === void 0 ? void 0 : (_token_ownership_floorAsk1 = _token_ownership3.floorAsk) === null || _token_ownership_floorAsk1 === void 0 ? void 0 : (_token_ownership_floorAsk_price = _token_ownership_floorAsk1.price) === null || _token_ownership_floorAsk_price === void 0 ? void 0 : (_token_ownership_floorAsk_price_amount = _token_ownership_floorAsk_price.amount) === null || _token_ownership_floorAsk_price_amount === void 0 ? void 0 : _token_ownership_floorAsk_price_amount.decimal) ? undefined : false,
                    content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        direction: "column",
                        css: {
                            gap: "$2"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                justify: "between",
                                css: {
                                    gap: "$3"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                        style: "body3",
                                        children: "Total Listed Price"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                                        amount: token === null || token === void 0 ? void 0 : (_token_ownership4 = token.ownership) === null || _token_ownership4 === void 0 ? void 0 : (_token_ownership_floorAsk2 = _token_ownership4.floorAsk) === null || _token_ownership_floorAsk2 === void 0 ? void 0 : (_token_ownership_floorAsk_price1 = _token_ownership_floorAsk2.price) === null || _token_ownership_floorAsk_price1 === void 0 ? void 0 : (_token_ownership_floorAsk_price_amount1 = _token_ownership_floorAsk_price1.amount) === null || _token_ownership_floorAsk_price_amount1 === void 0 ? void 0 : _token_ownership_floorAsk_price_amount1.decimal,
                                        address: token === null || token === void 0 ? void 0 : (_token_ownership5 = token.ownership) === null || _token_ownership5 === void 0 ? void 0 : (_token_ownership_floorAsk3 = _token_ownership5.floorAsk) === null || _token_ownership_floorAsk3 === void 0 ? void 0 : (_token_ownership_floorAsk_price2 = _token_ownership_floorAsk3.price) === null || _token_ownership_floorAsk_price2 === void 0 ? void 0 : (_token_ownership_floorAsk_price_currency = _token_ownership_floorAsk_price2.currency) === null || _token_ownership_floorAsk_price_currency === void 0 ? void 0 : _token_ownership_floorAsk_price_currency.contract,
                                        decimals: token === null || token === void 0 ? void 0 : (_token_ownership6 = token.ownership) === null || _token_ownership6 === void 0 ? void 0 : (_token_ownership_floorAsk4 = _token_ownership6.floorAsk) === null || _token_ownership_floorAsk4 === void 0 ? void 0 : (_token_ownership_floorAsk_price3 = _token_ownership_floorAsk4.price) === null || _token_ownership_floorAsk_price3 === void 0 ? void 0 : (_token_ownership_floorAsk_price_currency1 = _token_ownership_floorAsk_price3.currency) === null || _token_ownership_floorAsk_price_currency1 === void 0 ? void 0 : _token_ownership_floorAsk_price_currency1.decimals,
                                        textStyle: "subtitle3",
                                        logoHeight: 14
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                justify: "between",
                                css: {
                                    gap: "$2"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                        style: "body3",
                                        children: "You Get"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                                        amount: token === null || token === void 0 ? void 0 : (_token_ownership7 = token.ownership) === null || _token_ownership7 === void 0 ? void 0 : (_token_ownership_floorAsk5 = _token_ownership7.floorAsk) === null || _token_ownership_floorAsk5 === void 0 ? void 0 : (_token_ownership_floorAsk_price4 = _token_ownership_floorAsk5.price) === null || _token_ownership_floorAsk_price4 === void 0 ? void 0 : (_token_ownership_floorAsk_price_netAmount = _token_ownership_floorAsk_price4.netAmount) === null || _token_ownership_floorAsk_price_netAmount === void 0 ? void 0 : _token_ownership_floorAsk_price_netAmount.decimal,
                                        address: token === null || token === void 0 ? void 0 : (_token_ownership8 = token.ownership) === null || _token_ownership8 === void 0 ? void 0 : (_token_ownership_floorAsk6 = _token_ownership8.floorAsk) === null || _token_ownership_floorAsk6 === void 0 ? void 0 : (_token_ownership_floorAsk_price5 = _token_ownership_floorAsk6.price) === null || _token_ownership_floorAsk_price5 === void 0 ? void 0 : (_token_ownership_floorAsk_price_currency2 = _token_ownership_floorAsk_price5.currency) === null || _token_ownership_floorAsk_price_currency2 === void 0 ? void 0 : _token_ownership_floorAsk_price_currency2.contract,
                                        decimals: token === null || token === void 0 ? void 0 : (_token_ownership9 = token.ownership) === null || _token_ownership9 === void 0 ? void 0 : (_token_ownership_floorAsk7 = _token_ownership9.floorAsk) === null || _token_ownership_floorAsk7 === void 0 ? void 0 : (_token_ownership_floorAsk_price6 = _token_ownership_floorAsk7.price) === null || _token_ownership_floorAsk_price6 === void 0 ? void 0 : (_token_ownership_floorAsk_price_currency3 = _token_ownership_floorAsk_price6.currency) === null || _token_ownership_floorAsk_price_currency3 === void 0 ? void 0 : _token_ownership_floorAsk_price_currency3.decimals,
                                        textStyle: "subtitle3",
                                        logoHeight: 14
                                    })
                                ]
                            })
                        ]
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        align: "center",
                        css: {
                            gap: "$2"
                        },
                        children: [
                            ((_token_ownership10 = token.ownership) === null || _token_ownership10 === void 0 ? void 0 : (_token_ownership_floorAsk8 = _token_ownership10.floorAsk) === null || _token_ownership_floorAsk8 === void 0 ? void 0 : (_token_ownership_floorAsk_source = _token_ownership_floorAsk8.source) === null || _token_ownership_floorAsk_source === void 0 ? void 0 : _token_ownership_floorAsk_source.icon) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: token.ownership.floorAsk.source.icon,
                                alt: "Listing Source Icon",
                                style: {
                                    height: 16,
                                    width: 16
                                }
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                                amount: token === null || token === void 0 ? void 0 : (_token_ownership11 = token.ownership) === null || _token_ownership11 === void 0 ? void 0 : (_token_ownership_floorAsk9 = _token_ownership11.floorAsk) === null || _token_ownership_floorAsk9 === void 0 ? void 0 : (_token_ownership_floorAsk_price7 = _token_ownership_floorAsk9.price) === null || _token_ownership_floorAsk_price7 === void 0 ? void 0 : (_token_ownership_floorAsk_price_amount2 = _token_ownership_floorAsk_price7.amount) === null || _token_ownership_floorAsk_price_amount2 === void 0 ? void 0 : _token_ownership_floorAsk_price_amount2.decimal,
                                address: token === null || token === void 0 ? void 0 : (_token_ownership12 = token.ownership) === null || _token_ownership12 === void 0 ? void 0 : (_token_ownership_floorAsk10 = _token_ownership12.floorAsk) === null || _token_ownership_floorAsk10 === void 0 ? void 0 : (_token_ownership_floorAsk_price8 = _token_ownership_floorAsk10.price) === null || _token_ownership_floorAsk_price8 === void 0 ? void 0 : (_token_ownership_floorAsk_price_currency4 = _token_ownership_floorAsk_price8.currency) === null || _token_ownership_floorAsk_price_currency4 === void 0 ? void 0 : _token_ownership_floorAsk_price_currency4.contract,
                                decimals: token === null || token === void 0 ? void 0 : (_token_ownership13 = token.ownership) === null || _token_ownership13 === void 0 ? void 0 : (_token_ownership_floorAsk11 = _token_ownership13.floorAsk) === null || _token_ownership_floorAsk11 === void 0 ? void 0 : (_token_ownership_floorAsk_price9 = _token_ownership_floorAsk11.price) === null || _token_ownership_floorAsk_price9 === void 0 ? void 0 : (_token_ownership_floorAsk_price_currency5 = _token_ownership_floorAsk_price9.currency) === null || _token_ownership_floorAsk_price_currency5 === void 0 ? void 0 : _token_ownership_floorAsk_price_currency5.decimals,
                                textStyle: "subtitle1",
                                logoHeight: 14
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                    amount: token === null || token === void 0 ? void 0 : (_token_token12 = token.token) === null || _token_token12 === void 0 ? void 0 : (_token_token_collection4 = _token_token12.collection) === null || _token_token_collection4 === void 0 ? void 0 : (_token_token_collection_floorAskPrice = _token_token_collection4.floorAskPrice) === null || _token_token_collection_floorAskPrice === void 0 ? void 0 : (_token_token_collection_floorAskPrice_amount = _token_token_collection_floorAskPrice.amount) === null || _token_token_collection_floorAskPrice_amount === void 0 ? void 0 : _token_token_collection_floorAskPrice_amount.decimal,
                    address: token === null || token === void 0 ? void 0 : (_token_token13 = token.token) === null || _token_token13 === void 0 ? void 0 : (_token_token_collection5 = _token_token13.collection) === null || _token_token_collection5 === void 0 ? void 0 : (_token_token_collection_floorAskPrice1 = _token_token_collection5.floorAskPrice) === null || _token_token_collection_floorAskPrice1 === void 0 ? void 0 : (_token_token_collection_floorAskPrice_currency = _token_token_collection_floorAskPrice1.currency) === null || _token_token_collection_floorAskPrice_currency === void 0 ? void 0 : _token_token_collection_floorAskPrice_currency.contract,
                    decimals: token === null || token === void 0 ? void 0 : (_token_token14 = token.token) === null || _token_token14 === void 0 ? void 0 : (_token_token_collection6 = _token_token14.collection) === null || _token_token_collection6 === void 0 ? void 0 : (_token_token_collection_floorAskPrice2 = _token_token_collection6.floorAskPrice) === null || _token_token_collection_floorAskPrice2 === void 0 ? void 0 : (_token_token_collection_floorAskPrice_currency1 = _token_token_collection_floorAskPrice2.currency) === null || _token_token_collection_floorAskPrice_currency1 === void 0 ? void 0 : _token_token_collection_floorAskPrice_currency1.decimals,
                    textStyle: "subtitle1",
                    logoHeight: 14
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Tooltip */.u, {
                    side: "left",
                    sideOffset: "2",
                    open: (token === null || token === void 0 ? void 0 : (_token_token15 = token.token) === null || _token_token15 === void 0 ? void 0 : (_token_token_topBid = _token_token15.topBid) === null || _token_token_topBid === void 0 ? void 0 : (_token_token_topBid_price = _token_token_topBid.price) === null || _token_token_topBid_price === void 0 ? void 0 : (_token_token_topBid_price_amount = _token_token_topBid_price.amount) === null || _token_token_topBid_price_amount === void 0 ? void 0 : _token_token_topBid_price_amount.decimal) ? undefined : false,
                    content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        direction: "column",
                        css: {
                            gap: "$2"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                justify: "between",
                                css: {
                                    gap: "$3"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                        style: "body3",
                                        children: "Total Offer"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                                        amount: token === null || token === void 0 ? void 0 : (_token_token16 = token.token) === null || _token_token16 === void 0 ? void 0 : (_token_token_topBid1 = _token_token16.topBid) === null || _token_token_topBid1 === void 0 ? void 0 : (_token_token_topBid_price1 = _token_token_topBid1.price) === null || _token_token_topBid_price1 === void 0 ? void 0 : (_token_token_topBid_price_amount1 = _token_token_topBid_price1.amount) === null || _token_token_topBid_price_amount1 === void 0 ? void 0 : _token_token_topBid_price_amount1.decimal,
                                        address: token === null || token === void 0 ? void 0 : (_token_token17 = token.token) === null || _token_token17 === void 0 ? void 0 : (_token_token_topBid2 = _token_token17.topBid) === null || _token_token_topBid2 === void 0 ? void 0 : (_token_token_topBid_price2 = _token_token_topBid2.price) === null || _token_token_topBid_price2 === void 0 ? void 0 : (_token_token_topBid_price_currency = _token_token_topBid_price2.currency) === null || _token_token_topBid_price_currency === void 0 ? void 0 : _token_token_topBid_price_currency.contract,
                                        decimals: token === null || token === void 0 ? void 0 : (_token_token18 = token.token) === null || _token_token18 === void 0 ? void 0 : (_token_token_topBid3 = _token_token18.topBid) === null || _token_token_topBid3 === void 0 ? void 0 : (_token_token_topBid_price3 = _token_token_topBid3.price) === null || _token_token_topBid_price3 === void 0 ? void 0 : (_token_token_topBid_price_currency1 = _token_token_topBid_price3.currency) === null || _token_token_topBid_price_currency1 === void 0 ? void 0 : _token_token_topBid_price_currency1.decimals,
                                        textStyle: "subtitle3",
                                        logoHeight: 14
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                justify: "between",
                                css: {
                                    gap: "$2"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                        style: "body3",
                                        children: "You Get"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                                        amount: token === null || token === void 0 ? void 0 : (_token_token19 = token.token) === null || _token_token19 === void 0 ? void 0 : (_token_token_topBid4 = _token_token19.topBid) === null || _token_token_topBid4 === void 0 ? void 0 : (_token_token_topBid_price4 = _token_token_topBid4.price) === null || _token_token_topBid_price4 === void 0 ? void 0 : (_token_token_topBid_price_netAmount = _token_token_topBid_price4.netAmount) === null || _token_token_topBid_price_netAmount === void 0 ? void 0 : _token_token_topBid_price_netAmount.decimal,
                                        address: token === null || token === void 0 ? void 0 : (_token_token20 = token.token) === null || _token_token20 === void 0 ? void 0 : (_token_token_topBid5 = _token_token20.topBid) === null || _token_token_topBid5 === void 0 ? void 0 : (_token_token_topBid_price5 = _token_token_topBid5.price) === null || _token_token_topBid_price5 === void 0 ? void 0 : (_token_token_topBid_price_currency2 = _token_token_topBid_price5.currency) === null || _token_token_topBid_price_currency2 === void 0 ? void 0 : _token_token_topBid_price_currency2.contract,
                                        decimals: token === null || token === void 0 ? void 0 : (_token_token21 = token.token) === null || _token_token21 === void 0 ? void 0 : (_token_token_topBid6 = _token_token21.topBid) === null || _token_token_topBid6 === void 0 ? void 0 : (_token_token_topBid_price6 = _token_token_topBid6.price) === null || _token_token_topBid_price6 === void 0 ? void 0 : (_token_token_topBid_price_currency3 = _token_token_topBid_price6.currency) === null || _token_token_topBid_price_currency3 === void 0 ? void 0 : _token_token_topBid_price_currency3.decimals,
                                        textStyle: "subtitle3",
                                        logoHeight: 14
                                    })
                                ]
                            })
                        ]
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        direction: "column",
                        align: "start",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                css: {
                                    gap: "$2"
                                },
                                align: "center",
                                children: [
                                    ((_ref = (_token_token22 = token.token) === null || _token_token22 === void 0 ? void 0 : _token_token22.topBid) === null || _ref === void 0 ? void 0 : (_ref_source = _ref.source) === null || _ref_source === void 0 ? void 0 : _ref_source.icon) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: (token === null || token === void 0 ? void 0 : (_token_token23 = token.token) === null || _token_token23 === void 0 ? void 0 : _token_token23.topBid).source.icon,
                                        alt: "Listing Source Icon",
                                        style: {
                                            height: 16,
                                            width: 16
                                        }
                                    }) : null,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                                        amount: token === null || token === void 0 ? void 0 : (_token_token24 = token.token) === null || _token_token24 === void 0 ? void 0 : (_token_token_topBid7 = _token_token24.topBid) === null || _token_token_topBid7 === void 0 ? void 0 : (_token_token_topBid_price7 = _token_token_topBid7.price) === null || _token_token_topBid_price7 === void 0 ? void 0 : (_token_token_topBid_price_amount2 = _token_token_topBid_price7.amount) === null || _token_token_topBid_price_amount2 === void 0 ? void 0 : _token_token_topBid_price_amount2.decimal,
                                        address: token === null || token === void 0 ? void 0 : (_token_token25 = token.token) === null || _token_token25 === void 0 ? void 0 : (_token_token_topBid8 = _token_token25.topBid) === null || _token_token_topBid8 === void 0 ? void 0 : (_token_token_topBid_price8 = _token_token_topBid8.price) === null || _token_token_topBid_price8 === void 0 ? void 0 : (_token_token_topBid_price_currency4 = _token_token_topBid_price8.currency) === null || _token_token_topBid_price_currency4 === void 0 ? void 0 : _token_token_topBid_price_currency4.contract,
                                        decimals: token === null || token === void 0 ? void 0 : (_token_token26 = token.token) === null || _token_token26 === void 0 ? void 0 : (_token_token_topBid9 = _token_token26.topBid) === null || _token_token_topBid9 === void 0 ? void 0 : (_token_token_topBid_price9 = _token_token_topBid9.price) === null || _token_token_topBid_price9 === void 0 ? void 0 : (_token_token_topBid_price_currency5 = _token_token_topBid_price9.currency) === null || _token_token_topBid_price_currency5 === void 0 ? void 0 : _token_token_topBid_price_currency5.decimals,
                                        textStyle: "subtitle2",
                                        logoHeight: 14
                                    })
                                ]
                            }),
                            (token === null || token === void 0 ? void 0 : (_token_token27 = token.token) === null || _token_token27 === void 0 ? void 0 : (_token_token_topBid10 = _token_token27.topBid) === null || _token_token_topBid10 === void 0 ? void 0 : (_token_token_topBid_price10 = _token_token_topBid10.price) === null || _token_token_topBid_price10 === void 0 ? void 0 : (_token_token_topBid_price_amount3 = _token_token_topBid_price10.amount) === null || _token_token_topBid_price_amount3 === void 0 ? void 0 : _token_token_topBid_price_amount3.usd) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                style: "subtitle3",
                                css: {
                                    color: "$gray11"
                                },
                                ellipsify: true,
                                children: (0,numbers/* formatDollar */.el)(token === null || token === void 0 ? void 0 : (_token_token28 = token.token) === null || _token_token28 === void 0 ? void 0 : (_token_token_topBid11 = _token_token28.topBid) === null || _token_token_topBid11 === void 0 ? void 0 : (_token_token_topBid_price11 = _token_token_topBid11.price) === null || _token_token_topBid_price11 === void 0 ? void 0 : (_token_token_topBid_price_amount4 = _token_token_topBid_price11.amount) === null || _token_token_topBid_price_amount4 === void 0 ? void 0 : _token_token_topBid_price_amount4.usd)
                            }) : null
                        ]
                    })
                })
            }),
            isOwner && /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                    justify: "end",
                    css: {
                        gap: "$3"
                    },
                    children: [
                        (token === null || token === void 0 ? void 0 : (_token_token29 = token.token) === null || _token_token29 === void 0 ? void 0 : (_token_token_topBid12 = _token_token29.topBid) === null || _token_token_topBid12 === void 0 ? void 0 : (_token_token_topBid_price12 = _token_token_topBid12.price) === null || _token_token_topBid_price12 === void 0 ? void 0 : (_token_token_topBid_price_amount5 = _token_token_topBid_price12.amount) === null || _token_token_topBid_price_amount5 === void 0 ? void 0 : _token_token_topBid_price_amount5.decimal) && /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons/* AcceptBid */.ZS, {
                            openState: [
                                acceptBidModalOpen,
                                (open)=>{
                                    if (open !== acceptBidModalOpen) {
                                        onAcceptBidModalOpened(open);
                                    }
                                    setAcceptBidModalOpen(open);
                                }
                            ],
                            tokenId: token.token.tokenId,
                            collectionId: token === null || token === void 0 ? void 0 : (_token_token30 = token.token) === null || _token_token30 === void 0 ? void 0 : _token_token30.contract,
                            buttonCss: {
                                px: "32px",
                                backgroundColor: "$primary9",
                                color: "white",
                                "&:hover": {
                                    backgroundColor: "$primary10"
                                }
                            },
                            buttonChildren: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                align: "center",
                                css: {
                                    gap: "$2"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: free_solid_svg_icons/* faBolt */.BDt
                                    }),
                                    "Sell"
                                ]
                            }),
                            mutate: mutate
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons/* List */.aV, {
                            token: token,
                            buttonCss: {
                                px: "42px",
                                backgroundColor: "$gray3",
                                color: "$gray12",
                                "&:hover": {
                                    backgroundColor: "$gray4"
                                }
                            },
                            buttonChildren: "List",
                            mutate: mutate
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons_Transfer, {
                            token: token,
                            mutate: mutate
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dropdown/* Dropdown */.Lt, {
                            modal: false,
                            trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                                color: "gray3",
                                size: "xs",
                                css: {
                                    width: 44,
                                    justifyContent: "center"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    icon: free_solid_svg_icons/* faEllipsis */.S6C
                                })
                            }),
                            contentProps: {
                                asChild: true,
                                forceMount: true
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* DropdownMenuItem */.Xi, {
                                    css: {
                                        py: "$3",
                                        width: "100%"
                                    },
                                    onClick: (e)=>{
                                        var _token_token;
                                        if (isRefreshing) {
                                            e.preventDefault();
                                            return;
                                        }
                                        setIsRefreshing(true);
                                        (0,fetcher/* default */.ZP)("".concat(window.location.origin, "/").concat(proxyApi, "/tokens/refresh/v1"), undefined, {
                                            method: "POST",
                                            headers: {
                                                "Content-Type": "application/json"
                                            },
                                            body: JSON.stringify({
                                                token: "".concat(contract, ":").concat((_token_token = token.token) === null || _token_token === void 0 ? void 0 : _token_token.tokenId)
                                            })
                                        }).then((param)=>{
                                            let { data , response  } = param;
                                            if (response.status === 200) {
                                                addToast === null || addToast === void 0 ? void 0 : addToast({
                                                    title: "Refresh token",
                                                    description: "Request to refresh this token was accepted."
                                                });
                                            } else {
                                                throw data;
                                            }
                                            setIsRefreshing(false);
                                        }).catch((e)=>{
                                            var _DATE_REGEX_exec;
                                            const ratelimit = (_DATE_REGEX_exec = till/* DATE_REGEX.exec */.n.exec(e === null || e === void 0 ? void 0 : e.message)) === null || _DATE_REGEX_exec === void 0 ? void 0 : _DATE_REGEX_exec[0];
                                            addToast === null || addToast === void 0 ? void 0 : addToast({
                                                title: "Refresh token failed",
                                                description: ratelimit ? "This token was recently refreshed. The next available refresh is ".concat((0,till/* timeTill */.x)(ratelimit), ".") : "This token was recently refreshed. Please try again later."
                                            });
                                            setIsRefreshing(false);
                                            throw e;
                                        });
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                        align: "center",
                                        css: {
                                            gap: "$2"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                                css: {
                                                    color: "$gray10",
                                                    animation: isRefreshing ? "".concat(LoadingSpinner/* spin */.O, " 1s cubic-bezier(0.76, 0.35, 0.2, 0.7) infinite") : "none"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                    icon: free_solid_svg_icons/* faRefresh */.QDM,
                                                    width: 16,
                                                    height: 16
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                children: "Refresh"
                                            })
                                        ]
                                    })
                                }),
                                isOracleOrder && (token === null || token === void 0 ? void 0 : (_token_ownership14 = token.ownership) === null || _token_ownership14 === void 0 ? void 0 : (_token_ownership_floorAsk12 = _token_ownership14.floorAsk) === null || _token_ownership_floorAsk12 === void 0 ? void 0 : _token_ownership_floorAsk12.id) && (token === null || token === void 0 ? void 0 : (_token_token31 = token.token) === null || _token_token31 === void 0 ? void 0 : _token_token31.tokenId) && (token === null || token === void 0 ? void 0 : (_token_token32 = token.token) === null || _token_token32 === void 0 ? void 0 : (_token_token_collection7 = _token_token32.collection) === null || _token_token_collection7 === void 0 ? void 0 : _token_token_collection7.id) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_module/* EditListingModal */.oU, {
                                    trigger: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                        align: "center",
                                        css: {
                                            gap: "$2",
                                            px: "$2",
                                            py: "$3",
                                            borderRadius: 8,
                                            outline: "none",
                                            cursor: "pointer",
                                            "&:hover": {
                                                backgroundColor: "$gray5"
                                            },
                                            "&:focus": {
                                                backgroundColor: "$gray5"
                                            }
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                                css: {
                                                    color: "$gray10"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                    icon: free_solid_svg_icons/* faEdit */.Xcf
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                children: "Edit Listing"
                                            })
                                        ]
                                    }),
                                    listingId: token === null || token === void 0 ? void 0 : (_token_ownership15 = token.ownership) === null || _token_ownership15 === void 0 ? void 0 : (_token_ownership_floorAsk13 = _token_ownership15.floorAsk) === null || _token_ownership_floorAsk13 === void 0 ? void 0 : _token_ownership_floorAsk13.id,
                                    tokenId: token === null || token === void 0 ? void 0 : (_token_token33 = token.token) === null || _token_token33 === void 0 ? void 0 : _token_token33.tokenId,
                                    collectionId: token === null || token === void 0 ? void 0 : (_token_token34 = token.token) === null || _token_token34 === void 0 ? void 0 : (_token_token_collection8 = _token_token34.collection) === null || _token_token_collection8 === void 0 ? void 0 : _token_token_collection8.id,
                                    onClose: (data, currentStep)=>{
                                        if (mutate && currentStep == dist_index_module/* EditListingStep.Complete */.qy.Complete) mutate();
                                    }
                                }) : null,
                                (token === null || token === void 0 ? void 0 : (_token_ownership16 = token.ownership) === null || _token_ownership16 === void 0 ? void 0 : (_token_ownership_floorAsk14 = _token_ownership16.floorAsk) === null || _token_ownership_floorAsk14 === void 0 ? void 0 : _token_ownership_floorAsk14.id) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CancelListing/* default */.Z, {
                                    listingId: token.ownership.floorAsk.id,
                                    mutate: mutate,
                                    trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                                        css: {
                                            px: "$2",
                                            py: "$3",
                                            borderRadius: 8,
                                            outline: "none",
                                            cursor: "pointer",
                                            "&:hover": {
                                                backgroundColor: "$gray5"
                                            },
                                            "&:focus": {
                                                backgroundColor: "$gray5"
                                            }
                                        },
                                        children: !isOracleOrder ? /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Tooltip */.u, {
                                            content: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                style: "body2",
                                                as: "p",
                                                children: "Cancelling this order requires gas."
                                            }),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                                align: "center",
                                                css: {
                                                    gap: "$2"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                                        css: {
                                                            color: "$gray10"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                            icon: free_solid_svg_icons/* faGasPump */.q16
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                        color: "error",
                                                        children: "Cancel"
                                                    })
                                                ]
                                            })
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                            color: "error",
                                            children: "Cancel"
                                        })
                                    })
                                }) : null
                            ]
                        })
                    ]
                })
            })
        ]
    }, token === null || token === void 0 ? void 0 : (_token_token35 = token.token) === null || _token_token35 === void 0 ? void 0 : _token_token35.tokenId);
};
const TableHeading = (param)=>/*#__PURE__*/ {
    let { isOwner  } = param;
    return (0,jsx_runtime.jsxs)(primitives/* HeaderRow */.VJ, {
        css: {
            display: "none",
            "@md": {
                display: "grid"
            },
            gridTemplateColumns: isOwner ? ownerDesktopTemplateColumns : desktopTemplateColumns,
            position: "sticky",
            top: navbar/* NAVBAR_HEIGHT */.ik,
            backgroundColor: "$neutralBg"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                    style: "subtitle3",
                    color: "subtle",
                    children: "Items"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                    style: "subtitle3",
                    color: "subtle",
                    children: "Listed Price"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                    style: "subtitle3",
                    color: "subtle",
                    children: "Floor"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                    style: "subtitle3",
                    color: "subtle",
                    children: "Top Offer"
                })
            }),
            isOwner ? /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {}) : null
        ]
    });
};

// EXTERNAL MODULE: ./components/ConnectWalletButton.tsx
var ConnectWalletButton = __webpack_require__(80672);
// EXTERNAL MODULE: ./components/common/FullscreenModal.tsx
var FullscreenModal = __webpack_require__(18491);
;// CONCATENATED MODULE: ./components/common/LoadMoreCollections.tsx




const LoadMoreCollections = (param)=>{
    let { loadMore  } = param;
    const loadMoreRef = (0,react.useRef)(null);
    const loadMoreObserver = (0,esm/* useIntersectionObserver */.S1)(loadMoreRef, {});
    (0,react.useEffect)(()=>{
        const isVisible = !!(loadMoreObserver === null || loadMoreObserver === void 0 ? void 0 : loadMoreObserver.isIntersecting);
        if (isVisible) {
            loadMore();
        }
    }, [
        loadMoreObserver === null || loadMoreObserver === void 0 ? void 0 : loadMoreObserver.isIntersecting
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
        ref: loadMoreRef,
        css: {
            height: 20,
            width: "100%"
        }
    });
};
/* harmony default export */ var common_LoadMoreCollections = (LoadMoreCollections);

;// CONCATENATED MODULE: ./components/common/MobileTokenFilters.tsx












const MobileTokenFilters = (param)=>{
    let { collections , filterCollection , setFilterCollection , loadMoreCollections  } = param;
    const triggerRef = (0,react.useRef)(null);
    const trigger = /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
        justify: "center",
        css: {
            position: "fixed",
            left: 0,
            bottom: "70px",
            width: "100vw",
            zIndex: 99
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Button */.zx, {
            ref: triggerRef,
            css: {
                justifyContent: "center",
                alignItems: "center",
                justifyItems: "center",
                position: "fixed",
                px: "$6",
                py: "$3"
            },
            type: "button",
            size: "small",
            corners: "pill",
            color: "gray3",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                    style: "h6",
                    children: "Filter"
                }),
                filterCollection && /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                    justify: "center",
                    align: "center",
                    css: {
                        height: "24px",
                        width: "24px",
                        backgroundColor: "$gray4",
                        borderRadius: "100%",
                        fontSize: "medium",
                        fontWeight: "500"
                    },
                    children: "1"
                })
            ]
        })
    });
    if ((collections === null || collections === void 0 ? void 0 : collections.length) === 0 || collections == null) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FullscreenModal/* FullscreenModal */.O, {
        trigger: trigger,
        children: [
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                css: {
                    flexDirection: "column",
                    height: "100%",
                    overflow: "scroll"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        css: {
                            py: "$4",
                            px: "$4",
                            width: "100%",
                            borderBottom: "1px solid $gray4",
                            height: navbar/* NAVBAR_HEIGHT_MOBILE */.t7
                        },
                        align: "center",
                        justify: "between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                                align: "center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                    style: "h5",
                                    css: {
                                        mr: "$3"
                                    },
                                    children: "Filter"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_dialog_dist_index_module/* Close */.x8, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                                    css: {
                                        justifyContent: "center",
                                        width: "44px",
                                        height: "44px",
                                        alignItems: "center",
                                        borderRadius: 8,
                                        backgroundColor: "$gray3",
                                        color: "$gray12",
                                        "&:hover": {
                                            backgroundColor: "$gray4"
                                        }
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: free_solid_svg_icons/* faXmark */.g82,
                                        width: 16,
                                        height: 16
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        direction: "column",
                        css: {
                            pt: "$4",
                            maxHeight: "calc(100vh - ".concat(navbar/* NAVBAR_HEIGHT_MOBILE */.t7, "px)"),
                            overflowY: "auto",
                            pb: "$5"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                style: "subtitle1",
                                css: {
                                    mb: "$2",
                                    pl: "$4"
                                },
                                children: "Collections"
                            }),
                            collections === null || collections === void 0 ? void 0 : collections.map((collection)=>{
                                var _collection_collection, _collection_collection1, _collection_collection2, _collection_collection3, _collection_collection4, _collection_collection5, _collection_ownership, _collection_collection6;
                                let selected = (collection === null || collection === void 0 ? void 0 : (_collection_collection = collection.collection) === null || _collection_collection === void 0 ? void 0 : _collection_collection.id) == filterCollection;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                    css: {
                                        py: "$2",
                                        px: "$4",
                                        gap: "$3",
                                        cursor: "pointer",
                                        "&:hover": {
                                            backgroundColor: selected ? "$gray5" : "$gray4"
                                        },
                                        backgroundColor: selected ? "$gray5" : ""
                                    },
                                    align: "center",
                                    onClick: ()=>{
                                        var _triggerRef_current;
                                        if (selected) {
                                            setFilterCollection(undefined);
                                        } else {
                                            var _collection_collection;
                                            setFilterCollection(collection === null || collection === void 0 ? void 0 : (_collection_collection = collection.collection) === null || _collection_collection === void 0 ? void 0 : _collection_collection.id);
                                        }
                                        triggerRef === null || triggerRef === void 0 ? void 0 : (_triggerRef_current = triggerRef.current) === null || _triggerRef_current === void 0 ? void 0 : _triggerRef_current.click();
                                    },
                                    children: [
                                        (collection === null || collection === void 0 ? void 0 : (_collection_collection1 = collection.collection) === null || _collection_collection1 === void 0 ? void 0 : _collection_collection1.image) && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            style: {
                                                borderRadius: "4px",
                                                objectFit: "cover",
                                                aspectRatio: "1/1"
                                            },
                                            loader: (param)=>{
                                                let { src  } = param;
                                                return src;
                                            },
                                            src: (0,optimizeImage/* default */.Z)(collection === null || collection === void 0 ? void 0 : (_collection_collection2 = collection.collection) === null || _collection_collection2 === void 0 ? void 0 : _collection_collection2.image, 250),
                                            alt: collection === null || collection === void 0 ? void 0 : (_collection_collection3 = collection.collection) === null || _collection_collection3 === void 0 ? void 0 : _collection_collection3.name,
                                            width: 24,
                                            height: 24
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                            style: "body1",
                                            css: {
                                                flex: 1
                                            },
                                            ellipsify: true,
                                            children: collection === null || collection === void 0 ? void 0 : (_collection_collection4 = collection.collection) === null || _collection_collection4 === void 0 ? void 0 : _collection_collection4.name
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenSeaVerified/* OpenSeaVerified */.v, {
                                            openseaVerificationStatus: collection === null || collection === void 0 ? void 0 : (_collection_collection5 = collection.collection) === null || _collection_collection5 === void 0 ? void 0 : _collection_collection5.openseaVerificationStatus
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                            style: "subtitle2",
                                            css: {
                                                color: "$gray10"
                                            },
                                            children: collection === null || collection === void 0 ? void 0 : (_collection_ownership = collection.ownership) === null || _collection_ownership === void 0 ? void 0 : _collection_ownership.tokenCount
                                        })
                                    ]
                                }, collection === null || collection === void 0 ? void 0 : (_collection_collection6 = collection.collection) === null || _collection_collection6 === void 0 ? void 0 : _collection_collection6.id);
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(common_LoadMoreCollections, {
                                loadMore: loadMoreCollections
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@radix-ui/react-collapsible/dist/index.module.js
var react_collapsible_dist_index_module = __webpack_require__(48133);
// EXTERNAL MODULE: ./components/primitives/Collapsible.tsx
var Collapsible = __webpack_require__(61194);
// EXTERNAL MODULE: ./components/primitives/PercentChange.tsx + 1 modules
var PercentChange = __webpack_require__(31561);
;// CONCATENATED MODULE: ./components/common/TokenFilters.tsx











const TokenFilters = (param)=>{
    let { open , setOpen , collections , filterCollection , setFilterCollection , isLoading , isOwner , scrollToTop , loadMoreCollections  } = param;
    if ((collections === null || collections === void 0 ? void 0 : collections.length) === 0 || collections == null || isLoading) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_collapsible_dist_index_module/* Root */.fC, {
        open: open,
        onOpenChange: setOpen,
        style: {
            transition: "width .5s",
            width: open ? 350 : 0,
            zIndex: 900
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapsible/* CollapsibleContent */.Fw, {
            css: {
                position: "sticky",
                top: 16 + 80,
                height: "calc(100vh - ".concat(navbar/* NAVBAR_HEIGHT */.ik, "px - ").concat(isOwner ? 90 : 32, ")"),
                overflow: "auto"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                direction: "column",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                        style: "subtitle1",
                        css: {
                            mb: "$2",
                            ml: "$3"
                        }
                    }),
                    collections === null || collections === void 0 ? void 0 : collections.map((collection)=>{
                        var _collection_collection, _collection_collection1, _collection_collection2, _collection_collection3, _collection_collection4, _collection_collection5, _collection_ownership, _collection_collection6, _collection_collection_floorAskPrice, _collection_collection_floorAskPrice_amount, _collection_collection7, _collection_collection_floorAskPrice1, _collection_collection_floorAskPrice_currency, _collection_collection8, _collection_collection_volumeChange, _collection_collection9;
                        let selected = (collection === null || collection === void 0 ? void 0 : (_collection_collection = collection.collection) === null || _collection_collection === void 0 ? void 0 : _collection_collection.id) == filterCollection;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                            css: {
                                py: "$2",
                                px: "$3",
                                gap: "$3",
                                borderRadius: "4px",
                                cursor: "pointer",
                                "&:hover": {
                                    backgroundColor: selected ? "$gray5" : "$gray4"
                                },
                                backgroundColor: selected ? "$gray5" : ""
                            },
                            align: "center",
                            onClick: ()=>{
                                if (selected) {
                                    setFilterCollection(undefined);
                                } else {
                                    var _collection_collection;
                                    setFilterCollection(collection === null || collection === void 0 ? void 0 : (_collection_collection = collection.collection) === null || _collection_collection === void 0 ? void 0 : _collection_collection.id);
                                }
                                scrollToTop === null || scrollToTop === void 0 ? void 0 : scrollToTop();
                            },
                            children: [
                                (collection === null || collection === void 0 ? void 0 : (_collection_collection1 = collection.collection) === null || _collection_collection1 === void 0 ? void 0 : _collection_collection1.image) && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    style: {
                                        borderRadius: "4px",
                                        objectFit: "cover",
                                        aspectRatio: "1/1"
                                    },
                                    loader: (param)=>{
                                        let { src  } = param;
                                        return src;
                                    },
                                    src: (0,optimizeImage/* default */.Z)(collection === null || collection === void 0 ? void 0 : (_collection_collection2 = collection.collection) === null || _collection_collection2 === void 0 ? void 0 : _collection_collection2.image, 250),
                                    alt: collection === null || collection === void 0 ? void 0 : (_collection_collection3 = collection.collection) === null || _collection_collection3 === void 0 ? void 0 : _collection_collection3.name,
                                    width: 24,
                                    height: 24
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                    direction: "column",
                                    css: {
                                        minWidth: 0
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                            css: {
                                                gap: "$1"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                    style: "body1",
                                                    css: {
                                                        flex: 1
                                                    },
                                                    ellipsify: true,
                                                    children: collection === null || collection === void 0 ? void 0 : (_collection_collection4 = collection.collection) === null || _collection_collection4 === void 0 ? void 0 : _collection_collection4.name
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenSeaVerified/* OpenSeaVerified */.v, {
                                                    openseaVerificationStatus: collection === null || collection === void 0 ? void 0 : (_collection_collection5 = collection.collection) === null || _collection_collection5 === void 0 ? void 0 : _collection_collection5.openseaVerificationStatus
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Text */.xv, {
                                            style: "subtitle3",
                                            css: {
                                                color: "$gray10"
                                            },
                                            children: [
                                                "Owned: ",
                                                (0,numbers/* formatNumber */.uf)(collection === null || collection === void 0 ? void 0 : (_collection_ownership = collection.ownership) === null || _collection_ownership === void 0 ? void 0 : _collection_ownership.tokenCount)
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                    direction: "column",
                                    css: {
                                        ml: "auto",
                                        flexShrink: 0,
                                        alignItems: "end"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                            css: {
                                                gap: "$1"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                    style: "subtitle2",
                                                    children: "Floor"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                                                    logoHeight: 15,
                                                    amount: (_collection_collection6 = collection.collection) === null || _collection_collection6 === void 0 ? void 0 : (_collection_collection_floorAskPrice = _collection_collection6.floorAskPrice) === null || _collection_collection_floorAskPrice === void 0 ? void 0 : (_collection_collection_floorAskPrice_amount = _collection_collection_floorAskPrice.amount) === null || _collection_collection_floorAskPrice_amount === void 0 ? void 0 : _collection_collection_floorAskPrice_amount.decimal,
                                                    address: (_collection_collection7 = collection.collection) === null || _collection_collection7 === void 0 ? void 0 : (_collection_collection_floorAskPrice1 = _collection_collection7.floorAskPrice) === null || _collection_collection_floorAskPrice1 === void 0 ? void 0 : (_collection_collection_floorAskPrice_currency = _collection_collection_floorAskPrice1.currency) === null || _collection_collection_floorAskPrice_currency === void 0 ? void 0 : _collection_collection_floorAskPrice_currency.contract,
                                                    textStyle: "subtitle2"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Tooltip */.u, {
                                            sideOffset: 2,
                                            side: "top",
                                            content: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                style: "body3",
                                                css: {
                                                    display: "block"
                                                },
                                                children: "24h Floor Price Change"
                                            }),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PercentChange/* PercentChange */.q, {
                                                    value: (_collection_collection8 = collection.collection) === null || _collection_collection8 === void 0 ? void 0 : (_collection_collection_volumeChange = _collection_collection8.volumeChange) === null || _collection_collection_volumeChange === void 0 ? void 0 : _collection_collection_volumeChange["1day"],
                                                    decimals: 1
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        }, collection === null || collection === void 0 ? void 0 : (_collection_collection9 = collection.collection) === null || _collection_collection9 === void 0 ? void 0 : _collection_collection9.id);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common_LoadMoreCollections, {
                        loadMore: loadMoreCollections
                    })
                ]
            })
        })
    }, "Token Filter");
};

// EXTERNAL MODULE: ./components/common/FilterButton.tsx
var FilterButton = __webpack_require__(57813);
// EXTERNAL MODULE: ./components/primitives/Img.tsx
var Img = __webpack_require__(68916);
;// CONCATENATED MODULE: ./components/portfolio/ListingsTable.tsx


















const ListingsTable_desktopTemplateColumns = "1.25fr .75fr repeat(4, 1fr)";
const ListingsTable = (param)=>{
    let { address , isOwner  } = param;
    const loadMoreRef = (0,react.useRef)(null);
    const loadMoreObserver = (0,esm/* useIntersectionObserver */.S1)(loadMoreRef, {});
    let listingsQuery = {
        maker: address,
        includeCriteriaMetadata: true,
        includeRawData: true
    };
    const { chain  } = (0,react.useContext)(ChainContextProvider/* ChainContext */.p);
    if (chain.community) listingsQuery.community = chain.community;
    const { data: listings , mutate , fetchNextPage , isFetchingPage , isValidating  } = (0,dist_index_module/* useListings */.Jn)(listingsQuery);
    (0,react.useEffect)(()=>{
        const isVisible = !!(loadMoreObserver === null || loadMoreObserver === void 0 ? void 0 : loadMoreObserver.isIntersecting);
        if (isVisible) {
            fetchNextPage();
        }
    }, [
        loadMoreObserver === null || loadMoreObserver === void 0 ? void 0 : loadMoreObserver.isIntersecting
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !isValidating && !isFetchingPage && listings && listings.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                direction: "column",
                align: "center",
                css: {
                    py: "$6",
                    gap: "$4",
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                        css: {
                            color: "$gray11"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                            icon: free_solid_svg_icons/* faTag */.LEN,
                            size: "2xl"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                        css: {
                            color: "$gray11"
                        },
                        children: "No listings yet"
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                direction: "column",
                css: {
                    width: "100%",
                    pb: "$2"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ListingsTable_TableHeading, {}),
                    listings.map((listing, i)=>{
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListingTableRow, {
                            listing: listing,
                            isOwner: isOwner,
                            mutate: mutate
                        }, "".concat(listing === null || listing === void 0 ? void 0 : listing.id, "-").concat(i));
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                        ref: loadMoreRef,
                        css: {
                            height: 20
                        }
                    })
                ]
            }),
            isValidating && /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                align: "center",
                justify: "center",
                css: {
                    py: "$5"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpinner/* default */.Z, {})
            })
        ]
    });
};
const ListingTableRow = (param)=>{
    let { listing , isOwner , mutate  } = param;
    var _listing_criteria, _criteriaData_token, _criteriaData_token1, _criteriaData_collection, _criteriaData_token2, _criteriaData_token3, _criteriaData_collection1, _criteriaData_token4, _listing_price, _listing_price_amount, _listing_price1, _listing_price_currency, _listing_source, _listing_source1, _listing_source2, _listing_source3, _listing_criteria1, _listing_criteria_data, _listing_criteria_data_token, _listing_criteria2, _listing_criteria_data1, _listing_criteria_data_collection;
    const isSmallDevice = (0,react_responsive.useMediaQuery)({
        maxWidth: 900
    });
    const { routePrefix  } = (0,hooks/* useMarketplaceChain */.gw)();
    const expiration = (0,hooks/* useTimeSince */.vS)(listing === null || listing === void 0 ? void 0 : listing.expiration);
    const isOracleOrder = listing === null || listing === void 0 ? void 0 : listing.isNativeOffChainCancellable;
    let criteriaData = listing === null || listing === void 0 ? void 0 : (_listing_criteria = listing.criteria) === null || _listing_criteria === void 0 ? void 0 : _listing_criteria.data;
    const imageSrc = (0,react.useMemo)(()=>{
        var _criteriaData_token, _criteriaData_token1, _criteriaData_collection, _criteriaData_collection1;
        return (0,optimizeImage/* default */.Z)((criteriaData === null || criteriaData === void 0 ? void 0 : (_criteriaData_token = criteriaData.token) === null || _criteriaData_token === void 0 ? void 0 : _criteriaData_token.tokenId) ? (criteriaData === null || criteriaData === void 0 ? void 0 : (_criteriaData_token1 = criteriaData.token) === null || _criteriaData_token1 === void 0 ? void 0 : _criteriaData_token1.image) || (criteriaData === null || criteriaData === void 0 ? void 0 : (_criteriaData_collection = criteriaData.collection) === null || _criteriaData_collection === void 0 ? void 0 : _criteriaData_collection.image) : criteriaData === null || criteriaData === void 0 ? void 0 : (_criteriaData_collection1 = criteriaData.collection) === null || _criteriaData_collection1 === void 0 ? void 0 : _criteriaData_collection1.image, 250);
    }, [
        criteriaData === null || criteriaData === void 0 ? void 0 : (_criteriaData_token = criteriaData.token) === null || _criteriaData_token === void 0 ? void 0 : _criteriaData_token.tokenId,
        criteriaData === null || criteriaData === void 0 ? void 0 : (_criteriaData_token1 = criteriaData.token) === null || _criteriaData_token1 === void 0 ? void 0 : _criteriaData_token1.image,
        criteriaData === null || criteriaData === void 0 ? void 0 : (_criteriaData_collection = criteriaData.collection) === null || _criteriaData_collection === void 0 ? void 0 : _criteriaData_collection.image
    ]);
    if (isSmallDevice) {
        var _criteriaData_token5, _criteriaData_collection2, _criteriaData_token6, _listing_price2, _listing_price_amount1, _listing_price3, _listing_price_currency1, _listing_source4, _listing_source5, _listing_source6, _listing_criteria3, _listing_criteria_data2, _listing_criteria_data_token1, _listing_criteria4, _listing_criteria_data3, _listing_criteria_data_collection1;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
            direction: "column",
            align: "start",
            css: {
                gap: "$3",
                borderBottom: "1px solid $gray3",
                py: "$3",
                width: "100%",
                overflow: "hidden",
                flex: 1
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                    justify: "between",
                    css: {
                        width: "100%"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/".concat(routePrefix, "/asset/").concat(listing === null || listing === void 0 ? void 0 : listing.contract, ":").concat(criteriaData === null || criteriaData === void 0 ? void 0 : (_criteriaData_token5 = criteriaData.token) === null || _criteriaData_token5 === void 0 ? void 0 : _criteriaData_token5.tokenId),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Img/* default */.Z, {
                                        css: {
                                            borderRadius: "4px",
                                            objectFit: "cover",
                                            aspectRatio: "1/1"
                                        },
                                        loader: (param)=>{
                                            let { src  } = param;
                                            return src;
                                        },
                                        src: imageSrc,
                                        alt: "".concat(listing === null || listing === void 0 ? void 0 : listing.id),
                                        width: 36,
                                        height: 36
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                        direction: "column",
                                        css: {
                                            ml: "$2",
                                            overflow: "hidden",
                                            minWidth: 0
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                style: "subtitle3",
                                                ellipsify: true,
                                                css: {
                                                    color: "$gray11"
                                                },
                                                children: criteriaData === null || criteriaData === void 0 ? void 0 : (_criteriaData_collection2 = criteriaData.collection) === null || _criteriaData_collection2 === void 0 ? void 0 : _criteriaData_collection2.name
                                            }),
                                            (listing === null || listing === void 0 ? void 0 : listing.quantityRemaining) && (listing === null || listing === void 0 ? void 0 : listing.quantityRemaining) > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                                css: {
                                                    gap: "$2"
                                                },
                                                align: "center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Text */.xv, {
                                                        style: "subtitle2",
                                                        ellipsify: true,
                                                        children: [
                                                            "#",
                                                            criteriaData === null || criteriaData === void 0 ? void 0 : (_criteriaData_token6 = criteriaData.token) === null || _criteriaData_token6 === void 0 ? void 0 : _criteriaData_token6.tokenId
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                                                        justify: "center",
                                                        align: "center",
                                                        css: {
                                                            borderRadius: 4,
                                                            px: "$2",
                                                            py: "$1",
                                                            ml: "$1",
                                                            backgroundColor: "$gray2"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Text */.xv, {
                                                            style: "subtitle2",
                                                            color: "subtle",
                                                            children: [
                                                                "x",
                                                                (0,numbers/* formatNumber */.uf)(listing.quantityRemaining, 0, true)
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }) : null
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                            amount: listing === null || listing === void 0 ? void 0 : (_listing_price2 = listing.price) === null || _listing_price2 === void 0 ? void 0 : (_listing_price_amount1 = _listing_price2.amount) === null || _listing_price_amount1 === void 0 ? void 0 : _listing_price_amount1.decimal,
                            address: listing === null || listing === void 0 ? void 0 : (_listing_price3 = listing.price) === null || _listing_price3 === void 0 ? void 0 : (_listing_price_currency1 = _listing_price3.currency) === null || _listing_price_currency1 === void 0 ? void 0 : _listing_price_currency1.contract,
                            textStyle: "subtitle2",
                            logoHeight: 14
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                    justify: "between",
                    align: "center",
                    css: {
                        width: "100%"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "https://".concat(listing === null || listing === void 0 ? void 0 : (_listing_source4 = listing.source) === null || _listing_source4 === void 0 ? void 0 : _listing_source4.domain),
                            target: "_blank",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                align: "center",
                                css: {
                                    gap: "$2"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        width: "20px",
                                        height: "20px",
                                        src: (listing === null || listing === void 0 ? void 0 : (_listing_source5 = listing.source) === null || _listing_source5 === void 0 ? void 0 : _listing_source5.icon) || "",
                                        alt: "".concat(listing === null || listing === void 0 ? void 0 : (_listing_source6 = listing.source) === null || _listing_source6 === void 0 ? void 0 : _listing_source6.name)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                        style: "subtitle2",
                                        children: expiration
                                    })
                                ]
                            })
                        }),
                        isOwner ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CancelListing/* default */.Z, {
                            listingId: listing === null || listing === void 0 ? void 0 : listing.id,
                            mutate: mutate,
                            trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                                children: !isOracleOrder ? /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Tooltip */.u, {
                                    content: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                        style: "body3",
                                        as: "p",
                                        children: "Cancelling this order requires gas."
                                    }),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Button */.zx, {
                                        css: {
                                            color: "$red11",
                                            minWidth: "150px",
                                            justifyContent: "center"
                                        },
                                        color: "gray3",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                color: "#697177",
                                                icon: free_solid_svg_icons/* faGasPump */.q16,
                                                width: "16",
                                                height: "16"
                                            }),
                                            "Cancel"
                                        ]
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                                    css: {
                                        color: "$red11",
                                        minWidth: "150px",
                                        justifyContent: "center"
                                    },
                                    color: "gray3",
                                    children: "Cancel"
                                })
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons/* BuyNow */.Wg, {
                            tokenId: listing === null || listing === void 0 ? void 0 : (_listing_criteria3 = listing.criteria) === null || _listing_criteria3 === void 0 ? void 0 : (_listing_criteria_data2 = _listing_criteria3.data) === null || _listing_criteria_data2 === void 0 ? void 0 : (_listing_criteria_data_token1 = _listing_criteria_data2.token) === null || _listing_criteria_data_token1 === void 0 ? void 0 : _listing_criteria_data_token1.tokenId,
                            collectionId: listing === null || listing === void 0 ? void 0 : (_listing_criteria4 = listing.criteria) === null || _listing_criteria4 === void 0 ? void 0 : (_listing_criteria_data3 = _listing_criteria4.data) === null || _listing_criteria_data3 === void 0 ? void 0 : (_listing_criteria_data_collection1 = _listing_criteria_data3.collection) === null || _listing_criteria_data_collection1 === void 0 ? void 0 : _listing_criteria_data_collection1.id,
                            orderId: listing === null || listing === void 0 ? void 0 : listing.id,
                            mutate: mutate,
                            buttonCss: {
                                minWidth: "150px",
                                justifyContent: "center"
                            },
                            buttonChildren: "Buy Now"
                        })
                    ]
                })
            ]
        }, listing === null || listing === void 0 ? void 0 : listing.id);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* TableRow */.SC, {
        css: {
            gridTemplateColumns: ListingsTable_desktopTemplateColumns
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                css: {
                    minWidth: 0
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/".concat(routePrefix, "/asset/").concat(listing === null || listing === void 0 ? void 0 : listing.contract, ":").concat(criteriaData === null || criteriaData === void 0 ? void 0 : (_criteriaData_token2 = criteriaData.token) === null || _criteriaData_token2 === void 0 ? void 0 : _criteriaData_token2.tokenId),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Img/* default */.Z, {
                                css: {
                                    borderRadius: "4px",
                                    objectFit: "cover",
                                    aspectRatio: "1/1"
                                },
                                loader: (param)=>{
                                    let { src  } = param;
                                    return src;
                                },
                                src: imageSrc,
                                alt: "".concat(criteriaData === null || criteriaData === void 0 ? void 0 : (_criteriaData_token3 = criteriaData.token) === null || _criteriaData_token3 === void 0 ? void 0 : _criteriaData_token3.name),
                                width: 48,
                                height: 48
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                direction: "column",
                                css: {
                                    ml: "$2",
                                    overflow: "hidden"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                        style: "subtitle3",
                                        ellipsify: true,
                                        css: {
                                            color: "$gray11"
                                        },
                                        children: criteriaData === null || criteriaData === void 0 ? void 0 : (_criteriaData_collection1 = criteriaData.collection) === null || _criteriaData_collection1 === void 0 ? void 0 : _criteriaData_collection1.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Text */.xv, {
                                        style: "subtitle2",
                                        ellipsify: true,
                                        children: [
                                            "#",
                                            criteriaData === null || criteriaData === void 0 ? void 0 : (_criteriaData_token4 = criteriaData.token) === null || _criteriaData_token4 === void 0 ? void 0 : _criteriaData_token4.tokenId
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                    amount: listing === null || listing === void 0 ? void 0 : (_listing_price = listing.price) === null || _listing_price === void 0 ? void 0 : (_listing_price_amount = _listing_price.amount) === null || _listing_price_amount === void 0 ? void 0 : _listing_price_amount.decimal,
                    address: listing === null || listing === void 0 ? void 0 : (_listing_price1 = listing.price) === null || _listing_price1 === void 0 ? void 0 : (_listing_price_currency = _listing_price1.currency) === null || _listing_price_currency === void 0 ? void 0 : _listing_price_currency.contract,
                    textStyle: "subtitle2",
                    logoHeight: 14
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                    style: "subtitle2",
                    children: (0,numbers/* formatNumber */.uf)(listing.quantityRemaining)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                    style: "subtitle2",
                    children: expiration
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                    align: "center",
                    css: {
                        gap: "$2"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            width: "20px",
                            height: "20px",
                            src: (listing === null || listing === void 0 ? void 0 : (_listing_source = listing.source) === null || _listing_source === void 0 ? void 0 : _listing_source.icon) || "",
                            alt: "".concat(listing === null || listing === void 0 ? void 0 : (_listing_source1 = listing.source) === null || _listing_source1 === void 0 ? void 0 : _listing_source1.name)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Anchor */.ee, {
                            href: "https://".concat(listing === null || listing === void 0 ? void 0 : (_listing_source2 = listing.source) === null || _listing_source2 === void 0 ? void 0 : _listing_source2.domain),
                            target: "_blank",
                            color: "primary",
                            weight: "normal",
                            children: listing === null || listing === void 0 ? void 0 : (_listing_source3 = listing.source) === null || _listing_source3 === void 0 ? void 0 : _listing_source3.name
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                    justify: "end",
                    children: isOwner ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CancelListing/* default */.Z, {
                        listingId: listing === null || listing === void 0 ? void 0 : listing.id,
                        mutate: mutate,
                        trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                            children: !isOracleOrder ? /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Tooltip */.u, {
                                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                    style: "body3",
                                    as: "p",
                                    children: "Cancelling this order requires gas."
                                }),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Button */.zx, {
                                    css: {
                                        color: "$red11",
                                        minWidth: "150px",
                                        justifyContent: "center"
                                    },
                                    color: "gray3",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                            color: "#697177",
                                            icon: free_solid_svg_icons/* faGasPump */.q16,
                                            width: "16",
                                            height: "16"
                                        }),
                                        "Cancel"
                                    ]
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                                css: {
                                    color: "$red11",
                                    minWidth: "150px",
                                    justifyContent: "center"
                                },
                                color: "gray3",
                                children: "Cancel"
                            })
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons/* BuyNow */.Wg, {
                        tokenId: listing === null || listing === void 0 ? void 0 : (_listing_criteria1 = listing.criteria) === null || _listing_criteria1 === void 0 ? void 0 : (_listing_criteria_data = _listing_criteria1.data) === null || _listing_criteria_data === void 0 ? void 0 : (_listing_criteria_data_token = _listing_criteria_data.token) === null || _listing_criteria_data_token === void 0 ? void 0 : _listing_criteria_data_token.tokenId,
                        collectionId: listing === null || listing === void 0 ? void 0 : (_listing_criteria2 = listing.criteria) === null || _listing_criteria2 === void 0 ? void 0 : (_listing_criteria_data1 = _listing_criteria2.data) === null || _listing_criteria_data1 === void 0 ? void 0 : (_listing_criteria_data_collection = _listing_criteria_data1.collection) === null || _listing_criteria_data_collection === void 0 ? void 0 : _listing_criteria_data_collection.id,
                        orderId: listing === null || listing === void 0 ? void 0 : listing.id,
                        mutate: mutate,
                        buttonCss: {
                            minWidth: "150px",
                            justifyContent: "center"
                        },
                        buttonChildren: "Buy Now"
                    })
                })
            })
        ]
    }, listing === null || listing === void 0 ? void 0 : listing.id);
};
const headings = [
    "Items",
    "Listed Price",
    "Quantity",
    "Expiration",
    "Marketplace",
    ""
];
const ListingsTable_TableHeading = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* HeaderRow */.VJ, {
        css: {
            display: "none",
            "@md": {
                display: "grid"
            },
            gridTemplateColumns: ListingsTable_desktopTemplateColumns,
            position: "sticky",
            top: navbar/* NAVBAR_HEIGHT */.ik,
            backgroundColor: "$neutralBg"
        },
        children: headings.map((heading)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                    style: "subtitle3",
                    color: "subtle",
                    children: heading
                })
            }, heading))
    });

// EXTERNAL MODULE: ./components/buttons/CancelBid.tsx
var CancelBid = __webpack_require__(61818);
;// CONCATENATED MODULE: ./components/portfolio/OffersTable.tsx

















const OffersTable_desktopTemplateColumns = "1.25fr .75fr repeat(4, 1fr)";
const OffersTable = (param)=>{
    let { address , isOwner  } = param;
    const loadMoreRef = (0,react.useRef)(null);
    const loadMoreObserver = (0,esm/* useIntersectionObserver */.S1)(loadMoreRef, {});
    let bidsQuery = {
        maker: address,
        includeCriteriaMetadata: true,
        includeRawData: true
    };
    const { chain  } = (0,react.useContext)(ChainContextProvider/* ChainContext */.p);
    if (chain.community) bidsQuery.community = chain.community;
    const { data: offers , fetchNextPage , mutate , isValidating , isFetchingPage  } = (0,dist_index_module/* useBids */.Lk)(bidsQuery);
    (0,react.useEffect)(()=>{
        const isVisible = !!(loadMoreObserver === null || loadMoreObserver === void 0 ? void 0 : loadMoreObserver.isIntersecting);
        if (isVisible) {
            fetchNextPage();
        }
    }, [
        loadMoreObserver === null || loadMoreObserver === void 0 ? void 0 : loadMoreObserver.isIntersecting
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !isValidating && !isFetchingPage && offers && offers.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                direction: "column",
                align: "center",
                css: {
                    py: "$6",
                    gap: "$4",
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                        css: {
                            color: "$gray11"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                            icon: free_solid_svg_icons/* faHand */.ioV,
                            size: "2xl"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                        css: {
                            color: "$gray11"
                        },
                        children: "No offers made yet"
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                direction: "column",
                css: {
                    width: "100%",
                    pb: "$2"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OffersTable_TableHeading, {}),
                    offers.map((offer, i)=>{
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferTableRow, {
                            offer: offer,
                            isOwner: isOwner,
                            mutate: mutate
                        }, "".concat(offer === null || offer === void 0 ? void 0 : offer.id, "-").concat(i));
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                        ref: loadMoreRef,
                        css: {
                            height: 20
                        }
                    })
                ]
            }),
            isValidating && /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                align: "center",
                justify: "center",
                css: {
                    py: "$5"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpinner/* default */.Z, {})
            })
        ]
    });
};
const OfferTableRow = (param)=>{
    let { offer , isOwner , mutate  } = param;
    var _offer_criteria, _offer_criteria1, _offer_criteria_data, _offer_criteria2, _criteriaData_token, _criteriaData_token1, _criteriaData_collection, _criteriaData_token2, _criteriaData_token3, _criteriaData_collection1, _criteriaData_token4, _offer_price, _offer_price_netAmount, _offer_price1, _offer_price_netAmount1, _offer_price2, _offer_price_currency, _offer_price3, _offer_price_currency1, _offer_price4, _offer_price_amount, _offer_price5, _offer_price_currency2, _offer_price6, _offer_price_currency3, _offer_source, _offer_source1, _offer_source2, _offer_source3;
    const isSmallDevice = (0,react_responsive.useMediaQuery)({
        maxWidth: 900
    });
    const { routePrefix  } = (0,hooks/* useMarketplaceChain */.gw)();
    const expiration = (0,hooks/* useTimeSince */.vS)(offer === null || offer === void 0 ? void 0 : offer.expiration);
    const isOracleOrder = offer === null || offer === void 0 ? void 0 : offer.isNativeOffChainCancellable;
    const isCollectionOffer = (offer === null || offer === void 0 ? void 0 : (_offer_criteria = offer.criteria) === null || _offer_criteria === void 0 ? void 0 : _offer_criteria.kind) !== "token";
    // @ts-ignore
    const attribute = offer === null || offer === void 0 ? void 0 : (_offer_criteria1 = offer.criteria) === null || _offer_criteria1 === void 0 ? void 0 : (_offer_criteria_data = _offer_criteria1.data) === null || _offer_criteria_data === void 0 ? void 0 : _offer_criteria_data.attribute;
    const attributeQueryParam = attribute ? "?attributes[".concat(attribute.key, "]=").concat(attribute.value) : "";
    const attributeDisplayText = attribute ? "".concat(attribute === null || attribute === void 0 ? void 0 : attribute.key, ": ").concat(attribute === null || attribute === void 0 ? void 0 : attribute.value) : "";
    let criteriaData = offer === null || offer === void 0 ? void 0 : (_offer_criteria2 = offer.criteria) === null || _offer_criteria2 === void 0 ? void 0 : _offer_criteria2.data;
    const imageSrc = (0,react.useMemo)(()=>{
        var _criteriaData_token, _criteriaData_token1, _criteriaData_collection, _criteriaData_collection1;
        return (0,optimizeImage/* default */.Z)((criteriaData === null || criteriaData === void 0 ? void 0 : (_criteriaData_token = criteriaData.token) === null || _criteriaData_token === void 0 ? void 0 : _criteriaData_token.tokenId) ? (criteriaData === null || criteriaData === void 0 ? void 0 : (_criteriaData_token1 = criteriaData.token) === null || _criteriaData_token1 === void 0 ? void 0 : _criteriaData_token1.image) || (criteriaData === null || criteriaData === void 0 ? void 0 : (_criteriaData_collection = criteriaData.collection) === null || _criteriaData_collection === void 0 ? void 0 : _criteriaData_collection.image) : criteriaData === null || criteriaData === void 0 ? void 0 : (_criteriaData_collection1 = criteriaData.collection) === null || _criteriaData_collection1 === void 0 ? void 0 : _criteriaData_collection1.image, 250);
    }, [
        criteriaData === null || criteriaData === void 0 ? void 0 : (_criteriaData_token = criteriaData.token) === null || _criteriaData_token === void 0 ? void 0 : _criteriaData_token.tokenId,
        criteriaData === null || criteriaData === void 0 ? void 0 : (_criteriaData_token1 = criteriaData.token) === null || _criteriaData_token1 === void 0 ? void 0 : _criteriaData_token1.image,
        criteriaData === null || criteriaData === void 0 ? void 0 : (_criteriaData_collection = criteriaData.collection) === null || _criteriaData_collection === void 0 ? void 0 : _criteriaData_collection.image
    ]);
    if (isSmallDevice) {
        var _criteriaData_token5, _criteriaData_collection2, _criteriaData_token6, _offer_price7, _offer_price_netAmount2, _offer_price8, _offer_price_netAmount3, _offer_price9, _offer_price_currency4, _offer_price10, _offer_price_currency5, _offer_price11, _offer_price_amount1, _offer_price12, _offer_price_currency6, _offer_price13, _offer_price_currency7, _offer_source4, _offer_source5, _offer_source6;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
            direction: "column",
            align: "start",
            css: {
                gap: "$3",
                borderBottom: "1px solid $gray3",
                py: "$3",
                width: "100%",
                overflow: "hidden",
                flex: 1
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                    justify: "between",
                    css: {
                        width: "100%"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: isCollectionOffer ? "/".concat(routePrefix, "/collection/").concat(offer === null || offer === void 0 ? void 0 : offer.contract).concat(attributeQueryParam) : "/".concat(routePrefix, "/asset/").concat(offer === null || offer === void 0 ? void 0 : offer.contract, ":").concat(criteriaData === null || criteriaData === void 0 ? void 0 : (_criteriaData_token5 = criteriaData.token) === null || _criteriaData_token5 === void 0 ? void 0 : _criteriaData_token5.tokenId),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Img/* default */.Z, {
                                        css: {
                                            borderRadius: "4px",
                                            objectFit: "cover",
                                            aspectRatio: "1/1"
                                        },
                                        loader: (param)=>{
                                            let { src  } = param;
                                            return src;
                                        },
                                        src: imageSrc,
                                        alt: "".concat(offer === null || offer === void 0 ? void 0 : offer.id),
                                        width: 36,
                                        height: 36
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                        direction: "column",
                                        css: {
                                            ml: "$2",
                                            overflow: "hidden",
                                            minWidth: 0
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                style: "subtitle3",
                                                ellipsify: true,
                                                css: {
                                                    color: "$gray11"
                                                },
                                                children: criteriaData === null || criteriaData === void 0 ? void 0 : (_criteriaData_collection2 = criteriaData.collection) === null || _criteriaData_collection2 === void 0 ? void 0 : _criteriaData_collection2.name
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                                css: {
                                                    gap: "$2"
                                                },
                                                align: "center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                        style: "subtitle2",
                                                        ellipsify: true,
                                                        children: isCollectionOffer ? attributeDisplayText : "#".concat(criteriaData === null || criteriaData === void 0 ? void 0 : (_criteriaData_token6 = criteriaData.token) === null || _criteriaData_token6 === void 0 ? void 0 : _criteriaData_token6.tokenId)
                                                    }),
                                                    (offer === null || offer === void 0 ? void 0 : offer.quantityRemaining) && (offer === null || offer === void 0 ? void 0 : offer.quantityRemaining) > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                                                        justify: "center",
                                                        align: "center",
                                                        css: {
                                                            borderRadius: 4,
                                                            px: "$2",
                                                            py: "$1",
                                                            ml: "$1",
                                                            backgroundColor: "$gray2"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Text */.xv, {
                                                            style: "subtitle2",
                                                            color: "subtle",
                                                            children: [
                                                                "x",
                                                                (0,numbers/* formatNumber */.uf)(offer.quantityRemaining, 0, true)
                                                            ]
                                                        })
                                                    }) : null
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Tooltip */.u, {
                            side: "left",
                            sideOffset: "1",
                            open: (offer === null || offer === void 0 ? void 0 : (_offer_price7 = offer.price) === null || _offer_price7 === void 0 ? void 0 : (_offer_price_netAmount2 = _offer_price7.netAmount) === null || _offer_price_netAmount2 === void 0 ? void 0 : _offer_price_netAmount2.decimal) ? undefined : false,
                            content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                justify: "between",
                                css: {
                                    gap: "$2"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                        style: "body3",
                                        children: "Net Amount"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                                        amount: offer === null || offer === void 0 ? void 0 : (_offer_price8 = offer.price) === null || _offer_price8 === void 0 ? void 0 : (_offer_price_netAmount3 = _offer_price8.netAmount) === null || _offer_price_netAmount3 === void 0 ? void 0 : _offer_price_netAmount3.decimal,
                                        address: offer === null || offer === void 0 ? void 0 : (_offer_price9 = offer.price) === null || _offer_price9 === void 0 ? void 0 : (_offer_price_currency4 = _offer_price9.currency) === null || _offer_price_currency4 === void 0 ? void 0 : _offer_price_currency4.contract,
                                        decimals: offer === null || offer === void 0 ? void 0 : (_offer_price10 = offer.price) === null || _offer_price10 === void 0 ? void 0 : (_offer_price_currency5 = _offer_price10.currency) === null || _offer_price_currency5 === void 0 ? void 0 : _offer_price_currency5.decimals,
                                        textStyle: "subtitle3",
                                        logoHeight: 14
                                    })
                                ]
                            }),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                                    amount: offer === null || offer === void 0 ? void 0 : (_offer_price11 = offer.price) === null || _offer_price11 === void 0 ? void 0 : (_offer_price_amount1 = _offer_price11.amount) === null || _offer_price_amount1 === void 0 ? void 0 : _offer_price_amount1.decimal,
                                    address: offer === null || offer === void 0 ? void 0 : (_offer_price12 = offer.price) === null || _offer_price12 === void 0 ? void 0 : (_offer_price_currency6 = _offer_price12.currency) === null || _offer_price_currency6 === void 0 ? void 0 : _offer_price_currency6.contract,
                                    decimals: offer === null || offer === void 0 ? void 0 : (_offer_price13 = offer.price) === null || _offer_price13 === void 0 ? void 0 : (_offer_price_currency7 = _offer_price13.currency) === null || _offer_price_currency7 === void 0 ? void 0 : _offer_price_currency7.decimals,
                                    textStyle: "subtitle2",
                                    logoHeight: 14
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                    justify: "between",
                    align: "center",
                    css: {
                        width: "100%"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "https://".concat(offer === null || offer === void 0 ? void 0 : (_offer_source4 = offer.source) === null || _offer_source4 === void 0 ? void 0 : _offer_source4.domain),
                            target: "_blank",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                align: "center",
                                css: {
                                    gap: "$2"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        width: "20px",
                                        height: "20px",
                                        src: (offer === null || offer === void 0 ? void 0 : (_offer_source5 = offer.source) === null || _offer_source5 === void 0 ? void 0 : _offer_source5.icon) || "",
                                        alt: "".concat(offer === null || offer === void 0 ? void 0 : (_offer_source6 = offer.source) === null || _offer_source6 === void 0 ? void 0 : _offer_source6.name)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                        style: "subtitle2",
                                        children: expiration
                                    })
                                ]
                            })
                        }),
                        isOwner ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CancelBid/* default */.Z, {
                            bidId: offer === null || offer === void 0 ? void 0 : offer.id,
                            mutate: mutate,
                            trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                                children: !isOracleOrder ? /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Tooltip */.u, {
                                    content: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                        style: "body3",
                                        as: "p",
                                        children: "Cancelling this order requires gas."
                                    }),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Button */.zx, {
                                        css: {
                                            color: "$red11",
                                            minWidth: "150px",
                                            justifyContent: "center"
                                        },
                                        color: "gray3",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                color: "#697177",
                                                icon: free_solid_svg_icons/* faGasPump */.q16,
                                                width: "16",
                                                height: "16"
                                            }),
                                            "Cancel"
                                        ]
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                                    css: {
                                        color: "$red11",
                                        minWidth: "150px",
                                        justifyContent: "center"
                                    },
                                    color: "gray3",
                                    children: "Cancel"
                                })
                            })
                        }) : null
                    ]
                })
            ]
        }, offer === null || offer === void 0 ? void 0 : offer.id);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* TableRow */.SC, {
        css: {
            gridTemplateColumns: OffersTable_desktopTemplateColumns
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                css: {
                    minWidth: 0
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: isCollectionOffer ? "/".concat(routePrefix, "/collection/").concat(offer === null || offer === void 0 ? void 0 : offer.contract).concat(attributeQueryParam) : "/".concat(routePrefix, "/asset/").concat(offer === null || offer === void 0 ? void 0 : offer.contract, ":").concat(criteriaData === null || criteriaData === void 0 ? void 0 : (_criteriaData_token2 = criteriaData.token) === null || _criteriaData_token2 === void 0 ? void 0 : _criteriaData_token2.tokenId),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Img/* default */.Z, {
                                css: {
                                    borderRadius: "4px",
                                    objectFit: "cover",
                                    aspectRatio: "1/1"
                                },
                                loader: (param)=>{
                                    let { src  } = param;
                                    return src;
                                },
                                src: imageSrc,
                                alt: "".concat(criteriaData === null || criteriaData === void 0 ? void 0 : (_criteriaData_token3 = criteriaData.token) === null || _criteriaData_token3 === void 0 ? void 0 : _criteriaData_token3.name),
                                width: 48,
                                height: 48
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                direction: "column",
                                css: {
                                    ml: "$2",
                                    overflow: "hidden"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                        style: "subtitle3",
                                        ellipsify: true,
                                        css: {
                                            color: "$gray11"
                                        },
                                        children: criteriaData === null || criteriaData === void 0 ? void 0 : (_criteriaData_collection1 = criteriaData.collection) === null || _criteriaData_collection1 === void 0 ? void 0 : _criteriaData_collection1.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                        style: "subtitle2",
                                        ellipsify: true,
                                        children: isCollectionOffer ? attributeDisplayText : "#".concat(criteriaData === null || criteriaData === void 0 ? void 0 : (_criteriaData_token4 = criteriaData.token) === null || _criteriaData_token4 === void 0 ? void 0 : _criteriaData_token4.tokenId)
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Tooltip */.u, {
                    side: "left",
                    sideOffset: "1",
                    open: (offer === null || offer === void 0 ? void 0 : (_offer_price = offer.price) === null || _offer_price === void 0 ? void 0 : (_offer_price_netAmount = _offer_price.netAmount) === null || _offer_price_netAmount === void 0 ? void 0 : _offer_price_netAmount.decimal) ? undefined : false,
                    content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        justify: "between",
                        css: {
                            gap: "$2"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                style: "body3",
                                children: "Net Amount"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                                amount: offer === null || offer === void 0 ? void 0 : (_offer_price1 = offer.price) === null || _offer_price1 === void 0 ? void 0 : (_offer_price_netAmount1 = _offer_price1.netAmount) === null || _offer_price_netAmount1 === void 0 ? void 0 : _offer_price_netAmount1.decimal,
                                address: offer === null || offer === void 0 ? void 0 : (_offer_price2 = offer.price) === null || _offer_price2 === void 0 ? void 0 : (_offer_price_currency = _offer_price2.currency) === null || _offer_price_currency === void 0 ? void 0 : _offer_price_currency.contract,
                                decimals: offer === null || offer === void 0 ? void 0 : (_offer_price3 = offer.price) === null || _offer_price3 === void 0 ? void 0 : (_offer_price_currency1 = _offer_price3.currency) === null || _offer_price_currency1 === void 0 ? void 0 : _offer_price_currency1.decimals,
                                textStyle: "subtitle3",
                                logoHeight: 14
                            })
                        ]
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                            amount: offer === null || offer === void 0 ? void 0 : (_offer_price4 = offer.price) === null || _offer_price4 === void 0 ? void 0 : (_offer_price_amount = _offer_price4.amount) === null || _offer_price_amount === void 0 ? void 0 : _offer_price_amount.decimal,
                            address: offer === null || offer === void 0 ? void 0 : (_offer_price5 = offer.price) === null || _offer_price5 === void 0 ? void 0 : (_offer_price_currency2 = _offer_price5.currency) === null || _offer_price_currency2 === void 0 ? void 0 : _offer_price_currency2.contract,
                            decimals: offer === null || offer === void 0 ? void 0 : (_offer_price6 = offer.price) === null || _offer_price6 === void 0 ? void 0 : (_offer_price_currency3 = _offer_price6.currency) === null || _offer_price_currency3 === void 0 ? void 0 : _offer_price_currency3.decimals,
                            textStyle: "subtitle1",
                            logoHeight: 14
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                    style: "subtitle2",
                    children: (0,numbers/* formatNumber */.uf)(offer.quantityRemaining, 0, true)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                    style: "subtitle2",
                    children: expiration
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                    align: "center",
                    css: {
                        gap: "$2"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            width: "20px",
                            height: "20px",
                            src: (offer === null || offer === void 0 ? void 0 : (_offer_source = offer.source) === null || _offer_source === void 0 ? void 0 : _offer_source.icon) || "",
                            alt: "".concat(offer === null || offer === void 0 ? void 0 : (_offer_source1 = offer.source) === null || _offer_source1 === void 0 ? void 0 : _offer_source1.name)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Anchor */.ee, {
                            href: "https://".concat(offer === null || offer === void 0 ? void 0 : (_offer_source2 = offer.source) === null || _offer_source2 === void 0 ? void 0 : _offer_source2.domain),
                            target: "_blank",
                            color: "primary",
                            weight: "normal",
                            children: offer === null || offer === void 0 ? void 0 : (_offer_source3 = offer.source) === null || _offer_source3 === void 0 ? void 0 : _offer_source3.name
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                    justify: "end",
                    children: isOwner ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CancelBid/* default */.Z, {
                        bidId: offer === null || offer === void 0 ? void 0 : offer.id,
                        mutate: mutate,
                        trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                            children: !isOracleOrder ? /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Tooltip */.u, {
                                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                    style: "body3",
                                    as: "p",
                                    children: "Cancelling this order requires gas."
                                }),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Button */.zx, {
                                    css: {
                                        color: "$red11",
                                        minWidth: "150px",
                                        justifyContent: "center"
                                    },
                                    color: "gray3",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                            color: "#697177",
                                            icon: free_solid_svg_icons/* faGasPump */.q16,
                                            width: "16",
                                            height: "16"
                                        }),
                                        "Cancel"
                                    ]
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                                css: {
                                    color: "$red11",
                                    minWidth: "150px",
                                    justifyContent: "center"
                                },
                                color: "gray3",
                                children: "Cancel"
                            })
                        })
                    }) : null
                })
            })
        ]
    }, offer === null || offer === void 0 ? void 0 : offer.id);
};
const OffersTable_headings = [
    "Items",
    "Offer Amount",
    "Quantity",
    "Expiration",
    "Marketplace",
    ""
];
const OffersTable_TableHeading = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* HeaderRow */.VJ, {
        css: {
            display: "none",
            "@md": {
                display: "grid"
            },
            gridTemplateColumns: OffersTable_desktopTemplateColumns,
            position: "sticky",
            top: navbar/* NAVBAR_HEIGHT */.ik,
            backgroundColor: "$neutralBg"
        },
        children: OffersTable_headings.map((heading)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                    style: "subtitle3",
                    color: "subtle",
                    children: heading
                })
            }, heading))
    });

// EXTERNAL MODULE: ./components/common/ChainToggle.tsx
var ChainToggle = __webpack_require__(61955);
// EXTERNAL MODULE: ./components/Head.tsx
var Head = __webpack_require__(4049);
;// CONCATENATED MODULE: ./components/portfolio/BatchActionsFooter.tsx



const BatchActionsFooter = (param)=>{
    let { isOwner , selectedItems , setSelectedItems , setShowListingPage , setOpenAcceptBidModal  } = param;
    if (!isOwner) {
        return null;
    }
    const sellableItems = (0,react.useMemo)(()=>{
        return selectedItems.filter((item)=>{
            var _item_token, _item_token_topBid;
            return ((_item_token = item.token) === null || _item_token === void 0 ? void 0 : (_item_token_topBid = _item_token.topBid) === null || _item_token_topBid === void 0 ? void 0 : _item_token_topBid.id) !== null;
        });
    }, [
        selectedItems
    ]);
    const listItemSubject = selectedItems.length === 1 ? "item" : "items";
    const sellItemSubject = sellableItems.length === 1 ? "item" : "items";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
        align: "center",
        justify: "between",
        css: {
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            px: "$5",
            py: "$4",
            borderTop: "1px solid $gray7",
            backgroundColor: "$neutralBg",
            zIndex: 999
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                align: "center",
                css: {
                    gap: 24
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Text */.xv, {
                        children: [
                            selectedItems.length,
                            " ",
                            listItemSubject
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                        color: "ghost",
                        css: {
                            color: "$primary11"
                        },
                        onClick: ()=>setSelectedItems([]),
                        children: "Clear"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                align: "center",
                css: {
                    gap: "$4"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                        onClick: ()=>setShowListingPage(true),
                        disabled: selectedItems.length < 1,
                        color: sellableItems.length > 0 ? "gray3" : "primary",
                        children: selectedItems.length > 0 ? "List ".concat(selectedItems.length, " ").concat(listItemSubject) : "List"
                    }),
                    sellableItems.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                        onClick: ()=>setOpenAcceptBidModal(true),
                        disabled: sellableItems.length < 1,
                        children: sellableItems.length > 0 ? "Sell ".concat(sellableItems.length, " ").concat(sellItemSubject) : "Sell"
                    }) : null
                ]
            })
        ]
    });
};
/* harmony default export */ var portfolio_BatchActionsFooter = (BatchActionsFooter);

;// CONCATENATED MODULE: ./utils/defaultExpirationOptions.ts
const expirationOptions = [
    {
        text: "1 Hour",
        value: "hour",
        relativeTime: 1,
        relativeTimeUnit: "h"
    },
    {
        text: "12 Hours",
        value: "12 hours",
        relativeTime: 12,
        relativeTimeUnit: "h"
    },
    {
        text: "1 Day",
        value: "1 day",
        relativeTime: 1,
        relativeTimeUnit: "d"
    },
    {
        text: "3 Day",
        value: "3 days",
        relativeTime: 3,
        relativeTimeUnit: "d"
    },
    {
        text: "1 Week",
        value: "week",
        relativeTime: 1,
        relativeTimeUnit: "w"
    },
    {
        text: "1 Month",
        value: "month",
        relativeTime: 1,
        relativeTimeUnit: "M"
    },
    {
        text: "3 Months",
        value: "3 months",
        relativeTime: 3,
        relativeTimeUnit: "M"
    },
    {
        text: "6 Months",
        value: "6 months",
        relativeTime: 6,
        relativeTimeUnit: "M"
    }
];
/* harmony default export */ var defaultExpirationOptions = (expirationOptions);

// EXTERNAL MODULE: ./components/primitives/CryptoCurrencyIcon.tsx
var CryptoCurrencyIcon = __webpack_require__(72064);
// EXTERNAL MODULE: ./node_modules/@rainbow-me/rainbowkit/dist/chunk-3B7JRKV5.js + 15 modules
var chunk_3B7JRKV5 = __webpack_require__(87671);
// EXTERNAL MODULE: ./stitches.config.ts + 1 modules
var stitches_config = __webpack_require__(50530);
;// CONCATENATED MODULE: ./public/SeaPortLogoWhiteText.tsx


const SeaPortLogoWhiteText = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "87",
        height: "20",
        viewBox: "0 0 87 20",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M 154.234 21.622 L 146.585 30.01 Q 140.545 26.446 137.894 26.446 Q 135.851 26.446 134.374 27.989 Q 132.896 29.531 132.896 31.661 Q 132.896 35.876 140.545 38.962 Q 146.151 41.352 149.019 43.286 Q 151.887 45.219 153.821 48.653 Q 155.755 52.086 155.755 56.084 Q 155.755 63.428 149.823 68.86 Q 143.891 74.292 135.808 74.292 Q 126.943 74.292 118.295 65.948 L 126.378 56.518 Q 131.81 62.124 136.547 62.124 Q 138.763 62.124 140.805 60.147 Q 142.848 58.17 142.848 55.997 Q 142.848 51.521 133.418 48.131 Q 128.029 46.176 125.769 44.459 Q 123.509 42.742 121.967 39.461 Q 120.424 36.18 120.424 32.747 Q 120.424 25.142 125.378 20.406 Q 130.332 15.669 138.328 15.669 Q 147.802 15.669 154.234 21.622 Z M 198.859 57.474 L 172.22 57.474 Q 172.438 61.081 174.589 63.341 Q 176.74 65.601 179.608 65.601 Q 184.736 65.601 187.648 60.951 L 197.86 64.341 Q 192.167 74.292 180.173 74.292 Q 171.351 74.292 166.136 68.947 Q 160.921 63.602 160.921 54.563 Q 160.921 46.436 166.419 40.917 Q 171.916 35.398 179.956 35.398 Q 188.039 35.398 193.449 41.2 Q 198.859 47.001 198.859 55.693 Z M 172.307 50 L 187.343 50 Q 185.779 43.003 180.173 43.003 Q 176.957 43.003 174.849 44.828 Q 172.742 46.654 172.307 50 Z M 231.493 73.51 L 231.493 67.122 L 231.32 67.122 Q 228.712 70.859 226.061 72.532 Q 223.41 74.205 219.499 74.205 Q 212.937 74.205 208.331 68.556 Q 203.724 62.906 203.724 54.823 Q 203.724 46.827 208.635 41.113 Q 213.546 35.398 220.282 35.398 Q 223.497 35.398 226.061 36.832 Q 228.625 38.266 231.493 41.395 L 231.493 36.224 L 242.618 36.224 L 242.618 73.51 Z M 223.324 46.523 Q 220.021 46.523 217.805 49.152 Q 215.588 51.781 215.588 55.78 Q 215.588 59.517 217.696 61.798 Q 219.804 64.08 223.237 64.08 Q 226.539 64.08 228.886 61.451 Q 231.233 58.822 231.233 55.084 Q 231.233 51.608 228.886 49.065 Q 226.539 46.523 223.324 46.523 Z M 254.442 16.451 L 273.954 16.451 Q 281.82 16.451 286.643 21.036 Q 291.467 25.62 291.467 33.095 Q 291.467 38.006 289.099 42.416 Q 286.73 46.827 281.95 49 Q 277.17 51.173 273.78 51.26 L 266.653 51.434 L 266.653 73.51 L 254.442 73.51 Z M 266.479 26.707 L 266.479 41.308 L 271.26 41.308 Q 274.345 41.308 276.54 39.092 Q 278.734 36.876 278.734 33.834 Q 278.734 30.357 276.257 28.445 Q 273.78 26.533 269.217 26.533 Z M 297.221 54.91 Q 297.221 46.262 302.74 40.787 Q 308.259 35.311 316.907 35.311 Q 324.946 35.311 330.4 40.896 Q 335.854 46.48 335.854 54.737 Q 335.854 63.167 330.4 68.73 Q 324.946 74.292 316.733 74.292 Q 307.477 74.292 302.349 68.404 Q 297.221 62.515 297.221 54.91 Z M 324.903 54.91 Q 324.903 51.13 322.426 48.305 Q 319.949 45.48 316.646 45.48 Q 313.213 45.48 310.736 48.131 Q 308.259 50.782 308.259 54.476 Q 308.259 58.517 310.714 61.342 Q 313.169 64.167 316.646 64.167 Q 319.949 64.167 322.426 61.407 Q 324.903 58.648 324.903 54.91 Z M 353.391 36.137 L 353.391 41.656 L 353.565 41.656 Q 355.216 38.875 357.411 37.245 Q 359.605 35.615 361.474 35.615 Q 362.604 35.615 363.516 35.789 L 363.516 47.957 Q 362.126 47.697 360.779 47.697 Q 357.345 47.697 355.455 50.108 Q 353.565 52.52 353.565 56.866 L 353.565 73.51 L 342.266 73.51 L 342.266 36.137 Z M 372.858 23.317 L 383.983 23.317 L 383.983 36.137 L 389.328 36.137 L 389.328 46.349 L 383.983 46.349 L 383.983 73.51 L 372.858 73.51 L 372.858 46.349 L 368.599 46.349 L 368.599 36.137 L 372.858 36.137 Z",
                fill: "#000000",
                className: "letter"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M 6.908 23.559 C 6.908 23.651 6.959 23.726 7.019 23.726 C 7.081 23.726 7.131 23.651 7.131 23.559 C 7.131 23.467 7.081 23.392 7.019 23.392 C 6.959 23.392 6.908 23.467 6.908 23.559 M 37.47 62.204 C 30.675 68.974 25.065 74.57 25.003 74.638 C 24.716 74.964 10.941 88.674 6.68 92.877 C 0.155 99.314 0.121 99.349 0.118 99.642 L 0.116 99.892 L 24.933 99.892 L 49.749 99.892 L 49.819 99.383 C 49.887 98.887 49.925 49.894 49.857 49.894 C 49.839 49.894 44.264 55.433 37.47 62.204",
                fill: "#2ccce4",
                className: "letter"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M 47.886 24.843 C 42.108 25.335 36.962 27.629 32.758 31.586 C 28.428 35.662 25.849 40.868 25.066 47.11 C 24.901 48.423 24.9 74.504 25.065 74.504 C 25.251 74.504 74.612 25.087 74.612 24.901 C 74.612 24.719 49.958 24.667 47.886 24.843 M 66.483 97.888 C 66.483 98.036 66.557 98.111 66.705 98.111 C 66.854 98.111 66.928 98.036 66.928 97.888 C 66.928 97.739 66.854 97.665 66.705 97.665 C 66.557 97.665 66.483 97.739 66.483 97.888 M -1.443 98.397 C -1.443 98.762 -1.071 98.73 -1.018 98.36 C -0.991 98.17 -1.037 98.111 -1.212 98.111 C -1.387 98.111 -1.443 98.182 -1.443 98.397 M -0.719 98.778 C -0.821 98.945 -0.679 99.113 -0.435 99.113 C -0.293 99.113 -0.218 99.036 -0.218 98.89 C -0.218 98.654 -0.591 98.571 -0.719 98.778 M -2 99.503 C -2 99.844 -1.966 99.892 -1.721 99.892 C -1.478 99.892 -1.443 99.844 -1.443 99.503 C -1.443 99.161 -1.478 99.113 -1.721 99.113 C -1.966 99.113 -2 99.161 -2 99.503 M 48.555 100.163 C 48.555 100.367 48.611 100.431 48.777 100.418 C 48.93 100.407 49 100.322 49 100.147 C 49 99.966 48.935 99.892 48.777 99.892 C 48.615 99.892 48.555 99.966 48.555 100.163 M 49.556 100.17 C 49.556 100.375 49.616 100.449 49.78 100.449 C 49.943 100.449 50.003 100.375 50.003 100.17 C 50.003 99.966 49.943 99.892 49.78 99.892 C 49.616 99.892 49.556 99.966 49.556 100.17",
                fill: "#fbfbfb"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M 47.553 -0.437 C 47.553 -0.368 46.939 -0.326 45.935 -0.326 C 44.599 -0.326 44.305 -0.296 44.252 -0.159 C 44.202 -0.031 43.987 0.008 43.31 0.008 C 42.798 0.008 42.431 0.054 42.431 0.12 C 42.431 0.182 42.115 0.231 41.706 0.231 C 41.298 0.231 40.983 0.279 40.983 0.342 C 40.983 0.405 40.648 0.454 40.204 0.454 C 39.757 0.454 39.424 0.5 39.424 0.564 C 39.424 0.627 39.221 0.676 38.975 0.676 C 38.679 0.676 38.504 0.733 38.462 0.844 C 38.418 0.957 38.24 1.01 37.908 1.01 C 37.639 1.01 37.419 1.06 37.419 1.122 C 37.419 1.183 37.193 1.234 36.918 1.234 C 36.643 1.234 36.417 1.283 36.417 1.344 C 36.417 1.405 36.246 1.455 36.037 1.455 C 35.828 1.455 35.64 1.505 35.619 1.567 C 35.598 1.628 35.369 1.685 35.108 1.696 C 34.797 1.708 34.636 1.765 34.636 1.864 C 34.636 1.959 34.496 2.012 34.246 2.012 C 34.032 2.012 33.856 2.062 33.856 2.123 C 33.856 2.185 33.685 2.235 33.475 2.235 C 33.266 2.235 33.078 2.284 33.057 2.346 C 33.037 2.406 32.882 2.467 32.715 2.481 C 32.546 2.495 32.409 2.57 32.409 2.649 C 32.409 2.738 32.261 2.791 32.019 2.791 C 31.805 2.791 31.629 2.842 31.629 2.903 C 31.629 2.965 31.504 3.014 31.35 3.014 C 31.198 3.014 31.072 3.065 31.072 3.125 C 31.072 3.187 30.922 3.238 30.738 3.238 C 30.554 3.238 30.404 3.287 30.404 3.349 C 30.404 3.41 30.279 3.461 30.126 3.461 C 29.952 3.461 29.846 3.523 29.846 3.627 C 29.846 3.73 29.742 3.794 29.569 3.794 C 29.415 3.794 29.29 3.845 29.29 3.905 C 29.29 3.967 29.19 4.017 29.068 4.017 C 28.945 4.017 28.845 4.067 28.845 4.128 C 28.845 4.189 28.724 4.239 28.576 4.239 C 28.427 4.239 28.29 4.289 28.27 4.35 C 28.249 4.411 28.096 4.472 27.929 4.486 C 27.762 4.499 27.601 4.574 27.571 4.654 C 27.54 4.732 27.425 4.796 27.314 4.796 C 27.203 4.796 27.041 4.896 26.952 5.018 C 26.864 5.141 26.678 5.241 26.538 5.241 C 26.398 5.241 26.284 5.292 26.284 5.352 C 26.284 5.414 26.184 5.465 26.062 5.465 C 25.938 5.465 25.839 5.538 25.839 5.631 C 25.839 5.735 25.734 5.798 25.56 5.798 C 25.407 5.798 25.282 5.848 25.282 5.91 C 25.282 5.972 25.2 6.021 25.099 6.021 C 24.999 6.021 24.801 6.146 24.66 6.299 C 24.518 6.452 24.325 6.578 24.229 6.578 C 24.135 6.578 24.057 6.628 24.057 6.689 C 24.057 6.75 23.943 6.801 23.802 6.801 C 23.664 6.801 23.477 6.901 23.388 7.023 C 23.3 7.145 23.137 7.245 23.027 7.245 C 22.916 7.245 22.797 7.321 22.761 7.413 C 22.726 7.505 22.613 7.58 22.511 7.58 C 22.408 7.58 22.252 7.681 22.164 7.803 C 22.075 7.925 21.886 8.025 21.742 8.025 C 21.598 8.025 21.513 8.074 21.551 8.137 C 21.59 8.199 21.542 8.248 21.446 8.248 C 21.351 8.248 21.273 8.302 21.273 8.367 C 21.273 8.547 20.98 8.805 20.775 8.805 C 20.676 8.805 20.465 8.933 20.309 9.09 C 20.152 9.247 19.954 9.35 19.869 9.317 C 19.784 9.283 19.714 9.309 19.714 9.37 C 19.714 9.519 19.2 10.03 19.05 10.03 C 18.987 10.03 18.934 10.105 18.934 10.196 C 18.934 10.288 18.845 10.364 18.736 10.364 C 18.627 10.364 18.466 10.464 18.378 10.586 C 18.289 10.71 18.175 10.809 18.122 10.809 C 18.012 10.809 17.71 11.094 17.71 11.199 C 17.71 11.338 17.389 11.589 17.211 11.589 C 17.011 11.589 16.484 12.07 16.484 12.252 C 16.484 12.315 16.429 12.369 16.361 12.369 C 16.223 12.369 15.483 13.139 15.483 13.281 C 15.483 13.33 15.43 13.37 15.367 13.37 C 15.215 13.37 14.703 13.882 14.703 14.033 C 14.703 14.098 14.598 14.15 14.47 14.15 C 14.331 14.15 14.214 14.239 14.178 14.373 C 14.146 14.496 14.027 14.596 13.911 14.596 C 13.761 14.596 13.7 14.676 13.7 14.874 C 13.7 15.027 13.66 15.152 13.612 15.152 C 13.469 15.152 12.699 15.893 12.699 16.03 C 12.699 16.099 12.654 16.154 12.6 16.154 C 12.422 16.154 11.697 16.979 11.697 17.181 C 11.697 17.29 11.633 17.38 11.556 17.38 C 11.478 17.38 11.319 17.508 11.202 17.664 C 10.812 18.184 10.615 18.381 10.486 18.381 C 10.417 18.381 10.36 18.483 10.36 18.608 C 10.36 18.732 10.185 19.01 9.971 19.224 C 9.756 19.439 9.582 19.667 9.582 19.733 C 9.582 19.797 9.43 19.991 9.246 20.163 C 9.063 20.335 8.912 20.58 8.912 20.709 C 8.912 20.838 8.859 20.942 8.794 20.942 C 8.595 20.942 8.356 21.246 8.356 21.498 C 8.356 21.629 8.306 21.704 8.244 21.666 C 8.183 21.629 8.132 21.654 8.132 21.724 C 8.132 21.883 7.853 22.168 7.696 22.168 C 7.63 22.168 7.576 22.292 7.576 22.446 C 7.576 22.599 7.526 22.724 7.465 22.724 C 7.404 22.724 7.354 22.824 7.354 22.948 C 7.354 23.069 7.304 23.169 7.243 23.169 C 7.181 23.169 7.131 23.274 7.131 23.4 C 7.131 23.647 6.89 23.949 6.693 23.949 C 6.628 23.949 6.575 24.049 6.575 24.172 C 6.575 24.294 6.524 24.395 6.463 24.395 C 6.401 24.395 6.352 24.52 6.352 24.673 C 6.352 24.826 6.301 24.952 6.241 24.952 C 6.179 24.952 6.128 25.055 6.128 25.182 C 6.128 25.428 5.888 25.731 5.692 25.731 C 5.625 25.731 5.572 25.831 5.572 25.953 C 5.572 26.076 5.521 26.176 5.461 26.176 C 5.399 26.176 5.349 26.301 5.349 26.454 C 5.349 26.607 5.299 26.732 5.238 26.732 C 5.177 26.732 5.127 26.828 5.127 26.943 C 5.127 27.059 5.052 27.184 4.96 27.218 C 4.867 27.254 4.792 27.385 4.792 27.509 C 4.792 27.633 4.742 27.735 4.681 27.735 C 4.621 27.735 4.57 27.833 4.57 27.951 C 4.57 28.07 4.52 28.198 4.458 28.236 C 4.397 28.273 4.348 28.402 4.348 28.521 C 4.348 28.64 4.297 28.737 4.236 28.737 C 4.174 28.737 4.125 28.913 4.125 29.127 C 4.125 29.399 4.074 29.517 3.958 29.517 C 3.865 29.517 3.79 29.616 3.79 29.739 C 3.79 29.862 3.741 29.962 3.678 29.962 C 3.618 29.962 3.568 30.087 3.568 30.24 C 3.568 30.393 3.518 30.519 3.457 30.519 C 3.394 30.519 3.345 30.62 3.345 30.742 C 3.345 30.864 3.294 30.964 3.234 30.964 C 3.172 30.964 3.122 31.14 3.122 31.354 C 3.122 31.626 3.071 31.744 2.955 31.744 C 2.839 31.744 2.788 31.861 2.788 32.134 C 2.788 32.348 2.738 32.523 2.677 32.523 C 2.616 32.523 2.565 32.649 2.565 32.802 C 2.565 32.955 2.515 33.08 2.454 33.08 C 2.393 33.08 2.343 33.3 2.343 33.569 C 2.343 33.901 2.288 34.079 2.175 34.122 C 2.083 34.158 2.009 34.31 2.009 34.462 C 2.009 34.613 1.958 34.769 1.898 34.806 C 1.837 34.844 1.786 35.024 1.786 35.209 C 1.786 35.403 1.74 35.514 1.674 35.474 C 1.607 35.431 1.563 35.621 1.563 35.969 C 1.563 36.279 1.514 36.532 1.451 36.532 C 1.391 36.532 1.341 36.757 1.341 37.033 C 1.341 37.404 1.297 37.534 1.173 37.534 C 1.049 37.534 1.007 37.664 1.007 38.035 C 1.007 38.311 0.956 38.537 0.895 38.537 C 0.834 38.537 0.784 38.762 0.784 39.038 C 0.784 39.313 0.734 39.538 0.672 39.538 C 0.609 39.538 0.561 39.872 0.561 40.318 C 0.561 40.764 0.514 41.097 0.45 41.097 C 0.386 41.097 0.338 41.432 0.338 41.877 C 0.338 42.495 0.304 42.656 0.171 42.656 C 0.035 42.656 0.004 42.842 0.004 43.659 C 0.004 44.253 -0.041 44.661 -0.107 44.661 C -0.181 44.661 -0.218 53.941 -0.218 72.277 C -0.218 96.749 -0.199 99.892 -0.052 99.892 C 0.047 99.892 0.117 99.789 0.118 99.642 C 0.121 99.349 0.155 99.314 6.68 92.877 C 9.319 90.274 14.508 85.137 18.213 81.462 L 24.948 74.781 L 24.951 61.141 C 24.955 46.856 24.953 46.903 25.444 44.494 C 26.991 36.903 32.815 29.794 39.925 26.821 C 42.038 25.937 43.466 25.505 45.646 25.09 L 47.163 24.8 L 60.847 24.758 C 70.583 24.728 74.568 24.752 74.653 24.837 C 74.74 24.923 71.27 28.446 62.332 37.344 L 49.891 49.732 L 49.888 74.005 C 49.887 87.355 49.862 98.641 49.835 99.086 L 49.785 99.892 L 51.954 99.892 C 53.325 99.892 54.123 99.851 54.123 99.781 C 54.123 99.715 54.567 99.669 55.236 99.669 C 56.152 99.669 56.35 99.639 56.35 99.503 C 56.35 99.368 56.522 99.335 57.241 99.335 C 57.761 99.335 58.131 99.289 58.131 99.225 C 58.131 99.161 58.446 99.113 58.855 99.113 C 59.264 99.113 59.579 99.064 59.579 99.002 C 59.579 98.94 59.876 98.89 60.247 98.89 C 60.618 98.89 60.915 98.84 60.915 98.778 C 60.915 98.718 61.14 98.667 61.416 98.667 C 61.788 98.667 61.917 98.624 61.917 98.501 C 61.917 98.376 62.047 98.333 62.418 98.333 C 62.694 98.333 62.919 98.283 62.919 98.222 C 62.919 98.161 63.144 98.111 63.42 98.111 C 63.696 98.111 63.922 98.06 63.922 97.999 C 63.922 97.938 64.097 97.888 64.312 97.888 C 64.526 97.888 64.701 97.838 64.701 97.777 C 64.701 97.715 64.927 97.665 65.202 97.665 C 65.573 97.665 65.703 97.621 65.703 97.498 C 65.703 97.405 65.802 97.331 65.926 97.331 C 66.049 97.331 66.149 97.282 66.149 97.219 C 66.149 97.158 66.324 97.108 66.539 97.108 C 66.753 97.108 66.928 97.058 66.928 96.998 C 66.928 96.935 67.103 96.886 67.317 96.886 C 67.531 96.886 67.707 96.835 67.707 96.775 C 67.707 96.713 67.883 96.663 68.097 96.663 C 68.369 96.663 68.487 96.612 68.487 96.496 C 68.487 96.403 68.586 96.328 68.71 96.328 C 68.832 96.328 68.932 96.279 68.932 96.218 C 68.932 96.157 69.058 96.106 69.21 96.106 C 69.365 96.106 69.49 96.056 69.49 95.995 C 69.49 95.934 69.665 95.884 69.88 95.884 C 70.151 95.884 70.269 95.833 70.269 95.716 C 70.269 95.624 70.368 95.549 70.491 95.549 C 70.614 95.549 70.714 95.499 70.714 95.438 C 70.714 95.377 70.839 95.327 70.993 95.327 C 71.145 95.327 71.27 95.277 71.27 95.215 C 71.27 95.155 71.37 95.104 71.494 95.104 C 71.616 95.104 71.717 95.055 71.717 94.992 C 71.717 94.931 71.842 94.881 71.995 94.881 C 72.167 94.881 72.273 94.818 72.273 94.714 C 72.273 94.621 72.372 94.548 72.496 94.548 C 72.618 94.548 72.718 94.497 72.718 94.435 C 72.718 94.375 72.843 94.324 72.997 94.324 C 73.15 94.324 73.274 94.275 73.274 94.213 C 73.274 94.152 73.375 94.101 73.497 94.101 C 73.621 94.101 73.721 94.052 73.721 93.991 C 73.721 93.929 73.846 93.879 73.998 93.879 C 74.172 93.879 74.277 93.816 74.277 93.711 C 74.277 93.619 74.376 93.545 74.5 93.545 C 74.623 93.545 74.723 93.495 74.723 93.434 C 74.723 93.372 74.798 93.322 74.89 93.322 C 74.982 93.322 75.057 93.272 75.057 93.211 C 75.057 93.15 75.157 93.1 75.28 93.1 C 75.401 93.1 75.502 93.05 75.502 92.988 C 75.502 92.928 75.628 92.877 75.781 92.877 C 75.934 92.877 76.059 92.824 76.059 92.757 C 76.059 92.561 76.361 92.321 76.607 92.321 C 76.735 92.321 76.839 92.27 76.839 92.208 C 76.839 92.148 76.939 92.097 77.061 92.097 C 77.184 92.097 77.284 92.044 77.284 91.978 C 77.284 91.79 77.582 91.541 77.808 91.541 C 77.921 91.541 78.086 91.441 78.175 91.318 C 78.263 91.195 78.45 91.094 78.589 91.094 C 78.729 91.094 78.842 91.043 78.842 90.978 C 78.842 90.796 79.37 90.317 79.57 90.317 C 79.747 90.317 80.068 90.065 80.068 89.927 C 80.068 89.787 80.388 89.537 80.566 89.537 C 80.765 89.537 81.293 89.056 81.293 88.873 C 81.293 88.809 81.367 88.757 81.459 88.757 C 81.551 88.757 81.626 88.707 81.626 88.646 C 81.626 88.584 81.727 88.534 81.849 88.534 C 81.972 88.534 82.072 88.484 82.072 88.423 C 82.072 88.361 82.126 88.311 82.192 88.311 C 82.32 88.311 82.629 88.038 82.629 87.925 C 82.629 87.809 83.167 87.31 83.292 87.31 C 83.356 87.31 83.409 87.256 83.409 87.19 C 83.409 87.013 83.702 86.752 83.901 86.752 C 83.997 86.752 84.076 86.703 84.076 86.64 C 84.076 86.58 84.13 86.53 84.196 86.53 C 84.324 86.53 84.633 86.255 84.633 86.142 C 84.633 86.053 85.159 85.527 85.248 85.527 C 85.339 85.527 85.636 85.229 85.636 85.137 C 85.636 85.047 85.932 84.749 86.022 84.749 C 86.111 84.749 86.638 84.222 86.638 84.133 C 86.638 84.02 86.947 83.746 87.075 83.746 C 87.141 83.746 87.194 83.644 87.194 83.519 C 87.194 83.287 87.875 82.522 88.081 82.522 C 88.145 82.522 88.197 82.466 88.197 82.398 C 88.197 82.332 88.347 82.137 88.53 81.965 C 88.714 81.793 88.865 81.547 88.865 81.419 C 88.865 81.29 88.917 81.185 88.981 81.185 C 89.184 81.185 89.644 80.647 89.644 80.411 C 89.644 80.285 89.697 80.182 89.761 80.182 C 89.943 80.182 90.424 79.656 90.424 79.456 C 90.424 79.277 90.675 78.958 90.814 78.958 C 90.961 78.958 91.204 78.632 91.204 78.433 C 91.204 78.32 91.304 78.155 91.426 78.067 C 91.548 77.979 91.648 77.792 91.648 77.653 C 91.648 77.513 91.703 77.399 91.768 77.399 C 91.945 77.399 92.205 77.106 92.205 76.906 C 92.205 76.809 92.255 76.731 92.317 76.731 C 92.377 76.731 92.428 76.627 92.428 76.5 C 92.428 76.253 92.669 75.951 92.865 75.951 C 92.931 75.951 92.984 75.836 92.984 75.698 C 92.984 75.558 93.084 75.372 93.208 75.284 C 93.33 75.195 93.431 75.008 93.431 74.869 C 93.431 74.717 93.498 74.614 93.597 74.614 C 93.69 74.614 93.764 74.516 93.764 74.392 C 93.764 74.27 93.815 74.17 93.875 74.17 C 93.937 74.17 93.987 74.045 93.987 73.891 C 93.987 73.739 94.037 73.613 94.098 73.613 C 94.159 73.613 94.21 73.512 94.21 73.39 C 94.21 73.268 94.26 73.167 94.321 73.167 C 94.382 73.167 94.432 73.042 94.432 72.889 C 94.432 72.715 94.495 72.61 94.599 72.61 C 94.691 72.61 94.766 72.511 94.766 72.387 C 94.766 72.265 94.817 72.165 94.878 72.165 C 94.939 72.165 94.988 72.04 94.988 71.887 C 94.988 71.734 95.039 71.608 95.1 71.608 C 95.162 71.608 95.211 71.507 95.211 71.386 C 95.211 71.263 95.262 71.163 95.324 71.163 C 95.384 71.163 95.435 71.038 95.435 70.884 C 95.435 70.712 95.498 70.607 95.601 70.607 C 95.694 70.607 95.768 70.508 95.768 70.383 C 95.768 70.261 95.818 70.16 95.88 70.16 C 95.942 70.16 95.991 69.985 95.991 69.77 C 95.991 69.557 96.042 69.381 96.102 69.381 C 96.164 69.381 96.214 69.256 96.214 69.103 C 96.214 68.93 96.278 68.824 96.381 68.824 C 96.474 68.824 96.548 68.725 96.548 68.603 C 96.548 68.479 96.598 68.379 96.659 68.379 C 96.721 68.379 96.771 68.204 96.771 67.99 C 96.771 67.774 96.821 67.6 96.882 67.6 C 96.944 67.6 96.994 67.424 96.994 67.21 C 96.994 66.995 97.044 66.82 97.105 66.82 C 97.166 66.82 97.216 66.644 97.216 66.43 C 97.216 66.157 97.266 66.04 97.383 66.04 C 97.476 66.04 97.551 65.941 97.551 65.818 C 97.551 65.696 97.6 65.596 97.662 65.596 C 97.722 65.596 97.773 65.42 97.773 65.206 C 97.773 64.991 97.822 64.816 97.885 64.816 C 97.946 64.816 97.995 64.59 97.995 64.315 C 97.995 64.04 98.046 63.813 98.107 63.813 C 98.169 63.813 98.218 63.588 98.218 63.312 C 98.218 62.942 98.262 62.811 98.385 62.811 C 98.502 62.811 98.553 62.694 98.553 62.421 C 98.553 62.207 98.602 62.032 98.664 62.032 C 98.725 62.032 98.775 61.757 98.775 61.42 C 98.775 61.083 98.825 60.808 98.886 60.808 C 98.948 60.808 98.998 60.581 98.998 60.306 C 98.998 60.03 99.048 59.805 99.109 59.805 C 99.171 59.805 99.221 59.508 99.221 59.137 C 99.221 58.617 99.258 58.468 99.388 58.468 C 99.522 58.468 99.554 58.296 99.554 57.578 C 99.554 57.057 99.602 56.687 99.666 56.687 C 99.731 56.687 99.778 56.279 99.778 55.685 C 99.778 55.091 99.823 54.683 99.889 54.683 C 99.962 54.683 100 52.938 100 49.672 C 100 46.406 99.962 44.661 99.889 44.661 C 99.823 44.661 99.778 44.253 99.778 43.659 C 99.778 43.065 99.731 42.656 99.666 42.656 C 99.602 42.656 99.554 42.323 99.554 41.877 C 99.554 41.258 99.52 41.097 99.388 41.097 C 99.255 41.097 99.221 40.937 99.221 40.318 C 99.221 39.872 99.173 39.538 99.109 39.538 C 99.048 39.538 98.998 39.313 98.998 39.038 C 98.998 38.762 98.948 38.537 98.886 38.537 C 98.825 38.537 98.775 38.311 98.775 38.035 C 98.775 37.759 98.725 37.534 98.664 37.534 C 98.602 37.534 98.553 37.309 98.553 37.033 C 98.553 36.661 98.509 36.532 98.385 36.532 C 98.262 36.532 98.218 36.402 98.218 36.031 C 98.218 35.755 98.169 35.53 98.107 35.53 C 98.046 35.53 97.995 35.355 97.995 35.14 C 97.995 34.925 97.946 34.751 97.885 34.751 C 97.822 34.751 97.773 34.6 97.773 34.416 C 97.773 34.232 97.722 34.083 97.662 34.083 C 97.6 34.083 97.551 33.907 97.551 33.693 C 97.551 33.42 97.5 33.303 97.383 33.303 C 97.266 33.303 97.216 33.185 97.216 32.913 C 97.216 32.698 97.166 32.523 97.105 32.523 C 97.044 32.523 96.994 32.348 96.994 32.134 C 96.994 31.918 96.944 31.744 96.882 31.744 C 96.821 31.744 96.771 31.644 96.771 31.521 C 96.771 31.399 96.721 31.298 96.659 31.298 C 96.598 31.298 96.548 31.147 96.548 30.96 C 96.548 30.763 96.479 30.596 96.381 30.559 C 96.289 30.525 96.214 30.375 96.214 30.229 C 96.214 30.082 96.164 29.962 96.102 29.962 C 96.042 29.962 95.991 29.787 95.991 29.572 C 95.991 29.358 95.942 29.182 95.88 29.182 C 95.818 29.182 95.768 29.082 95.768 28.959 C 95.768 28.837 95.694 28.737 95.601 28.737 C 95.498 28.737 95.435 28.632 95.435 28.459 C 95.435 28.306 95.384 28.18 95.324 28.18 C 95.262 28.18 95.211 28.03 95.211 27.846 C 95.211 27.662 95.162 27.512 95.1 27.512 C 95.039 27.512 94.988 27.437 94.988 27.345 C 94.988 27.253 94.939 27.179 94.878 27.179 C 94.817 27.179 94.766 27.079 94.766 26.955 C 94.766 26.832 94.691 26.732 94.599 26.732 C 94.495 26.732 94.432 26.627 94.432 26.454 C 94.432 26.301 94.382 26.176 94.321 26.176 C 94.26 26.176 94.21 26.076 94.21 25.953 C 94.21 25.831 94.159 25.731 94.098 25.731 C 94.037 25.731 93.987 25.606 93.987 25.452 C 93.987 25.299 93.937 25.175 93.875 25.175 C 93.815 25.175 93.764 25.074 93.764 24.952 C 93.764 24.828 93.708 24.728 93.637 24.728 C 93.466 24.728 93.215 24.385 93.211 24.145 C 93.21 24.036 93.157 23.949 93.097 23.949 C 93.035 23.949 92.984 23.823 92.984 23.671 C 92.984 23.517 92.931 23.392 92.865 23.392 C 92.687 23.392 92.428 23.099 92.428 22.899 C 92.428 22.803 92.377 22.724 92.317 22.724 C 92.255 22.724 92.205 22.649 92.205 22.558 C 92.205 22.466 92.155 22.39 92.094 22.39 C 92.033 22.39 91.983 22.29 91.983 22.168 C 91.983 22.044 91.908 21.945 91.815 21.945 C 91.723 21.945 91.648 21.88 91.648 21.802 C 91.648 21.725 91.548 21.587 91.426 21.499 C 91.304 21.411 91.204 21.25 91.204 21.141 C 91.204 21.032 91.153 20.942 91.092 20.942 C 91.03 20.942 90.981 20.817 90.981 20.664 C 90.981 20.511 90.928 20.385 90.864 20.385 C 90.682 20.385 90.201 19.859 90.201 19.659 C 90.201 19.455 89.943 19.161 89.764 19.161 C 89.698 19.161 89.644 19.058 89.644 18.933 C 89.644 18.721 89.192 18.158 89.021 18.158 C 88.9 18.158 88.65 17.786 88.645 17.599 C 88.643 17.506 88.541 17.356 88.419 17.267 C 88.297 17.18 88.197 17.043 88.197 16.965 C 88.197 16.886 88.145 16.823 88.081 16.823 C 87.931 16.823 87.194 16.085 87.194 15.935 C 87.194 15.873 87.119 15.82 87.027 15.82 C 86.935 15.82 86.86 15.721 86.86 15.597 C 86.86 15.449 86.786 15.375 86.638 15.375 C 86.486 15.375 86.415 15.3 86.415 15.144 C 86.415 14.927 86.181 14.596 86.029 14.596 C 85.991 14.596 85.691 14.319 85.362 13.983 C 85.034 13.646 84.684 13.37 84.587 13.37 C 84.489 13.37 84.411 13.295 84.411 13.203 C 84.411 13.111 84.359 13.037 84.295 13.037 C 84.146 13.037 83.409 12.298 83.409 12.149 C 83.409 12.086 83.353 12.034 83.285 12.034 C 83.219 12.034 83.024 11.883 82.852 11.7 C 82.68 11.516 82.434 11.366 82.306 11.366 C 82.131 11.366 82.072 11.296 82.072 11.088 C 82.072 10.883 82.013 10.809 81.849 10.809 C 81.727 10.809 81.626 10.759 81.626 10.698 C 81.626 10.637 81.572 10.586 81.508 10.586 C 81.353 10.586 81.069 10.303 81.069 10.15 C 81.069 10.083 80.969 10.03 80.847 10.03 C 80.725 10.03 80.625 9.979 80.625 9.919 C 80.625 9.857 80.572 9.807 80.505 9.807 C 80.352 9.807 80.068 9.525 80.068 9.373 C 80.068 9.309 80.004 9.281 79.926 9.312 C 79.848 9.342 79.598 9.189 79.37 8.973 C 79.14 8.758 78.901 8.582 78.837 8.582 C 78.774 8.582 78.605 8.457 78.463 8.304 C 78.321 8.15 78.122 8.025 78.022 8.025 C 77.922 8.025 77.84 7.975 77.84 7.915 C 77.84 7.852 77.766 7.803 77.674 7.803 C 77.582 7.803 77.507 7.752 77.507 7.692 C 77.507 7.63 77.406 7.58 77.284 7.58 C 77.16 7.58 77.061 7.506 77.061 7.413 C 77.061 7.313 76.959 7.245 76.807 7.245 C 76.668 7.245 76.481 7.145 76.393 7.023 C 76.305 6.901 76.143 6.801 76.035 6.801 C 75.926 6.801 75.837 6.75 75.837 6.689 C 75.837 6.628 75.761 6.578 75.669 6.578 C 75.577 6.578 75.502 6.503 75.502 6.411 C 75.502 6.318 75.403 6.244 75.28 6.244 C 75.157 6.244 75.057 6.194 75.057 6.132 C 75.057 6.072 74.932 6.021 74.778 6.021 C 74.626 6.021 74.5 5.972 74.5 5.91 C 74.5 5.848 74.4 5.798 74.277 5.798 C 74.155 5.798 74.054 5.749 74.054 5.689 C 74.054 5.629 73.929 5.548 73.776 5.51 C 73.623 5.472 73.497 5.395 73.497 5.34 C 73.497 5.286 73.398 5.241 73.274 5.241 C 73.153 5.241 73.053 5.192 73.053 5.13 C 73.053 5.069 72.948 5.018 72.822 5.018 C 72.577 5.018 72.273 4.779 72.273 4.585 C 72.273 4.521 72.204 4.495 72.12 4.528 C 72.036 4.56 71.89 4.508 71.794 4.413 C 71.699 4.317 71.466 4.239 71.279 4.239 C 71.091 4.239 70.937 4.189 70.937 4.128 C 70.937 4.067 70.836 4.017 70.714 4.017 C 70.591 4.017 70.491 3.967 70.491 3.905 C 70.491 3.845 70.365 3.794 70.213 3.794 C 70.039 3.794 69.934 3.73 69.934 3.627 C 69.934 3.534 69.835 3.461 69.712 3.461 C 69.59 3.461 69.49 3.41 69.49 3.349 C 69.49 3.287 69.314 3.238 69.1 3.238 C 68.885 3.238 68.71 3.187 68.71 3.125 C 68.71 3.065 68.609 3.014 68.487 3.014 C 68.364 3.014 68.264 2.965 68.264 2.903 C 68.264 2.842 68.094 2.791 67.887 2.791 C 67.653 2.791 67.484 2.727 67.445 2.624 C 67.407 2.527 67.24 2.458 67.043 2.458 C 66.857 2.458 66.705 2.407 66.705 2.347 C 66.705 2.285 66.531 2.235 66.315 2.235 C 66.101 2.235 65.926 2.185 65.926 2.123 C 65.926 2.062 65.83 2.012 65.712 2.012 C 65.595 2.012 65.478 1.951 65.454 1.875 C 65.429 1.8 65.311 1.734 65.193 1.728 C 64.462 1.69 64.36 1.668 64.423 1.567 C 64.463 1.501 64.331 1.455 64.094 1.455 C 63.877 1.455 63.698 1.405 63.698 1.344 C 63.698 1.283 63.473 1.234 63.198 1.234 C 62.922 1.234 62.697 1.183 62.697 1.122 C 62.697 1.06 62.476 1.01 62.207 1.01 C 61.875 1.01 61.698 0.957 61.653 0.844 C 61.612 0.734 61.438 0.676 61.147 0.676 C 60.904 0.676 60.674 0.627 60.636 0.564 C 60.599 0.503 60.244 0.454 59.85 0.454 C 59.446 0.454 59.133 0.404 59.133 0.342 C 59.133 0.278 58.799 0.231 58.354 0.231 C 57.908 0.231 57.574 0.182 57.574 0.12 C 57.574 0.053 57.166 0.008 56.572 0.008 C 55.813 0.008 55.57 -0.028 55.57 -0.14 C 55.57 -0.253 55.253 -0.292 54.206 -0.311 C 53.453 -0.324 52.825 -0.382 52.805 -0.441 C 52.753 -0.59 47.553 -0.586 47.553 -0.437",
                fill: "#3874e6"
            })
        ]
    });
};
/* harmony default export */ var public_SeaPortLogoWhiteText = (SeaPortLogoWhiteText);

;// CONCATENATED MODULE: ./components/common/Modal.tsx










const Title = (0,stitches_config/* styled */.zo)(react_dialog_dist_index_module/* Title */.Dx, {
    margin: 0
});
const Logo = (0,stitches_config/* styled */.zo)(public_SeaPortLogoWhiteText, {
    "& .letter": {
        fill: "$gray12"
    }
});
const Modal = /*#__PURE__*/ (0,react.forwardRef)((param, forwardedRef)=>{
    let { title , children , trigger , onBack , open , onOpenChange , loading , onPointerDownOutside , onFocusCapture  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog/* Dialog */.Vq, {
        ref: forwardedRef,
        trigger: trigger,
        open: open,
        onOpenChange: onOpenChange,
        onPointerDownOutside: onPointerDownOutside,
        onFocusCapture: onFocusCapture,
        overlayProps: {
            style: {
                opacity: 0.6
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                css: {
                    p: 16,
                    backgroundColor: "$gray3",
                    alignItems: "center",
                    justifyContent: "space-between",
                    borderTopRightRadius: "$borderRadius",
                    borderTopLeftRadius: "$borderRadius"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Title, {
                        css: {
                            alignItems: "center",
                            display: "flex"
                        },
                        children: [
                            onBack && /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                                color: "ghost",
                                size: "none",
                                css: {
                                    mr: "$2",
                                    color: "$neutralText"
                                },
                                onClick: onBack,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    icon: free_solid_svg_icons/* faChevronLeft */.A35,
                                    width: 16,
                                    height: 16
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                style: "h6",
                                children: title
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_dialog_dist_index_module/* Close */.x8, {
                        asChild: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                            color: "ghost",
                            size: "none",
                            css: {
                                color: "$neutralText"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                icon: free_solid_svg_icons/* faClose */.YIN,
                                width: 16,
                                height: 16
                            })
                        })
                    })
                ]
            }),
            loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpinner/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                css: {
                    maxHeight: "85vh",
                    overflowY: "auto",
                    backgroundColor: "$neutralBg"
                },
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                css: {
                    mx: "auto",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "$gray3",
                    py: 10.5,
                    borderBottomRightRadius: "$borderRadius",
                    borderBottomLeftRadius: "$borderRadius"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Anchor */.ee, {
                    href: "https://www.seaport.market/",
                    target: "_blank",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Text */.xv, {
                        style: "body3",
                        css: {
                            display: "inline-flex",
                            alignItems: "center",
                            gap: 4
                        },
                        children: [
                            "Powered by ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo, {})
                        ]
                    })
                })
            })
        ]
    });
});

;// CONCATENATED MODULE: ./components/common/TransactionProgress.tsx




const TransactionProgress_Img = (0,stitches_config/* styled */.zo)("img", {
    width: 56,
    height: 56,
    borderRadius: 4,
    objectFit: "cover",
    "& + img": {
        ml: -20
    }
});
const ProgressDot = (0,stitches_config/* styled */.zo)(primitives/* Box */.xu, {
    borderRadius: "50%",
    width: 5,
    height: 5
});
const loadingStart = (0,stitches_config/* keyframes */.F4)({
    "0%": {
        transform: "scale(0.8)",
        backgroundColor: "$gray9"
    },
    "20%": {
        transform: "scale(1)",
        backgroundColor: "$primary11"
    },
    "100%": {
        transform: "scale(0.8)",
        backgroundColor: "$gray9"
    }
});
const loadingMiddle = (0,stitches_config/* keyframes */.F4)({
    "0%": {
        transform: "scale(0.8)",
        backgroundColor: "$gray9"
    },
    "20%": {
        transform: "scale(0.8)",
        backgroundColor: "$gray9"
    },
    "40%": {
        transform: "scale(1)",
        backgroundColor: "$primary11"
    },
    "100%": {
        transform: "scale(0.8)",
        backgroundColor: "$gray9"
    }
});
const loadingEnd = (0,stitches_config/* keyframes */.F4)({
    "0%": {
        transform: "scale(0.8)",
        backgroundColor: "$grayy9"
    },
    "40%": {
        transform: "scale(0.8)",
        backgroundColor: "$gray9"
    },
    "60%": {
        transform: "scale(1)",
        backgroundColor: "$primary11"
    },
    "100%": {
        transform: "scale(0.8)",
        backgroundColor: "$gray9"
    }
});
const TransactionProgress = (param)=>{
    let { fromImgs , toImgs , ...props } = param;
    const hasManyFromImgs = fromImgs.length > 5;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
        ...props,
        align: "center",
        children: [
            fromImgs.map((src, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionProgress_Img, {
                    src: src,
                    css: {
                        "& + img": {
                            ml: hasManyFromImgs ? -40 : -30
                        }
                    }
                }, i)),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                css: {
                    gap: "$1",
                    mx: 23
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgressDot, {
                        css: {
                            animation: "".concat(loadingStart, " 1s ease-in-out infinite")
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgressDot, {
                        css: {
                            animation: "".concat(loadingMiddle, " 1s ease-in-out infinite")
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgressDot, {
                        css: {
                            animation: "".concat(loadingEnd, " 1s ease-in-out infinite")
                        }
                    })
                ]
            }),
            toImgs.map((src, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionProgress_Img, {
                    src: src
                }, i))
        ]
    });
};
/* harmony default export */ var common_TransactionProgress = (TransactionProgress);

// EXTERNAL MODULE: ./components/primitives/Flex.tsx
var Flex = __webpack_require__(20326);
// EXTERNAL MODULE: ./components/primitives/Text.tsx
var Text = __webpack_require__(71818);
;// CONCATENATED MODULE: ./components/primitives/ErrorWell.tsx






function ErrorWell(param) {
    let { message , css  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        css: {
            color: "$red11",
            p: "$4",
            gap: "$2",
            background: "$gray3",
            ...css
        },
        align: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                icon: free_solid_svg_icons/* faCircleExclamation */.xHz,
                width: 16,
                height: 16
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                style: "body3",
                color: "error",
                children: message || "Oops, something went wrong. Please try again."
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/@stitches/react/dist/index.mjs
var react_dist = __webpack_require__(86744);
;// CONCATENATED MODULE: ./components/portfolio/ApprovalCollapsible.tsx










const ApprovalCollapsible_Img = (0,react_dist/* styled */.zo)("img", {
    height: 24,
    width: 24,
    borderRadius: 4,
    objectFit: "cover",
    "& + img": {
        marginLeft: -10
    }
});
const ApprovalCollapsible = (param)=>{
    let { item , batchListingData , selectedMarketplaces , open  } = param;
    var _batchListingData_orderIndexes_, _batchListingData_orderIndexes__token, _batchListingData_orderIndexes__token_token, _batchListingData_orderIndexes__token_token_collection;
    const [collapsibleOpen, setCollapsibleOpen] = (0,react.useState)(false);
    let isComplete = item.status == "complete";
    const orderIndexes = (item === null || item === void 0 ? void 0 : item.orderIndexes) || [];
    const marketplacesSeekingApproval = (0,react.useMemo)(()=>{
        let uniqueMarketplaces = [];
        orderIndexes.forEach((orderIndex)=>{
            if (batchListingData[orderIndex]) {
                const listing = batchListingData[orderIndex].listing;
                const marketplace = selectedMarketplaces.find((m)=>m.orderbook === listing.orderbook);
                if (marketplace && !uniqueMarketplaces.find((uniqueMarketplace)=>uniqueMarketplace.orderbook === marketplace.orderbook)) {
                    uniqueMarketplaces.push(marketplace);
                }
            }
        });
        return uniqueMarketplaces;
    }, [
        orderIndexes,
        item,
        batchListingData
    ]);
    const marketplaceNames = (0,react.useMemo)(()=>{
        return marketplacesSeekingApproval.map((marketplace)=>marketplace.name).join(" and ");
    }, [
        marketplacesSeekingApproval
    ]);
    const collectionImage = (0,react.useMemo)(()=>{
        var _batchListingData_orderIndexes_, _batchListingData_orderIndexes__token, _token_collection;
        const token = (_batchListingData_orderIndexes_ = batchListingData[orderIndexes[0]]) === null || _batchListingData_orderIndexes_ === void 0 ? void 0 : (_batchListingData_orderIndexes__token = _batchListingData_orderIndexes_.token) === null || _batchListingData_orderIndexes__token === void 0 ? void 0 : _batchListingData_orderIndexes__token.token;
        return (0,optimizeImage/* default */.Z)(token === null || token === void 0 ? void 0 : (_token_collection = token.collection) === null || _token_collection === void 0 ? void 0 : _token_collection.imageUrl, 250) || (token === null || token === void 0 ? void 0 : token.imageSmall) || "";
    }, [
        batchListingData,
        orderIndexes
    ]);
    const collectionName = ((_batchListingData_orderIndexes_ = batchListingData[orderIndexes[0]]) === null || _batchListingData_orderIndexes_ === void 0 ? void 0 : (_batchListingData_orderIndexes__token = _batchListingData_orderIndexes_.token) === null || _batchListingData_orderIndexes__token === void 0 ? void 0 : (_batchListingData_orderIndexes__token_token = _batchListingData_orderIndexes__token.token) === null || _batchListingData_orderIndexes__token_token === void 0 ? void 0 : (_batchListingData_orderIndexes__token_token_collection = _batchListingData_orderIndexes__token_token.collection) === null || _batchListingData_orderIndexes__token_token_collection === void 0 ? void 0 : _batchListingData_orderIndexes__token_token_collection.name) || "collection";
    (0,react.useEffect)(()=>{
        if (open !== undefined && open !== collapsibleOpen) {
            setCollapsibleOpen(open);
        }
    }, [
        open
    ]);
    (0,react.useEffect)(()=>{
        if (isComplete) {
            setCollapsibleOpen(false);
        }
    }, [
        isComplete
    ]);
    if (batchListingData[orderIndexes[0]] == undefined) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Collapsible/* CollapsibleRoot */.Kq, {
        onOpenChange: (open)=>{
            setCollapsibleOpen(open);
        },
        open: collapsibleOpen,
        css: {
            backgroundColor: "$gray3",
            width: "100%"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_collapsible_dist_index_module/* Trigger */.xz, {
                asChild: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                    justify: "between",
                    css: {
                        px: "$4",
                        py: "$3"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                            align: "center",
                            css: {
                                gap: "$3"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                    css: {
                                        width: 18,
                                        height: 18,
                                        backgroundColor: isComplete ? "$green6" : "$indigo6",
                                        borderColor: isComplete ? "$green9" : "$indigo9",
                                        borderStyle: "solid",
                                        borderWidth: 4,
                                        borderRadius: 999
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                    style: "subtitle2",
                                    css: {
                                        color: isComplete ? "$gray11" : "$gray12"
                                    },
                                    children: "Approve Collection"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                            css: {
                                color: "$neutralSolid",
                                transform: collapsibleOpen ? "rotate(180deg)" : "rotate(0)",
                                transition: ".3s"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                icon: free_solid_svg_icons/* faChevronDown */.ptq
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapsible/* CollapsibleContent */.Fw, {
                css: {
                    '&[data-state="open"]': {
                        animation: "".concat(Collapsible/* slideDown */.qw, " 300ms cubic-bezier(0.87, 0, 0.13, 1)")
                    },
                    '&[data-state="closed"]': {
                        animation: "".concat(Collapsible/* slideUp */.iM, " 300ms cubic-bezier(0.87, 0, 0.13, 1)")
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                    align: "center",
                    justify: "between",
                    css: {
                        px: "$4",
                        pb: "$2",
                        width: "100%",
                        gap: "$2"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                            css: {
                                gap: "$2"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                    align: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ApprovalCollapsible_Img, {
                                            src: collectionImage
                                        }),
                                        marketplacesSeekingApproval.map((marketplace)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ApprovalCollapsible_Img, {
                                                src: marketplace.imageUrl
                                            }))
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Text */.xv, {
                                    style: "body3",
                                    ellipsify: true,
                                    children: [
                                        "Approve ",
                                        collectionName,
                                        " on ",
                                        marketplaceNames
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                            children: item.txHash && item.status == "incomplete" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpinner/* default */.Z, {
                                css: {
                                    width: 18,
                                    height: 18,
                                    borderWidth: 2,
                                    borderBottomColor: "$indigo10"
                                }
                            }) : null
                        })
                    ]
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/viem/dist/esm/utils/unit/parseUnits.js
var parseUnits = __webpack_require__(22852);
// EXTERNAL MODULE: ./node_modules/viem/dist/esm/constants/address.js
var address = __webpack_require__(66373);
;// CONCATENATED MODULE: ./components/portfolio/BatchListModal.tsx
















var BatchListStep;
(function(BatchListStep) {
    BatchListStep[BatchListStep["Approving"] = 0] = "Approving";
    BatchListStep[BatchListStep["Complete"] = 1] = "Complete";
})(BatchListStep || (BatchListStep = {}));
const BatchListModal = (param)=>{
    let { listings , disabled , currency , selectedMarketplaces , onCloseComplete  } = param;
    var _stepData_currentStep_items;
    const [open, setOpen] = (0,react.useState)(false);
    const { data: wallet  } = (0,dist/* useWalletClient */.py)();
    const { openConnectModal  } = (0,chunk_3B7JRKV5/* useConnectModal */.We)();
    const { chain: activeChain  } = (0,dist/* useNetwork */.LN)();
    const marketplaceChain = (0,hooks/* useMarketplaceChain */.gw)();
    const { switchNetworkAsync  } = (0,dist/* useSwitchNetwork */.g0)({
        chainId: marketplaceChain.id
    });
    const isInTheWrongNetwork = Boolean(wallet && (activeChain === null || activeChain === void 0 ? void 0 : activeChain.id) !== marketplaceChain.id);
    const client = (0,dist_index_module/* useReservoirClient */.RW)();
    const [batchListStep, setBatchListStep] = (0,react.useState)(BatchListStep.Approving);
    const [stepData, setStepData] = (0,react.useState)(null);
    const [transactionError, setTransactionError] = (0,react.useState)();
    const [stepTitle, setStepTitle] = (0,react.useState)("");
    const [uniqueMarketplaces, setUniqueMarketplaces] = (0,react.useState)([]);
    const getUniqueMarketplaces = (0,react.useCallback)((listings)=>{
        const marketplaces = [];
        listings.forEach((listing)=>{
            const marketplace = selectedMarketplaces.find((m)=>m.orderbook === listing.listing.orderbook);
            if (marketplace && !marketplaces.includes(marketplace)) {
                marketplaces.push(marketplace);
            }
        });
        return marketplaces;
    }, [
        listings
    ]);
    (0,react.useEffect)(()=>{
        if (stepData) {
            const orderKind = stepData.listings[0].listing.orderKind || "exchange";
            const marketplaces = getUniqueMarketplaces(stepData.listings);
            const marketplaceNames = marketplaces.map((marketplace)=>marketplace.name).join(" and ");
            setUniqueMarketplaces(marketplaces);
            switch(stepData.currentStep.kind){
                case "transaction":
                    {
                        setStepTitle("Approve ".concat((orderKind === null || orderKind === void 0 ? void 0 : orderKind[0].toUpperCase()) + (orderKind === null || orderKind === void 0 ? void 0 : orderKind.slice(1)), " to access item\nin your wallet"));
                        break;
                    }
                case "signature":
                    {
                        setStepTitle("Confirm listings on ".concat(marketplaceNames, "\nin your wallet"));
                        break;
                    }
            }
        }
    }, [
        stepData
    ]);
    const listTokens = (0,react.useCallback)(()=>{
        if (!wallet) {
            const error = new Error("Missing a wallet");
            setTransactionError(error);
            throw error;
        }
        if (!client) {
            const error1 = new Error("ReservoirClient was not initialized");
            setTransactionError(error1);
            throw error1;
        }
        setTransactionError(null);
        const batchListingData = [];
        listings.forEach((listing)=>{
            var _listing_token_token, _listing_token_token1;
            let expirationTime = null;
            if (listing.expirationOption && listing.expirationOption.relativeTime && listing.expirationOption.relativeTimeUnit) {
                expirationTime = dayjs_min_default()().add(listing.expirationOption.relativeTime, listing.expirationOption.relativeTimeUnit).unix().toString();
            }
            const token = "".concat((_listing_token_token = listing.token.token) === null || _listing_token_token === void 0 ? void 0 : _listing_token_token.contract, ":").concat((_listing_token_token1 = listing.token.token) === null || _listing_token_token1 === void 0 ? void 0 : _listing_token_token1.tokenId);
            const convertedListing = {
                token: token,
                weiPrice: ((0,parseUnits/* parseUnits */.v)("".concat(+listing.price), currency.decimals || 18) * BigInt(listing.quantity)).toString(),
                orderbook: listing.orderbook,
                orderKind: listing.orderKind,
                quantity: listing.quantity
            };
            if (expirationTime) {
                convertedListing.expirationTime = expirationTime;
            }
            if (currency && currency.contract != address/* zeroAddress */.D) {
                convertedListing.currency = currency.contract;
            }
            batchListingData.push({
                listing: convertedListing,
                token: listing.token
            });
        });
        setBatchListStep(BatchListStep.Approving);
        client.actions.listToken({
            listings: batchListingData.map((data)=>data.listing),
            wallet,
            onProgress: (steps)=>{
                const executableSteps = steps.filter((step)=>step.items && step.items.length > 0);
                let stepCount = executableSteps.length;
                let incompleteStepItemIndex = null;
                let incompleteStepIndex = null;
                executableSteps.find((step, i)=>{
                    if (!step.items) {
                        return false;
                    }
                    incompleteStepItemIndex = step.items.findIndex((item)=>item.status == "incomplete");
                    if (incompleteStepItemIndex !== -1) {
                        incompleteStepIndex = i;
                        return true;
                    }
                });
                if (incompleteStepIndex === null || incompleteStepItemIndex === null) {
                    const currentStep = executableSteps[executableSteps.length - 1];
                    setBatchListStep(BatchListStep.Complete);
                    setStepData({
                        totalSteps: stepCount,
                        stepProgress: stepCount,
                        currentStep,
                        listings: batchListingData
                    });
                } else {
                    setStepData({
                        totalSteps: stepCount,
                        stepProgress: incompleteStepIndex,
                        currentStep: executableSteps[incompleteStepIndex],
                        listings: batchListingData
                    });
                }
            }
        }).catch((e)=>{
            const error = e;
            const transactionError = new Error("Oops, something went wrong. Please try again.", {
                cause: error
            });
            setTransactionError(transactionError);
        });
    }, [
        client,
        listings,
        wallet
    ]);
    const trigger = /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
        disabled: disabled,
        onClick: listTokens,
        children: "List"
    });
    if (isInTheWrongNetwork) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
            disabled: disabled,
            onClick: async ()=>{
                if (isInTheWrongNetwork && switchNetworkAsync) {
                    const chain = await switchNetworkAsync(marketplaceChain.id);
                    if (chain.id !== marketplaceChain.id) {
                        return false;
                    }
                }
                if (!wallet) {
                    openConnectModal === null || openConnectModal === void 0 ? void 0 : openConnectModal();
                }
            },
            children: "List"
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal, {
        title: "Complete Listings",
        trigger: trigger,
        open: open,
        onOpenChange: (open)=>{
            if (!open && onCloseComplete && batchListStep === BatchListStep.Complete) {
                onCloseComplete();
            }
            setOpen(open);
        },
        children: [
            batchListStep === BatchListStep.Approving && /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                direction: "column",
                justify: "start",
                align: "center",
                css: {
                    flex: 1,
                    textAlign: "center",
                    p: "$4",
                    gap: "$4"
                },
                children: [
                    transactionError && /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorWell, {
                        message: transactionError.message,
                        css: {
                            width: "100%"
                        }
                    }),
                    !stepData && !transactionError && /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                        css: {
                            height: "100%",
                            py: "$6"
                        },
                        align: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpinner/* default */.Z, {})
                    }),
                    stepData && /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        direction: "column",
                        align: "center",
                        css: {
                            maxHeight: "40vh",
                            overflowY: "auto",
                            width: "100%"
                        },
                        children: [
                            stepData.currentStep.kind === "signature" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                css: {
                                    textAlign: "center",
                                    my: 28,
                                    maxWidth: 400
                                },
                                style: "subtitle1",
                                children: stepTitle
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                                direction: "column",
                                css: {
                                    gap: "$3",
                                    width: "100%"
                                },
                                children: stepData.currentStep.kind === "transaction" ? (_stepData_currentStep_items = stepData.currentStep.items) === null || _stepData_currentStep_items === void 0 ? void 0 : _stepData_currentStep_items.map((item, i)=>{
                                    if (item.data) return /*#__PURE__*/ (0,jsx_runtime.jsx)(ApprovalCollapsible, {
                                        item: item,
                                        batchListingData: stepData.listings,
                                        selectedMarketplaces: selectedMarketplaces,
                                        open: item.status == "incomplete"
                                    }, i);
                                }) : null
                            }),
                            stepData.currentStep.kind === "signature" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(common_TransactionProgress, {
                                justify: "center",
                                css: {
                                    mb: "$3"
                                },
                                fromImgs: stepData.listings.map((listing)=>{
                                    var _listing_token_token;
                                    return (_listing_token_token = listing.token.token) === null || _listing_token_token === void 0 ? void 0 : _listing_token_token.imageSmall;
                                }),
                                toImgs: uniqueMarketplaces.map((marketplace)=>{
                                    return (marketplace === null || marketplace === void 0 ? void 0 : marketplace.imageUrl) || "";
                                })
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                        css: {
                            textAlign: "center",
                            maxWidth: 395,
                            mx: "auto"
                        },
                        style: "body3",
                        color: "subtle",
                        children: stepData === null || stepData === void 0 ? void 0 : stepData.currentStep.description
                    }),
                    !transactionError ? /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                        css: {
                            width: "100%",
                            justifyContent: "center"
                        },
                        disabled: true,
                        children: "Waiting for Approval..."
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                        css: {
                            width: "100%",
                            justifyContent: "center"
                        },
                        onClick: ()=>setOpen(false),
                        children: "Close"
                    })
                ]
            }),
            batchListStep === BatchListStep.Complete && /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                direction: "column",
                align: "center",
                justify: "center",
                css: {
                    flex: 1,
                    textAlign: "center",
                    p: "$4"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        direction: "column",
                        css: {
                            my: 50
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                css: {
                                    color: "$green10",
                                    mb: 24
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    icon: free_solid_svg_icons/* faCheckCircle */.f8k,
                                    size: "2x"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                style: "h5",
                                children: "Your items have been listed!"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                        css: {
                            width: "100%",
                            justifyContent: "center"
                        },
                        onClick: ()=>{
                            setOpen(false);
                            onCloseComplete === null || onCloseComplete === void 0 ? void 0 : onCloseComplete();
                        },
                        children: "Close"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var portfolio_BatchListModal = (BatchListModal);

;// CONCATENATED MODULE: ./components/portfolio/BatchListingsTableHeading.tsx



const BatchListingsTableHeading = (param)=>{
    let { displayQuantity , gridTemplateColumns  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* HeaderRow */.VJ, {
        css: {
            display: "none",
            "@md": {
                display: "grid"
            },
            gridTemplateColumns: gridTemplateColumns,
            position: "sticky",
            top: navbar/* NAVBAR_HEIGHT */.ik,
            backgroundColor: "$neutralBg"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                    style: "subtitle3",
                    color: "subtle",
                    children: "Items"
                })
            }),
            displayQuantity ? /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                    style: "subtitle3",
                    color: "subtle",
                    children: "Quantity"
                })
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                    style: "subtitle3",
                    color: "subtle",
                    children: "Price"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                    style: "subtitle3",
                    color: "subtle",
                    children: "Expiration"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                    style: "subtitle3",
                    color: "subtle",
                    children: "Creator Royalties"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                    style: "subtitle3",
                    color: "subtle",
                    children: "Marketplace Fee"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                    style: "subtitle3",
                    color: "subtle",
                    children: "Profit"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                css: {
                    marginLeft: "auto"
                }
            })
        ]
    });
};

// EXTERNAL MODULE: ./hooks/useOpenseaFees.ts
var useOpenseaFees = __webpack_require__(35312);
;// CONCATENATED MODULE: ./components/portfolio/BatchListingsTableRow.tsx










const MINIMUM_AMOUNT = 0.000001;
const BatchListingsTableRow = (param)=>{
    let { listing , listings , setListings , updateListing , selectedItems , displayQuantity , gridTemplateColumns , isLargeDevice , setSelectedItems , globalExpirationOption , globalPrice , currency , defaultCurrency , selectedMarketplaces  } = param;
    var _listing_token_token, _listing_token_token1, _listing_token_token_collection, _listing_token, _listing_token_token2, _listing_token_token_collection1, _listing_token1, _listing_token_token3, _listing_token_token_collection2, _listing_token2, _listing_token_token4, _listing_token_token5, _listing_token3, _listing_token_ownership, _listing_token_ownership1, _listing_token4, _listing_token_token6, _listing_token_token_collection3, _listing_token_token_collection_floorAskPrice, _listing_token_token_collection_floorAskPrice_amount, _listing_token5, _listing_token_token7, _listing_token_token_collection4, _listing_token_token_collection_floorAskPrice1, _listing_token_token_collection_floorAskPrice_amount1, _listing_token6, _listing_token_token8, _listing_token_token_collection5, _listing_token_token_collection_floorAskPrice2, _listing_token_token_collection_floorAskPrice_amount2;
    const [expirationOption, setExpirationOption] = (0,react.useState)(globalExpirationOption);
    const [price, setPrice] = (0,react.useState)(listing.price);
    const [quantity, setQuantity] = (0,react.useState)(1);
    const [marketplaceFee, setMarketplaceFee] = (0,react.useState)(0);
    const [marketplaceFeePercent, setMarketplaceFeePercent] = (0,react.useState)(0);
    const tokenImage = (0,react.useMemo)(()=>{
        var _listing_token_token;
        return (0,optimizeImage/* default */.Z)((_listing_token_token = listing.token.token) === null || _listing_token_token === void 0 ? void 0 : _listing_token_token.image, 250);
    }, [
        (_listing_token_token = listing.token.token) === null || _listing_token_token === void 0 ? void 0 : _listing_token_token.image
    ]);
    const { addToast  } = (0,react.useContext)(ToastContextProvider/* ToastContext */.u);
    const marketplace = selectedMarketplaces.find((m)=>m.orderbook === listing.orderbook);
    const handleMarketplaceFeeChange = (0,react.useCallback)((marketplaceFee)=>{
        setMarketplaceFee(marketplaceFee);
        const updatedListing = {
            ...listing,
            marketplaceFee: marketplaceFee
        };
        updateListing(updatedListing);
    }, [
        listing,
        updateListing
    ]);
    const removeListing = (0,react.useCallback)((token, orderbook)=>{
        const updatedListings = listings.filter((listing)=>{
            var _listing_token_token, _listing_token_token1;
            return "".concat((_listing_token_token = listing.token.token) === null || _listing_token_token === void 0 ? void 0 : _listing_token_token.contract, ":").concat((_listing_token_token1 = listing.token.token) === null || _listing_token_token1 === void 0 ? void 0 : _listing_token_token1.tokenId) !== token || listing.orderbook !== orderbook;
        });
        // Update selectedItems
        const selectedItemIndex = selectedItems.findIndex((item)=>{
            var _item_token, _item_token1;
            return "".concat(item === null || item === void 0 ? void 0 : (_item_token = item.token) === null || _item_token === void 0 ? void 0 : _item_token.contract, ":").concat(item === null || item === void 0 ? void 0 : (_item_token1 = item.token) === null || _item_token1 === void 0 ? void 0 : _item_token1.tokenId) === token;
        });
        if (selectedItemIndex !== -1 && !updatedListings.some((listing)=>{
            var _listing_token_token, _listing_token_token1;
            return "".concat((_listing_token_token = listing.token.token) === null || _listing_token_token === void 0 ? void 0 : _listing_token_token.contract, ":").concat((_listing_token_token1 = listing.token.token) === null || _listing_token_token1 === void 0 ? void 0 : _listing_token_token1.tokenId) === token;
        })) {
            const updatedSelectedItems = [
                ...selectedItems
            ];
            updatedSelectedItems.splice(selectedItemIndex, 1);
            setSelectedItems(updatedSelectedItems);
        }
        setListings(updatedListings);
    }, [
        listings
    ]);
    let openseaFees = (0,useOpenseaFees/* default */.Z)(listing.orderbook == "opensea" ? (_listing_token_token1 = listing.token.token) === null || _listing_token_token1 === void 0 ? void 0 : (_listing_token_token_collection = _listing_token_token1.collection) === null || _listing_token_token_collection === void 0 ? void 0 : _listing_token_token_collection.id : undefined);
    (0,react.useEffect)(()=>{
        if (openseaFees && openseaFees.fee && openseaFees.fee.bps && listing.orderbook == "opensea") {
            // Remove listing and emit toast if listing not enabled
            if (!openseaFees.listingEnabled) {
                var _listing_token_token, _listing_token_token1, _listing_token_token2;
                addToast === null || addToast === void 0 ? void 0 : addToast({
                    title: "Listing not enabled",
                    description: "Cannnot list ".concat((_listing_token_token = listing.token.token) === null || _listing_token_token === void 0 ? void 0 : _listing_token_token.name, " on OpenSea")
                });
                removeListing("".concat((_listing_token_token1 = listing.token.token) === null || _listing_token_token1 === void 0 ? void 0 : _listing_token_token1.contract, ":").concat((_listing_token_token2 = listing.token.token) === null || _listing_token_token2 === void 0 ? void 0 : _listing_token_token2.tokenId), listing.orderbook);
            }
            setMarketplaceFeePercent(openseaFees.fee.bps / 100 || 0);
            handleMarketplaceFeeChange(openseaFees.fee.bps / 10000 * Number(price) * listing.quantity || 0);
        }
    }, [
        openseaFees,
        price,
        quantity,
        marketplace
    ]);
    const creatorRoyalties = ((listing === null || listing === void 0 ? void 0 : (_listing_token = listing.token) === null || _listing_token === void 0 ? void 0 : (_listing_token_token2 = _listing_token.token) === null || _listing_token_token2 === void 0 ? void 0 : (_listing_token_token_collection1 = _listing_token_token2.collection) === null || _listing_token_token_collection1 === void 0 ? void 0 : _listing_token_token_collection1.royaltiesBps) || 0) / 10000;
    const profit = Number(price) * listing.quantity - marketplaceFee - creatorRoyalties * Number(price) * listing.quantity;
    const topTraitPrice = (0,react.useMemo)(()=>{
        var _listing_token_token;
        if (!((_listing_token_token = listing.token.token) === null || _listing_token_token === void 0 ? void 0 : _listing_token_token.attributes)) return undefined;
        var _attribute_floorAskPrice;
        // Find the highest floor price
        return Math.max(...listing.token.token.attributes.map((attribute)=>(_attribute_floorAskPrice = attribute.floorAskPrice) !== null && _attribute_floorAskPrice !== void 0 ? _attribute_floorAskPrice : 0));
    }, []);
    (0,react.useEffect)(()=>{
        handlePriceChange(globalPrice);
    }, [
        globalPrice
    ]);
    (0,react.useEffect)(()=>{
        if (listing.price != price && Number(listing.price) != 0) {
            handlePriceChange(listing.price);
        }
    }, [
        listing.price
    ]);
    (0,react.useEffect)(()=>{
        handleExpirationChange(globalExpirationOption.value);
    }, [
        globalExpirationOption
    ]);
    const handleExpirationChange = (0,react.useCallback)((value)=>{
        const option = defaultExpirationOptions.find((option)=>option.value === value);
        if (option) {
            setExpirationOption(option);
            const updatedListing = {
                ...listing,
                expirationOption: option
            };
            updateListing(updatedListing);
        }
    }, [
        listing,
        updateListing
    ]);
    const handlePriceChange = (0,react.useCallback)((value)=>{
        setPrice(value);
        const updatedListing = {
            ...listing,
            price: value
        };
        updateListing(updatedListing);
    }, [
        listing,
        updateListing
    ]);
    const handleQuantityChange = (0,react.useCallback)((quantity)=>{
        setQuantity(quantity);
        const updatedListing = {
            ...listing,
            quantity: quantity
        };
        updateListing(updatedListing);
    }, [
        listing,
        updateListing
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* TableRow */.SC, {
        css: {
            gridTemplateColumns: gridTemplateColumns,
            alignItems: "stretch",
            py: "$2",
            "&:last-child": {
                borderBottom: "none"
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                css: {
                    overflow: "hidden",
                    minWidth: 0
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                    align: "center",
                    css: {
                        gap: "$3"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: marketplace === null || marketplace === void 0 ? void 0 : marketplace.imageUrl,
                            alt: marketplace === null || marketplace === void 0 ? void 0 : marketplace.name,
                            style: {
                                width: 32,
                                height: 32,
                                borderRadius: 4,
                                aspectRatio: "1/1",
                                visibility: (marketplace === null || marketplace === void 0 ? void 0 : marketplace.imageUrl) ? "visible" : "hidden"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: tokenImage,
                            style: {
                                width: 48,
                                height: 48,
                                borderRadius: 4,
                                aspectRatio: "1/1"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                            direction: "column",
                            css: {
                                minWidth: 0
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                    style: "subtitle3",
                                    color: "subtle",
                                    ellipsify: true,
                                    children: listing === null || listing === void 0 ? void 0 : (_listing_token1 = listing.token) === null || _listing_token1 === void 0 ? void 0 : (_listing_token_token3 = _listing_token1.token) === null || _listing_token_token3 === void 0 ? void 0 : (_listing_token_token_collection2 = _listing_token_token3.collection) === null || _listing_token_token_collection2 === void 0 ? void 0 : _listing_token_token_collection2.name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Text */.xv, {
                                    ellipsify: true,
                                    children: [
                                        "#",
                                        listing === null || listing === void 0 ? void 0 : (_listing_token2 = listing.token) === null || _listing_token2 === void 0 ? void 0 : (_listing_token_token4 = _listing_token2.token) === null || _listing_token_token4 === void 0 ? void 0 : _listing_token_token4.tokenId
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            displayQuantity ? /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                css: {
                    minWith: 0,
                    overflow: "hidden"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                    direction: "column",
                    align: "start",
                    css: {
                        gap: "$2",
                        minWidth: 0,
                        overflow: "hidden"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Input */.II, {
                            type: "number",
                            value: quantity,
                            onChange: (e)=>{
                                var _listing_token_ownership;
                                const inputValue = Number(e.target.value);
                                const max = Number((_listing_token_ownership = listing.token.ownership) === null || _listing_token_ownership === void 0 ? void 0 : _listing_token_ownership.tokenCount);
                                if (e.target.value === "") {
                                    setQuantity(undefined);
                                } else if (inputValue > max) {
                                    handleQuantityChange(max);
                                } else {
                                    handleQuantityChange(inputValue);
                                }
                            },
                            onBlur: ()=>{
                                if (quantity === undefined || quantity <= 0) {
                                    handleQuantityChange(1);
                                }
                            },
                            css: {
                                maxWidth: 45
                            },
                            disabled: ((_listing_token_token5 = listing.token.token) === null || _listing_token_token5 === void 0 ? void 0 : _listing_token_token5.kind) !== "erc1155" || Number(listing === null || listing === void 0 ? void 0 : (_listing_token3 = listing.token) === null || _listing_token3 === void 0 ? void 0 : (_listing_token_ownership = _listing_token3.ownership) === null || _listing_token_ownership === void 0 ? void 0 : _listing_token_ownership.tokenCount) <= 1
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Text */.xv, {
                            style: "subtitle3",
                            color: "subtle",
                            ellipsify: true,
                            css: {
                                width: "100%"
                            },
                            children: [
                                (_listing_token_ownership1 = listing.token.ownership) === null || _listing_token_ownership1 === void 0 ? void 0 : _listing_token_ownership1.tokenCount,
                                " available"
                            ]
                        })
                    ]
                })
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                    align: "start",
                    css: {
                        gap: "$3"
                    },
                    children: [
                        isLargeDevice ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                    direction: "column",
                                    align: "center",
                                    css: {
                                        gap: "$2"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                                            color: "gray3",
                                            corners: "pill",
                                            size: "large",
                                            css: {
                                                minWidth: "max-content",
                                                minHeight: 48,
                                                py: 14
                                            },
                                            disabled: !((_listing_token4 = listing.token) === null || _listing_token4 === void 0 ? void 0 : (_listing_token_token6 = _listing_token4.token) === null || _listing_token_token6 === void 0 ? void 0 : (_listing_token_token_collection3 = _listing_token_token6.collection) === null || _listing_token_token_collection3 === void 0 ? void 0 : (_listing_token_token_collection_floorAskPrice = _listing_token_token_collection3.floorAskPrice) === null || _listing_token_token_collection_floorAskPrice === void 0 ? void 0 : (_listing_token_token_collection_floorAskPrice_amount = _listing_token_token_collection_floorAskPrice.amount) === null || _listing_token_token_collection_floorAskPrice_amount === void 0 ? void 0 : _listing_token_token_collection_floorAskPrice_amount.native),
                                            onClick: ()=>{
                                                var _listing_token, _listing_token_token, _listing_token_token_collection, _listing_token_token_collection_floorAskPrice, _listing_token_token_collection_floorAskPrice_amount;
                                                if ((_listing_token = listing.token) === null || _listing_token === void 0 ? void 0 : (_listing_token_token = _listing_token.token) === null || _listing_token_token === void 0 ? void 0 : (_listing_token_token_collection = _listing_token_token.collection) === null || _listing_token_token_collection === void 0 ? void 0 : (_listing_token_token_collection_floorAskPrice = _listing_token_token_collection.floorAskPrice) === null || _listing_token_token_collection_floorAskPrice === void 0 ? void 0 : (_listing_token_token_collection_floorAskPrice_amount = _listing_token_token_collection_floorAskPrice.amount) === null || _listing_token_token_collection_floorAskPrice_amount === void 0 ? void 0 : _listing_token_token_collection_floorAskPrice_amount.native) {
                                                    var _listing_token1, _listing_token_token1, _listing_token_token_collection1, _listing_token_token_collection_floorAskPrice1, _listing_token_token_collection_floorAskPrice_amount1, _listing_token_token_collection_floorAskPrice_amount_native;
                                                    handlePriceChange((_listing_token1 = listing.token) === null || _listing_token1 === void 0 ? void 0 : (_listing_token_token1 = _listing_token1.token) === null || _listing_token_token1 === void 0 ? void 0 : (_listing_token_token_collection1 = _listing_token_token1.collection) === null || _listing_token_token_collection1 === void 0 ? void 0 : (_listing_token_token_collection_floorAskPrice1 = _listing_token_token_collection1.floorAskPrice) === null || _listing_token_token_collection_floorAskPrice1 === void 0 ? void 0 : (_listing_token_token_collection_floorAskPrice_amount1 = _listing_token_token_collection_floorAskPrice1.amount) === null || _listing_token_token_collection_floorAskPrice_amount1 === void 0 ? void 0 : (_listing_token_token_collection_floorAskPrice_amount_native = _listing_token_token_collection_floorAskPrice_amount1.native) === null || _listing_token_token_collection_floorAskPrice_amount_native === void 0 ? void 0 : _listing_token_token_collection_floorAskPrice_amount_native.toString());
                                                }
                                            },
                                            children: "Floor"
                                        }),
                                        ((_listing_token5 = listing.token) === null || _listing_token5 === void 0 ? void 0 : (_listing_token_token7 = _listing_token5.token) === null || _listing_token_token7 === void 0 ? void 0 : (_listing_token_token_collection4 = _listing_token_token7.collection) === null || _listing_token_token_collection4 === void 0 ? void 0 : (_listing_token_token_collection_floorAskPrice1 = _listing_token_token_collection4.floorAskPrice) === null || _listing_token_token_collection_floorAskPrice1 === void 0 ? void 0 : (_listing_token_token_collection_floorAskPrice_amount1 = _listing_token_token_collection_floorAskPrice1.amount) === null || _listing_token_token_collection_floorAskPrice_amount1 === void 0 ? void 0 : _listing_token_token_collection_floorAskPrice_amount1.native) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                            style: "subtitle3",
                                            color: "subtle",
                                            children: "".concat((_listing_token6 = listing.token) === null || _listing_token6 === void 0 ? void 0 : (_listing_token_token8 = _listing_token6.token) === null || _listing_token_token8 === void 0 ? void 0 : (_listing_token_token_collection5 = _listing_token_token8.collection) === null || _listing_token_token_collection5 === void 0 ? void 0 : (_listing_token_token_collection_floorAskPrice2 = _listing_token_token_collection5.floorAskPrice) === null || _listing_token_token_collection_floorAskPrice2 === void 0 ? void 0 : (_listing_token_token_collection_floorAskPrice_amount2 = _listing_token_token_collection_floorAskPrice2.amount) === null || _listing_token_token_collection_floorAskPrice_amount2 === void 0 ? void 0 : _listing_token_token_collection_floorAskPrice_amount2.native, " ").concat(defaultCurrency.symbol)
                                        }) : null
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                    direction: "column",
                                    align: "center",
                                    css: {
                                        gap: "$2"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                                            color: "gray3",
                                            corners: "pill",
                                            size: "large",
                                            css: {
                                                minWidth: "max-content",
                                                minHeight: 48,
                                                py: 14
                                            },
                                            onClick: ()=>handlePriceChange(topTraitPrice.toString()),
                                            disabled: !topTraitPrice || topTraitPrice <= 0,
                                            children: "Top Trait"
                                        }),
                                        topTraitPrice && topTraitPrice > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Text */.xv, {
                                            style: "subtitle3",
                                            color: "subtle",
                                            children: [
                                                topTraitPrice,
                                                " ",
                                                defaultCurrency.symbol
                                            ]
                                        }) : null
                                    ]
                                })
                            ]
                        }) : null,
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                            align: "start",
                            css: {
                                gap: "$3"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                    align: "center",
                                    css: {
                                        mt: 12
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CryptoCurrencyIcon/* default */.Z, {
                                            address: currency.contract,
                                            css: {
                                                height: 18
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                            style: "subtitle1",
                                            color: "subtle",
                                            css: {
                                                ml: "$1"
                                            },
                                            children: currency.symbol
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                    direction: "column",
                                    align: "center",
                                    css: {
                                        gap: "$2"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Input */.II, {
                                            placeholder: "Price",
                                            type: "number",
                                            value: price,
                                            onChange: (e)=>{
                                                handlePriceChange(e.target.value);
                                            },
                                            css: {
                                                width: 100,
                                                "@bp1500": {
                                                    width: 150
                                                }
                                            }
                                        }),
                                        price !== undefined && price !== "" && Number(price) !== 0 && Number(price) < MINIMUM_AMOUNT && /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Text */.xv, {
                                            style: "subtitle3",
                                            color: "error",
                                            children: [
                                                "Must exceed ",
                                                MINIMUM_AMOUNT
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Select */.Ph, {
                    css: {
                        flex: 1,
                        width: "100%",
                        whiteSpace: "nowrap"
                    },
                    value: (expirationOption === null || expirationOption === void 0 ? void 0 : expirationOption.text) || "",
                    onValueChange: handleExpirationChange,
                    children: defaultExpirationOptions.map((option)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Select.Item */.Ph.Item, {
                            value: option.value,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Select.ItemText */.Ph.ItemText, {
                                css: {
                                    whiteSpace: "nowrap"
                                },
                                children: option.text
                            })
                        }, option.text))
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                css: {
                    minWidth: 0,
                    overflow: "hidden"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                    align: "center",
                    css: {
                        gap: "$2",
                        minWidth: 0,
                        width: "100%",
                        boxSizing: "border-box",
                        mt: "$3"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                            amount: creatorRoyalties * Number(price),
                            logoHeight: 14,
                            textStyle: "body1",
                            css: {
                                width: "100%"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Text */.xv, {
                            style: "body1",
                            color: "subtle",
                            ellipsify: true,
                            children: [
                                "(",
                                creatorRoyalties * 100,
                                ")%"
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                css: {
                    minWidth: 0,
                    overflow: "hidden"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                    align: "center",
                    css: {
                        gap: "$2",
                        mt: "$3"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                            amount: marketplaceFee,
                            logoHeight: 14,
                            textStyle: "body1"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Text */.xv, {
                            style: "body1",
                            color: "subtle",
                            ellipsify: true,
                            children: [
                                "(",
                                marketplaceFeePercent || 0,
                                ")%"
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                css: {
                    minWidth: 0,
                    overflow: "hidden"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                    css: {
                        mt: "$3"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                        amount: profit,
                        logoHeight: 14,
                        textStyle: "body1"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                css: {
                    marginLeft: "auto"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                    color: "gray3",
                    size: "small",
                    css: {
                        justifyContent: "center",
                        width: "44px",
                        height: "44px"
                    },
                    onClick: ()=>{
                        var _listing_token_token, _listing_token_token1;
                        return removeListing("".concat((_listing_token_token = listing.token.token) === null || _listing_token_token === void 0 ? void 0 : _listing_token_token.contract, ":").concat((_listing_token_token1 = listing.token.token) === null || _listing_token_token1 === void 0 ? void 0 : _listing_token_token1.tokenId), listing.orderbook);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                        icon: free_solid_svg_icons/* faTrash */.$aW
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/portfolio/BatchListings.tsx












const BatchListings_MINIMUM_AMOUNT = 0.000001;
const marketplaces = [
    {
        name: "SeaPort",
        imageUrl: "/seaport-source-icon.png",
        orderbook: "reservoir",
        orderKind: "seaport-v1.4"
    },
    {
        name: "OpenSea",
        imageUrl: "https://api.reservoir.tools/redirect/sources/opensea/logo/v2",
        orderbook: "opensea",
        orderKind: "seaport-v1.4"
    }
];
const BatchListings = (param)=>{
    let { selectedItems , setSelectedItems , setShowListingPage  } = param;
    const [listings, setListings] = (0,react.useState)([]);
    const [selectedMarketplaces, setSelectedMarketplaces] = (0,react.useState)([
        marketplaces[0]
    ]);
    const [globalPrice, setGlobalPrice] = (0,react.useState)("");
    const [globalExpirationOption, setGlobalExpirationOption] = (0,react.useState)(defaultExpirationOptions[5]);
    const [totalProfit, setTotalProfit] = (0,react.useState)(0);
    const [listButtonDisabled, setListButtonDisabled] = (0,react.useState)(true);
    const isLargeDevice = (0,react_responsive.useMediaQuery)({
        minWidth: 1400
    });
    const chain = (0,hooks/* useMarketplaceChain */.gw)();
    const chainCurrency = (0,hooks/* useChainCurrency */.D5)();
    const defaultCurrency = {
        contract: chainCurrency.address,
        symbol: chainCurrency.symbol
    };
    const currencies = chain.listingCurrencies;
    const [currency, setCurrency] = (0,react.useState)(currencies && currencies[0] ? currencies[0] : defaultCurrency);
    const displayQuantity = (0,react.useCallback)(()=>{
        return listings.some((listing)=>{
            var _listing_token, _listing_token_token;
            return (listing === null || listing === void 0 ? void 0 : (_listing_token = listing.token) === null || _listing_token === void 0 ? void 0 : (_listing_token_token = _listing_token.token) === null || _listing_token_token === void 0 ? void 0 : _listing_token_token.kind) === "erc1155";
        });
    }, [
        listings
    ]);
    let gridTemplateColumns = displayQuantity() ? isLargeDevice ? "1.1fr .5fr 2.6fr .8fr repeat(2, .7fr) .5fr .3fr" : "1.3fr .6fr 1.6fr 1fr repeat(2, .9fr) .6fr .3fr" : isLargeDevice ? "1.1fr 2.7fr 1fr repeat(2, .7fr) .5fr .3fr" : "1.3fr 1.8fr 1.2fr repeat(2, .9fr) .6fr .3fr";
    const generateListings = (0,react.useCallback)(()=>{
        const listings = selectedItems.flatMap((item)=>{
            return selectedMarketplaces.map((marketplace)=>{
                const listing = {
                    token: item,
                    quantity: 1,
                    price: globalPrice || "0",
                    expirationOption: globalExpirationOption,
                    //@ts-ignore
                    orderbook: marketplace.orderbook,
                    //@ts-ignore
                    orderKind: marketplace.orderKind
                };
                return listing;
            });
        });
        return listings;
    }, [
        selectedItems,
        selectedMarketplaces
    ]);
    (0,react.useEffect)(()=>{
        setListings(generateListings());
    }, [
        selectedItems,
        selectedMarketplaces,
        generateListings
    ]);
    (0,react.useEffect)(()=>{
        const maxProfit = selectedItems.reduce((total, item)=>{
            var _item_token, _item_token1;
            const itemId = "".concat((_item_token = item.token) === null || _item_token === void 0 ? void 0 : _item_token.contract, ":").concat((_item_token1 = item.token) === null || _item_token1 === void 0 ? void 0 : _item_token1.tokenId);
            const itemListings = listings.filter((listing)=>{
                var _listing_token_token, _listing_token_token1;
                return "".concat((_listing_token_token = listing.token.token) === null || _listing_token_token === void 0 ? void 0 : _listing_token_token.contract, ":").concat((_listing_token_token1 = listing.token.token) === null || _listing_token_token1 === void 0 ? void 0 : _listing_token_token1.tokenId) === itemId;
            });
            const profits = itemListings.map((listing)=>{
                var _listing_token, _listing_token_token, _listing_token_token_collection;
                const listingCreatorRoyalties = Number(listing.price) * listing.quantity * ((listing === null || listing === void 0 ? void 0 : (_listing_token = listing.token) === null || _listing_token === void 0 ? void 0 : (_listing_token_token = _listing_token.token) === null || _listing_token_token === void 0 ? void 0 : (_listing_token_token_collection = _listing_token_token.collection) === null || _listing_token_token_collection === void 0 ? void 0 : _listing_token_token_collection.royaltiesBps) || 0) / 10000;
                const profit = Number(listing.price) * listing.quantity - (listing.marketplaceFee || 0) - listingCreatorRoyalties;
                return profit;
            });
            const highestProfit = Math.max(...profits);
            return total + highestProfit;
        }, 0);
        setTotalProfit(maxProfit);
    }, [
        listings,
        selectedMarketplaces,
        globalPrice
    ]);
    (0,react.useEffect)(()=>{
        const hasInvalidPrice = listings.some((listing)=>listing.price === undefined || listing.price === "" || Number(listing.price) < BatchListings_MINIMUM_AMOUNT);
        setListButtonDisabled(hasInvalidPrice);
    }, [
        listings
    ]);
    const removeMarketplaceListings = (0,react.useCallback)((orderbook)=>{
        let updatedListings = listings.filter((listing)=>listing.orderbook === orderbook);
        setListings(updatedListings);
    }, [
        listings
    ]);
    const addMarketplaceListings = (0,react.useCallback)((orderbook, orderKind)=>{
        setListings((prevListings)=>{
            const updatedListings = [
                ...prevListings
            ];
            selectedItems.forEach((item)=>{
                const existingListingIndex = updatedListings.findIndex((listing)=>listing.token === item && listing.orderbook === orderbook);
                if (existingListingIndex === -1) {
                    const newListing = {
                        token: item,
                        quantity: 1,
                        price: globalPrice || "0",
                        expirationOption: globalExpirationOption,
                        //@ts-ignore
                        orderbook: orderbook,
                        //@ts-ignore
                        orderKind: orderKind
                    };
                    updatedListings.push(newListing);
                }
            });
            return updatedListings;
        });
    }, [
        selectedItems,
        globalPrice,
        globalExpirationOption
    ]);
    const handleMarketplaceSelection = (0,react.useCallback)((marketplace)=>{
        const isSelected = selectedMarketplaces.some((selected)=>selected.orderbook === marketplace.orderbook);
        if (isSelected) {
            setSelectedMarketplaces((prevSelected)=>prevSelected.filter((selected)=>selected.orderbook !== marketplace.orderbook));
            removeMarketplaceListings(marketplace.orderbook);
        } else {
            setSelectedMarketplaces((prevSelected)=>[
                    ...prevSelected,
                    marketplace
                ]);
            addMarketplaceListings(marketplace.orderbook, marketplace.orderKind);
        }
    }, [
        selectedMarketplaces,
        addMarketplaceListings,
        removeMarketplaceListings
    ]);
    const updateListing = (0,react.useCallback)((updatedListing)=>{
        setListings((prevListings)=>{
            return prevListings.map((listing)=>{
                if (listing.token === updatedListing.token && listing.orderbook === updatedListing.orderbook) {
                    return updatedListing;
                }
                return listing;
            });
        });
    }, []);
    const applyFloorPrice = (0,react.useCallback)(()=>{
        setListings((prevListings)=>{
            return prevListings.map((listing)=>{
                var _listing_token_token, _listing_token_token_collection, _listing_token_token_collection_floorAskPrice, _listing_token_token_collection_floorAskPrice_amount;
                if ((_listing_token_token = listing.token.token) === null || _listing_token_token === void 0 ? void 0 : (_listing_token_token_collection = _listing_token_token.collection) === null || _listing_token_token_collection === void 0 ? void 0 : (_listing_token_token_collection_floorAskPrice = _listing_token_token_collection.floorAskPrice) === null || _listing_token_token_collection_floorAskPrice === void 0 ? void 0 : (_listing_token_token_collection_floorAskPrice_amount = _listing_token_token_collection_floorAskPrice.amount) === null || _listing_token_token_collection_floorAskPrice_amount === void 0 ? void 0 : _listing_token_token_collection_floorAskPrice_amount.native) {
                    var _listing_token_token1, _listing_token_token_collection1, _listing_token_token_collection_floorAskPrice1, _listing_token_token_collection_floorAskPrice_amount1;
                    return {
                        ...listing,
                        price: (_listing_token_token1 = listing.token.token) === null || _listing_token_token1 === void 0 ? void 0 : (_listing_token_token_collection1 = _listing_token_token1.collection) === null || _listing_token_token_collection1 === void 0 ? void 0 : (_listing_token_token_collection_floorAskPrice1 = _listing_token_token_collection1.floorAskPrice) === null || _listing_token_token_collection_floorAskPrice1 === void 0 ? void 0 : (_listing_token_token_collection_floorAskPrice_amount1 = _listing_token_token_collection_floorAskPrice1.amount) === null || _listing_token_token_collection_floorAskPrice_amount1 === void 0 ? void 0 : _listing_token_token_collection_floorAskPrice_amount1.native.toString()
                    };
                }
                return listing;
            });
        });
        setCurrency(defaultCurrency);
    }, [
        listings
    ]);
    const applyTopTraitPrice = (0,react.useCallback)(()=>{
        setListings((prevListings)=>{
            return prevListings.map((listing)=>{
                var _listing_token_token;
                if ((_listing_token_token = listing.token.token) === null || _listing_token_token === void 0 ? void 0 : _listing_token_token.attributes) {
                    var _attribute_floorAskPrice;
                    // Find the highest floor price
                    let topTraitPrice = Math.max(...listing.token.token.attributes.map((attribute)=>(_attribute_floorAskPrice = attribute.floorAskPrice) !== null && _attribute_floorAskPrice !== void 0 ? _attribute_floorAskPrice : 0));
                    if (topTraitPrice && topTraitPrice > 0) {
                        return {
                            ...listing,
                            price: topTraitPrice.toString()
                        };
                    }
                }
                return listing;
            });
        });
        setCurrency(defaultCurrency);
    }, [
        listings
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
        direction: "column",
        css: {
            gap: "$5",
            width: "100%"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                align: "center",
                css: {
                    gap: 24
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                        color: "gray3",
                        size: "small",
                        css: {
                            justifyContent: "center",
                            width: "44px",
                            height: "44px"
                        },
                        onClick: ()=>setShowListingPage(false),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                            icon: free_solid_svg_icons/* faChevronLeft */.A35
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                        style: "h4",
                        children: "List for Sale"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                justify: "between",
                css: {
                    border: "1px solid $gray6",
                    borderRadius: 8,
                    p: 24
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        direction: "column",
                        css: {
                            gap: "$3"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                style: "h6",
                                children: "Select Marketplaces"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                                align: "center",
                                css: {
                                    gap: "$3"
                                },
                                children: marketplaces.map((marketplace)=>{
                                    const isSelected = selectedMarketplaces.some((selected)=>selected.orderbook === marketplace.orderbook);
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                        align: "center",
                                        css: {
                                            border: isSelected ? "1px solid $primary7" : "1px solid $gray6",
                                            borderRadius: 8,
                                            gap: "$2",
                                            p: "$3",
                                            cursor: "pointer"
                                        },
                                        onClick: ()=>handleMarketplaceSelection(marketplace),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: marketplace.imageUrl,
                                                alt: marketplace.name,
                                                style: {
                                                    width: 32,
                                                    height: 32
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                style: "subtitle2",
                                                children: marketplace.name
                                            })
                                        ]
                                    }, marketplace.name);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        direction: "column",
                        css: {
                            gap: "$3"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                style: "h6",
                                children: "Apply to All"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                align: "center",
                                css: {
                                    gap: "$5"
                                },
                                children: [
                                    isLargeDevice ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                        align: "center",
                                        css: {
                                            gap: "$3"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                                                color: "gray3",
                                                corners: "pill",
                                                size: "large",
                                                css: {
                                                    minWidth: "max-content"
                                                },
                                                onClick: applyFloorPrice,
                                                children: "Floor"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                                                color: "gray3",
                                                corners: "pill",
                                                size: "large",
                                                css: {
                                                    minWidth: "max-content"
                                                },
                                                onClick: applyTopTraitPrice,
                                                children: "Top Trait"
                                            })
                                        ]
                                    }) : null,
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                        align: "center",
                                        css: {
                                            gap: "$3"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Select */.Ph, {
                                                trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Select.Trigger */.Ph.Trigger, {
                                                    css: {
                                                        width: 130
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Select.Value */.Ph.Value, {
                                                        asChild: true,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                                            align: "center",
                                                            justify: "center",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CryptoCurrencyIcon/* default */.Z, {
                                                                    address: currency.contract,
                                                                    css: {
                                                                        height: 18
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                                    style: "subtitle1",
                                                                    color: "subtle",
                                                                    css: {
                                                                        ml: "$1"
                                                                    },
                                                                    children: currency.symbol
                                                                }),
                                                                currencies && (currencies === null || currencies === void 0 ? void 0 : currencies.length) > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Select.DownIcon */.Ph.DownIcon, {
                                                                    style: {
                                                                        marginLeft: 6
                                                                    }
                                                                }) : null
                                                            ]
                                                        })
                                                    })
                                                }),
                                                value: currency.contract,
                                                onValueChange: (value)=>{
                                                    const option = currencies === null || currencies === void 0 ? void 0 : currencies.find((option)=>option.contract == value);
                                                    if (option) {
                                                        setCurrency(option);
                                                    }
                                                },
                                                children: currencies === null || currencies === void 0 ? void 0 : currencies.map((option)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Select.Item */.Ph.Item, {
                                                        value: option.contract,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Select.ItemText */.Ph.ItemText, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                                                align: "center",
                                                                css: {
                                                                    gap: "$1"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CryptoCurrencyIcon/* default */.Z, {
                                                                        address: option.contract,
                                                                        css: {
                                                                            height: 18
                                                                        }
                                                                    }),
                                                                    option.symbol
                                                                ]
                                                            })
                                                        })
                                                    }, option.contract))
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Input */.II, {
                                                placeholder: "Set Price for All",
                                                type: "number",
                                                value: globalPrice,
                                                onChange: (e)=>{
                                                    setGlobalPrice(e.target.value);
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                                        align: "center",
                                        css: {
                                            gap: "$3"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Select */.Ph, {
                                            css: {
                                                flex: 1,
                                                width: 200
                                            },
                                            value: (globalExpirationOption === null || globalExpirationOption === void 0 ? void 0 : globalExpirationOption.text) || "",
                                            onValueChange: (value)=>{
                                                const option = defaultExpirationOptions.find((option)=>option.value == value);
                                                if (option) {
                                                    setGlobalExpirationOption(option);
                                                }
                                            },
                                            children: defaultExpirationOptions.map((option)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Select.Item */.Ph.Item, {
                                                    value: option.value,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Select.ItemText */.Ph.ItemText, {
                                                        children: option.text
                                                    })
                                                }, option.text))
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            listings.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                direction: "column",
                css: {
                    width: "100%",
                    pb: 37
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BatchListingsTableHeading, {
                        displayQuantity: displayQuantity(),
                        gridTemplateColumns: gridTemplateColumns
                    }),
                    listings.map((listing, i)=>{
                        var _listing_token_token, _listing_token_token_collection, _listing_token_token1;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(BatchListingsTableRow, {
                            listing: listing,
                            listings: listings,
                            setListings: setListings,
                            updateListing: updateListing,
                            setSelectedItems: setSelectedItems,
                            selectedItems: selectedItems,
                            displayQuantity: displayQuantity(),
                            gridTemplateColumns: gridTemplateColumns,
                            isLargeDevice: isLargeDevice,
                            globalExpirationOption: globalExpirationOption,
                            globalPrice: globalPrice,
                            currency: currency,
                            defaultCurrency: defaultCurrency,
                            selectedMarketplaces: selectedMarketplaces
                        }, "".concat((_listing_token_token = listing.token.token) === null || _listing_token_token === void 0 ? void 0 : (_listing_token_token_collection = _listing_token_token.collection) === null || _listing_token_token_collection === void 0 ? void 0 : _listing_token_token_collection.id, ":").concat((_listing_token_token1 = listing.token.token) === null || _listing_token_token1 === void 0 ? void 0 : _listing_token_token1.tokenId, ":").concat(listing.orderbook));
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                        align: "center",
                        justify: "between",
                        css: {
                            position: "fixed",
                            bottom: 0,
                            left: 0,
                            right: 0,
                            px: "$5",
                            py: "$4",
                            borderTop: "1px solid $gray7",
                            backgroundColor: "$neutralBg"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                            align: "center",
                            css: {
                                gap: 24,
                                marginLeft: "auto"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                    style: "body1",
                                    children: "Max Profit"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                                    amount: totalProfit,
                                    logoHeight: 18,
                                    textStyle: "h6",
                                    css: {
                                        width: "max-content"
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(portfolio_BatchListModal, {
                                    listings: listings,
                                    disabled: listButtonDisabled,
                                    currency: currency,
                                    selectedMarketplaces: selectedMarketplaces,
                                    onCloseComplete: ()=>{
                                        setShowListingPage(false);
                                        setSelectedItems([]);
                                        setListings([]);
                                    }
                                })
                            ]
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                direction: "column",
                align: "center",
                css: {
                    py: "$6",
                    gap: "$4",
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                        css: {
                            color: "$gray11"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                            icon: free_solid_svg_icons/* faMagnifyingGlass */.Y$T,
                            size: "2xl"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                        css: {
                            color: "$gray11"
                        },
                        children: "No items selected"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var portfolio_BatchListings = (BatchListings);

// EXTERNAL MODULE: ./node_modules/@radix-ui/react-dropdown-menu/dist/index.module.js + 1 modules
var react_dropdown_menu_dist_index_module = __webpack_require__(84113);
;// CONCATENATED MODULE: ./components/common/PortfolioSortDropdown.tsx








const sortingOptions = [
    "acquiredAt",
    "lastAppraisalValue"
];
const nameForSortingOption = (option, compact)=>{
    switch(option){
        case "acquiredAt":
            return "Recently Acquired";
        case "lastAppraisalValue":
            return "Appraisal Value";
    }
};
const PortfolioSortDropdown = (param)=>{
    let { option , onOptionSelected  } = param;
    var _buttonRef_current;
    const isSmallDevice = (0,react_responsive.useMediaQuery)({
        maxWidth: 905
    });
    const buttonRef = (0,react.useRef)(null);
    var _buttonRef_current_offsetWidth;
    const [sortWidth, setSortWidth] = (0,react.useState)((_buttonRef_current_offsetWidth = (_buttonRef_current = buttonRef.current) === null || _buttonRef_current === void 0 ? void 0 : _buttonRef_current.offsetWidth) !== null && _buttonRef_current_offsetWidth !== void 0 ? _buttonRef_current_offsetWidth : "220px");
    const handleResize = ()=>{
        if (isSmallDevice) {
            var _buttonRef_current, _buttonRef_current1;
            setSortWidth((buttonRef === null || buttonRef === void 0 ? void 0 : (_buttonRef_current = buttonRef.current) === null || _buttonRef_current === void 0 ? void 0 : _buttonRef_current.offsetWidth) ? buttonRef === null || buttonRef === void 0 ? void 0 : (_buttonRef_current1 = buttonRef.current) === null || _buttonRef_current1 === void 0 ? void 0 : _buttonRef_current1.offsetWidth : "220px");
        }
    };
    (0,react.useEffect)(()=>{
        window.addEventListener("resize", handleResize, false);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_dropdown_menu_dist_index_module/* Root */.fC, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_dropdown_menu_dist_index_module/* Trigger */.xz, {
                asChild: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Button */.zx, {
                    color: "gray3",
                    css: {
                        px: "14px",
                        justifyContent: "space-between",
                        width: "100%",
                        height: 48,
                        minWidth: "max-content",
                        maxWidth: 300,
                        "@md": {
                            width: "220px",
                            minWidth: "max-content",
                            px: "$4"
                        }
                    },
                    ref: buttonRef,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                            style: "body1",
                            children: nameForSortingOption(option, false)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                            css: {
                                color: "$gray10",
                                transition: "transform",
                                "[data-state=open] &": {
                                    transform: "rotate(180deg)"
                                }
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                icon: free_solid_svg_icons/* faChevronDown */.ptq,
                                width: 16
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* DropdownMenuContent */.AW, {
                css: {
                    mt: "$2",
                    zIndex: 1000,
                    width: sortWidth,
                    minWidth: "max-content",
                    maxWidth: 300,
                    "@md": {
                        width: "220px",
                        minWidth: "max-content",
                        px: "$4"
                    }
                },
                children: sortingOptions.map((optionItem)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* DropdownMenuItem */.Xi, {
                        css: {
                            py: "$3"
                        },
                        onClick: ()=>onOptionSelected(optionItem),
                        children: nameForSortingOption(optionItem, false)
                    }, optionItem))
            })
        ]
    });
};
/* harmony default export */ var common_PortfolioSortDropdown = (PortfolioSortDropdown);

// EXTERNAL MODULE: ./components/common/ActivityFilters.tsx
var ActivityFilters = __webpack_require__(18733);
// EXTERNAL MODULE: ./components/common/MobileActivityFilters.tsx
var MobileActivityFilters = __webpack_require__(33808);
// EXTERNAL MODULE: ./components/common/ActivityTable.tsx
var ActivityTable = __webpack_require__(31322);
;// CONCATENATED MODULE: ./components/portfolio/UserActivityTable.tsx





const UserActivityTable = (param)=>{
    let { user , activityTypes  } = param;
    let activityQuery = {
        limit: 20,
        types: activityTypes
    };
    const { chain  } = (0,react.useContext)(ChainContextProvider/* ChainContext */.p);
    if (chain.collectionSetId) {
        activityQuery.collectionsSetId = chain.collectionSetId;
    } else if (chain.community) {
        activityQuery.community = chain.community;
    }
    const data = (0,dist_index_module/* useUsersActivity */.uR)(user ? [
        user
    ] : undefined, activityQuery, {
        revalidateOnMount: true,
        fallbackData: []
    });
    (0,react.useEffect)(()=>{
        data.mutate();
        return ()=>{
            data.setSize(1);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivityTable/* ActivityTable */.T, {
        data: data
    });
};

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./components/portfolio/ViewToggle.tsx




const ViewToggle = (param)=>{
    let { itemView , setItemView  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* ToggleGroup */.tX, {
        type: "single",
        value: itemView,
        onValueChange: (value)=>setItemView(value),
        css: {
            flexShrink: 0
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* ToggleGroupItem */.GX, {
                value: "list",
                css: {
                    width: 48,
                    height: 48
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                    css: {
                        color: "$gray12"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                        icon: free_solid_svg_icons/* faList */.Zrf,
                        width: 16,
                        height: 16
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* ToggleGroupItem */.GX, {
                value: "grid",
                css: {
                    width: 48,
                    height: 48
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                    css: {
                        color: "$gray12"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                        icon: free_solid_svg_icons/* faTableCellsLarge */.jJj,
                        width: 16,
                        height: 16
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/react-jazzicon/dist/index.js
var react_jazzicon_dist = __webpack_require__(44111);
var dist_default = /*#__PURE__*/__webpack_require__.n(react_jazzicon_dist);
// EXTERNAL MODULE: ./components/primitives/Avatar.tsx
var Avatar = __webpack_require__(95715);
// EXTERNAL MODULE: ./components/common/CopyText.tsx
var CopyText = __webpack_require__(56373);
;// CONCATENATED MODULE: ./pages/portfolio/[[...address]].tsx


































const IndexPage = ()=>{
    const router = (0,next_router.useRouter)();
    const { address: accountAddress , isConnected  } = (0,dist/* useAccount */.mA)();
    const address = router.query.address ? router.query.address[0] : accountAddress;
    const [tabValue, setTabValue] = (0,react.useState)("items");
    const [itemView, setItemView] = (0,react.useState)("list");
    const [activityTypes, setActivityTypes] = (0,react.useState)([
        "sale"
    ]);
    const [activityFiltersOpen, setActivityFiltersOpen] = (0,react.useState)(true);
    const [tokenFiltersOpen, setTokenFiltersOpen] = (0,react.useState)(true);
    const [filterCollection, setFilterCollection] = (0,react.useState)(undefined);
    const [sortByType, setSortByType] = (0,react.useState)("acquiredAt");
    const isSmallDevice = (0,react_responsive.useMediaQuery)({
        maxWidth: 905
    });
    const isMounted = (0,hooks/* useMounted */.s4)();
    const { addToast  } = (0,react.useContext)(ToastContextProvider/* ToastContext */.u);
    const isOwner = !router.query.address || router.query.address[0] === accountAddress;
    const { avatar: ensAvatar , name: resolvedEnsName , shortAddress  } = (0,hooks/* useENSResolver */.Af)(address);
    let collectionQuery = {
        limit: 100
    };
    const { chain  } = (0,react.useContext)(ChainContextProvider/* ChainContext */.p);
    if (chain.collectionSetId) {
        collectionQuery.collectionsSetId = chain.collectionSetId;
    } else if (chain.community) {
        collectionQuery.community = chain.community;
    }
    const { data: collections , isLoading: collectionsLoading , fetchNextPage  } = (0,dist_index_module/* useUserCollections */.UJ)(address, collectionQuery);
    // Batch listing logic
    const [showListingPage, setShowListingPage] = (0,react.useState)(false);
    const [batchAcceptBidModalOpen, setBatchAcceptBidModalOpen] = (0,react.useState)(false);
    const [selectedItems, setSelectedItems] = (0,react.useState)([]);
    const sellableItems = (0,react.useMemo)(()=>{
        return selectedItems.filter((item)=>{
            var _item_token, _item_token_topBid;
            return ((_item_token = item.token) === null || _item_token === void 0 ? void 0 : (_item_token_topBid = _item_token.topBid) === null || _item_token_topBid === void 0 ? void 0 : _item_token_topBid.id) !== null;
        }).map((item)=>{
            var _item_token, _item_token1, _item_token_collection;
            return {
                tokenId: (_item_token = item.token) === null || _item_token === void 0 ? void 0 : _item_token.tokenId,
                collectionId: (_item_token1 = item.token) === null || _item_token1 === void 0 ? void 0 : (_item_token_collection = _item_token1.collection) === null || _item_token_collection === void 0 ? void 0 : _item_token_collection.id
            };
        });
    }, [
        selectedItems
    ]);
    const tokenTableRef = (0,react.useRef)(null);
    (0,react.useEffect)(()=>{
        setSelectedItems([]);
    }, [
        chain
    ]);
    (0,react.useEffect)(()=>{
        setSelectedItems([]);
        setShowListingPage(false);
        setBatchAcceptBidModalOpen(false);
    }, [
        address
    ]);
    (0,react.useEffect)(()=>{
        let tab = tabValue;
        let deeplinkTab = null;
        if (true) {
            const params = new URL(window.location.href).searchParams;
            deeplinkTab = params.get("tab");
        }
        if (deeplinkTab) {
            switch(deeplinkTab){
                case "items":
                    tab = "items";
                    break;
                case "collections":
                    tab = "collections";
                    break;
                case "listings":
                    tab = "listings";
                    break;
                case "offers":
                    tab = "offers";
                    break;
                case "activity":
                    tab = "activity";
                    break;
            }
        }
        setTabValue(tab);
    }, [
        isSmallDevice,
        router.asPath
    ]);
    (0,react.useEffect)(()=>{
        router.query.tab = tabValue;
        router.push(router, undefined, {
            shallow: true
        });
    }, [
        tabValue
    ]);
    if (!isMounted) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                        direction: "column",
                        css: {
                            px: "$4",
                            py: 40,
                            "@sm": {
                                px: "$5"
                            }
                        },
                        children: !isOwner || isConnected ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: showListingPage && !isSmallDevice ? /*#__PURE__*/ (0,jsx_runtime.jsx)(portfolio_BatchListings, {
                                selectedItems: selectedItems,
                                setSelectedItems: setSelectedItems,
                                setShowListingPage: setShowListingPage
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                        align: "center",
                                        justify: "between",
                                        css: {
                                            gap: "$4",
                                            flexDirection: "column",
                                            alignItems: "start",
                                            "@sm": {
                                                flexDirection: "row",
                                                alignItems: "center"
                                            }
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                                align: "center",
                                                children: [
                                                    ensAvatar ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* Avatar */.q, {
                                                        size: "xxl",
                                                        src: ensAvatar
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((dist_default()), {
                                                        diameter: 64,
                                                        paperStyles: {
                                                            borderRadius: "8px"
                                                        },
                                                        seed: (0,react_jazzicon_dist.jsNumberForAddress)(address)
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                                        direction: "column",
                                                        css: {
                                                            ml: "$4"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                                style: "h5",
                                                                children: resolvedEnsName ? resolvedEnsName : shortAddress
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CopyText/* default */.Z, {
                                                                text: address,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                                                    align: "center",
                                                                    css: {
                                                                        cursor: "pointer"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                                            style: "subtitle1",
                                                                            color: "subtle",
                                                                            css: {
                                                                                mr: "$3"
                                                                            },
                                                                            children: shortAddress
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                                                            css: {
                                                                                color: "$gray10"
                                                                            },
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                                                icon: free_solid_svg_icons/* faCopy */.kZ_,
                                                                                width: 16,
                                                                                height: 16
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChainToggle/* default */.Z, {})
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_module/* Root */.fC, {
                                        defaultValue: "items",
                                        value: tabValue,
                                        onValueChange: (value)=>setTabValue(value),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                                                css: {
                                                    overflowX: "scroll",
                                                    "@sm": {
                                                        overflowX: "auto"
                                                    }
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tab/* TabsList */.dr, {
                                                    style: {
                                                        whiteSpace: "nowrap",
                                                        width: "100%"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* TabsTrigger */.SP, {
                                                            value: "items",
                                                            children: "Items"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* TabsTrigger */.SP, {
                                                            value: "listings",
                                                            children: "Listings"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* TabsTrigger */.SP, {
                                                            value: "offers",
                                                            children: "Offers Made"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* TabsTrigger */.SP, {
                                                            value: "activity",
                                                            children: "Activity"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* TabsContent */.nU, {
                                                value: "items",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                                    css: {
                                                        gap: tokenFiltersOpen ? "$5" : "0",
                                                        position: "relative",
                                                        pb: 37
                                                    },
                                                    children: [
                                                        isSmallDevice ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileTokenFilters, {
                                                            collections: collections,
                                                            filterCollection: filterCollection,
                                                            setFilterCollection: setFilterCollection,
                                                            loadMoreCollections: fetchNextPage
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenFilters, {
                                                            isLoading: collectionsLoading,
                                                            isOwner: isOwner,
                                                            open: tokenFiltersOpen,
                                                            setOpen: setTokenFiltersOpen,
                                                            collections: collections,
                                                            filterCollection: filterCollection,
                                                            setFilterCollection: setFilterCollection,
                                                            loadMoreCollections: fetchNextPage
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Box */.xu, {
                                                            css: {
                                                                flex: 1,
                                                                maxWidth: "100%"
                                                            },
                                                            children: [
                                                                isSmallDevice && /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                                                    justify: "between",
                                                                    css: {
                                                                        gap: "$3"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(common_PortfolioSortDropdown, {
                                                                            option: sortByType,
                                                                            onOptionSelected: (option)=>{
                                                                                setSortByType(option);
                                                                            }
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewToggle, {
                                                                            itemView: itemView,
                                                                            setItemView: setItemView
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                                                    justify: "between",
                                                                    css: {
                                                                        marginBottom: "$4"
                                                                    },
                                                                    children: [
                                                                        !isSmallDevice && !collectionsLoading && collections.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterButton/* FilterButton */.L, {
                                                                            open: tokenFiltersOpen,
                                                                            setOpen: setTokenFiltersOpen
                                                                        }),
                                                                        !isSmallDevice && !collectionsLoading && /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                                                            align: "center",
                                                                            justify: "between",
                                                                            css: {
                                                                                gap: "$3"
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(common_PortfolioSortDropdown, {
                                                                                    option: sortByType,
                                                                                    onOptionSelected: (option)=>{
                                                                                        setSortByType(option);
                                                                                    }
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewToggle, {
                                                                                    itemView: itemView,
                                                                                    setItemView: setItemView
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenTable, {
                                                                    ref: tokenTableRef,
                                                                    isLoading: collectionsLoading,
                                                                    address: address,
                                                                    filterCollection: filterCollection,
                                                                    sortBy: sortByType,
                                                                    selectedItems: selectedItems,
                                                                    setSelectedItems: setSelectedItems,
                                                                    isOwner: isOwner,
                                                                    itemView: itemView
                                                                })
                                                            ]
                                                        }),
                                                        !isSmallDevice && /*#__PURE__*/ (0,jsx_runtime.jsx)(portfolio_BatchActionsFooter, {
                                                            selectedItems: selectedItems,
                                                            setSelectedItems: setSelectedItems,
                                                            setShowListingPage: setShowListingPage,
                                                            setOpenAcceptBidModal: setBatchAcceptBidModalOpen,
                                                            isOwner: isOwner
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* TabsContent */.nU, {
                                                value: "listings",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListingsTable, {
                                                    address: address,
                                                    isOwner: isOwner
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* TabsContent */.nU, {
                                                value: "offers",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OffersTable, {
                                                    address: address,
                                                    isOwner: isOwner
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* TabsContent */.nU, {
                                                value: "activity",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                                    css: {
                                                        gap: activityFiltersOpen ? "$5" : "",
                                                        position: "relative"
                                                    },
                                                    children: [
                                                        !isSmallDevice && /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivityFilters/* ActivityFilters */.Y, {
                                                            open: activityFiltersOpen,
                                                            setOpen: setActivityFiltersOpen,
                                                            activityTypes: activityTypes,
                                                            setActivityTypes: setActivityTypes
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Box */.xu, {
                                                            css: {
                                                                flex: 1,
                                                                gap: "$4",
                                                                pb: "$5"
                                                            },
                                                            children: [
                                                                isSmallDevice ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileActivityFilters/* MobileActivityFilters */.r, {
                                                                    activityTypes: activityTypes,
                                                                    setActivityTypes: setActivityTypes
                                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterButton/* FilterButton */.L, {
                                                                    open: activityFiltersOpen,
                                                                    setOpen: setActivityFiltersOpen
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UserActivityTable, {
                                                                    user: address,
                                                                    activityTypes: activityTypes
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                            direction: "column",
                            align: "center",
                            css: {
                                mx: "auto",
                                py: "120px",
                                maxWidth: "350px",
                                gap: "$4"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                    style: "h4",
                                    css: {
                                        mb: "$3"
                                    },
                                    children: "Sell your NFT instantly"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                    css: {
                                        color: "$gray11"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: free_solid_svg_icons/* faWallet */.X5K,
                                        size: "2xl"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                    style: "body1",
                                    css: {
                                        color: "$gray11",
                                        textAlign: "center",
                                        mb: "$4"
                                    },
                                    children: "Connect wallet to instant sell your token across all major marketplaces."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectWalletButton/* ConnectWalletButton */.p, {})
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_module/* AcceptBidModal */.wK, {
                        trigger: null,
                        openState: [
                            batchAcceptBidModalOpen,
                            setBatchAcceptBidModalOpen
                        ],
                        tokens: sellableItems,
                        onClose: (data, stepData, currentStep)=>{
                            if (tokenTableRef && currentStep == dist_index_module/* AcceptBidStep.Complete */.h$.Complete) {
                                var _tokenTableRef_current;
                                (_tokenTableRef_current = tokenTableRef.current) === null || _tokenTableRef_current === void 0 ? void 0 : _tokenTableRef_current.mutate();
                                setSelectedItems([]);
                            }
                        },
                        onBidAcceptError: (error)=>{
                            if ((error === null || error === void 0 ? void 0 : error.type) === "price mismatch") {
                                addToast === null || addToast === void 0 ? void 0 : addToast({
                                    title: "Could not accept offer",
                                    description: "Offer was lower than expected."
                                });
                                return;
                            }
                            // Handle user rejection
                            if ((error === null || error === void 0 ? void 0 : error.code) === 4001) {
                                addToast === null || addToast === void 0 ? void 0 : addToast({
                                    title: "User canceled transaction",
                                    description: "You have canceled the transaction."
                                });
                                return;
                            }
                            addToast === null || addToast === void 0 ? void 0 : addToast({
                                title: "Could not accept offer",
                                description: "The transaction was not completed."
                            });
                        }
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var _address_ = (IndexPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7948,3160,3334,1943,6143,3924,9774,2888,179], function() { return __webpack_exec__(13425); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);